import React, { useEffect, useRef, useState } from "react";
import { API_BASE_URL, Assets_URL } from "../../Apicongfig";
import {
  Button,
  Card,
  Modal,
  ProgressBar,
  Spinner,
  Table,
} from "react-bootstrap";
import moment from "moment";
import {
  convertCount2ToSeconds,
  convertTimeTakenToSeconds,
  createStrategyMoment,
  markToFinish,
} from "../../Utils/MeetingFunctions";
import { image_upload_handler_callback, optimizeEditorContent } from "./Chart";
import { MdKeyboardArrowDown, MdOutlineModeEdit } from "react-icons/md";
import ReportStepFile from "./ReportStepFile";
import ParticipantCard from "./CurrentMeeting/components/ParticipantCard";
import { IoArrowBackSharp } from "react-icons/io5";
import {
  formatDate,
  formatTime,
  parseAndFormatDateTime,
  timezoneSymbols,
} from "./GetMeeting/Helpers/functionHelper";
import { FaLocationDot } from "react-icons/fa6";
import { BsPersonWorkspace } from "react-icons/bs";
import { FaExpand, FaPhoneAlt, FaUserCircle } from "react-icons/fa";
import { Tooltip as AntdTooltip, Avatar, Tooltip } from "antd";
import CounterContainer from "./PlayMeeting/components/CounterContainer";
import Spreadsheet from "react-spreadsheet";
import DOMPurify from "dompurify";
import ConfirmationModal from "../../Utils/ConfirmationModal";
import axios from "axios";
import { toast } from "react-toastify";
import ReactToggle from "react-toggle";
import "react-toggle/style.css";
import Select from "react-select";
import ShowIF from "../../Utils/ShowIF";
import { Editor } from "@tinymce/tinymce-react";
import { AiFillDelete } from "react-icons/ai";
import { useCounterContext } from "./context/CounterContext";
import { useNavigate } from "react-router-dom";
import HostCard from "./CurrentMeeting/components/HostCard";
import { useRecording } from "../../../context/RecordingContext";
import DocViewer, { DocViewerRenderers } from "@cyntler/react-doc-viewer";
import StepFile from "./CurrentMeeting/components/StepFile";
import ActiveReportStepCard from "./Report/ActiveReportStepCard";
import SignUp from "../AuthModal/SignUp";
import { useMeetings } from "../../../context/MeetingsContext";
import RecordingErrorModal from "./RecordingErrorModal";
import MeetingDiscussion from "./CurrentMeeting/components/MeetingDiscussion";

const InProgress = ({
  onUploadSuccess,
  meetingData,
  setMeetingData,
  t,
  dropdownRef,
  renderIcon,
  allMeetings,
  meetId,
  selectedTitleOrder,
  toggleDropdown,
  dropdownVisible,
  applyFilter,
  formattedDate,
  convertTo12HourFormat,
  formattedTime,
  formattedEndDate,
  estimateDate,
  estimateTime,
  setEstimateDate,
  setEstimateTime,
  // handleShowSignUp,
  showHostProfile,
  hideHostShow,
  handleHostShow,
  isContentBlurred,
  guideEmails,
  showProfile,
  handleShow,
  hideShow,
  onModalClose,
  isModalOpen,
  setIsModalOpen,
  setCallNow,
  fromTektime,
  setFromTektime,
  meetingFile,
  meetingMessages,
  setMeetingMessages,
  showProgressBar,
  setShowProgressBar,
  progress,
  setProgress,
  setIsUploading
}) => {
  const getTimezoneSymbol = (timezone) => timezoneSymbols[timezone] || timezone;
  const [excelData, setExcelData] = useState(null);
  const [currentStepIndex, setCurrentStepIndex] = useState(0);
  const TINYMCEAPI = process.env.REACT_APP_TINYMCE_API;
  const editorRef = useRef(null);
  const navigate = useNavigate();
  const { setCallApi } = useMeetings();
  const {
    //   meetingData,
    savedTime,
    negativeTimes,
    activeStepIndex,
    setNextActiveStep,
    setPreviousActiveStep,
    stepDelay,
    setStepDelay,
    setDecision,
    decision,

    // const [decision, setDecision] = useState([]);
  } = useCounterContext();
  const { startRecording } = useRecording();
  const [showConfirmationPopup, setShowConfirmationPopup] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [showErrorModal, setShowErrorModal] = useState(false);


  const [showStepContentEditor, setShowStepContentEditor] = useState(false);

  // REACT QUILL EDITORS for Notes and Decisions:
  const [notesEditor, setNotesEditor] = useState({
    value: "",
    showEditor: false,
  });
  const [decisionEditor, setDecisionEditor] = useState({
    value: "",
    showEditor: false,
  });
  const [fileEditor, setFileEditor] = useState({
    value: "",
    showEditor: false,
  });
  const [planDActionEditor, setPlanDActionEditor] = useState({
    showEditor: false,
  });
 
  const isMobile = window.innerWidth <= 768; // You can adjust this breakpoint

  const getMeetingById = async () => {
    const currentTime = new Date();
    const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

    const options = { timeZone: userTimeZone };
    const timeInUserZone = new Date(
      currentTime.toLocaleString("en-US", options)
    );

    const formattedTime = formatTime(timeInUserZone);
    const formattedDate = formatDate(timeInUserZone);

    try {
      const response = await axios.get(
        `${API_BASE_URL}/meetings/${meetId}?current_time=${formattedTime}&current_date=${formattedDate}&timezone=${userTimeZone}`,
        {
          headers: {
            Authorization: `Bearer ${
              sessionStorage.getItem("token") || localStorage.getItem("token")
            }`,
          },
        }
      );
      if (response.status) {
        const meetingData = response.data?.data;
        if (meetingData?.prise_de_notes === "Automatic") {
          setIsAutomatic(true);
        } else {
          setIsAutomatic(false);
        }
        setPreviousSteps(meetingData?.steps);
        setStepNotes(meetingData?.steps?.map((step) => step?.note));
        setDecision(meetingData?.steps?.map((step) => step?.decision));
        setStepData(meetingData?.steps);
        setTableData(meetingData?.plan_d_actions || []);
        setMeetingData(meetingData);
        // setEmailCampaign(meetingData?.email_campaigns);

        const estimate_time = response?.data?.data?.estimate_time;
        const type = response?.data?.data?.type;
        const timezone = response?.data?.data?.timezone;
        if (estimate_time) {
          const formattedDateTime = parseAndFormatDateTime(
            estimate_time,
            type,
            timezone
          );

          setEstimateTime(formattedDateTime.formattedTime);
          setEstimateDate(formattedDateTime.formattedDate);
        }

        return meetingData;
      }
    } catch (error) {
      return null;
    }
  };
  const getMeeting = async () => {
    // Check if any editor is open
    if (
      showStepContentEditor ||
      notesEditor.showEditor ||
      decisionEditor.showEditor ||
      fileEditor.showEditor ||
      planDActionEditor.showEditor
    ) {
      return;
    }
    if (meetingData?.status !== "in_progress") {
      return;
    }

    const currentTime = new Date();
    const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

    const options = { timeZone: userTimeZone };
    const timeInUserZone = new Date(
      currentTime.toLocaleString("en-US", options)
    );

    const formattedTime = formatTime(timeInUserZone);
    const formattedDate = formatDate(timeInUserZone);

    try {
      const response = await axios.get(
        `${API_BASE_URL}/get-meeting/${meetId}?current_time=${formattedTime}&current_date=${formattedDate}&timezone=${userTimeZone}`
      );
      if (response.status) {
        const meetingData = response.data?.data;
        if (meetingData?.prise_de_notes === "Automatic") {
          setIsAutomatic(true);
        } else {
          setIsAutomatic(false);
        }

        setPreviousSteps(meetingData?.steps);
        setStepNotes(meetingData?.steps?.map((step) => step?.note));
        setDecision(meetingData?.steps?.map((step) => step?.decision));
        setStepData(meetingData?.steps);
        setTableData(meetingData?.plan_d_actions || []);
        setMeetingData(meetingData);
        // setEmailCampaign(meetingData?.email_campaigns);

        const estimate_time = response?.data?.data?.estimate_time;
        const type = response?.data?.data?.type;
        const timezone = response?.data?.data?.timezone;
        if (estimate_time) {
          const formattedDateTime = parseAndFormatDateTime(
            estimate_time,
            type,
            timezone
          );

          setEstimateTime(formattedDateTime.formattedTime);
          setEstimateDate(formattedDateTime.formattedDate);
        }

        return meetingData;
      }
    } catch (error) {
      return null;
    }
  };

  useEffect(() => {
    if (meetingData && meetingData?.status === "in_progress") {
      const intervalId = setInterval(() => {
        if (
          !showStepContentEditor &&
          !notesEditor.showEditor &&
          !decisionEditor.showEditor &&
          !fileEditor.showEditor &&
          !planDActionEditor.showEditor
        ) {
          getMeeting();
        }
      }, 30000); // 30 seconds

      return () => clearInterval(intervalId);
    }
  }, [
    meetingData,
    meetId,
    isModalOpen,
    showStepContentEditor,
    notesEditor.showEditor,
    decisionEditor.showEditor,
    fileEditor.showEditor,
    planDActionEditor.showEditor,
  ]);

  useEffect(() => {
    if (meetingData) {
      const index = meetingData?.steps.findIndex(
        (step) => step?.step_status == "in_progress"
      );
      const index2 = meetingData?.steps.find(
        (step) => step?.step_status == "in_progress"
      );

      setCurrentStepIndex(index);
      if (meetingData?.prise_de_notes === "Automatic") {
        setIsAutomatic(true);
      } else {
        setIsAutomatic(false);
      }
    }
  }, [meetingData]);

  useEffect(() => {
    if (currentStepIndex !== -1) {
      if (
        fromTektime &&
        meetingData?.status !== "to_finish" &&
        meetingData?.status !== "todo"
      ) {
        setIsModalOpen(true);
      } else {
        setIsModalOpen(false);
      }
    }
  }, [currentStepIndex, fromTektime, meetingData?.status]);

  // useEffect(() => {
  //   const initiateRecording = async () => {
  //     if (
  //       meetingData?.prise_de_notes === "Automatic" &&
  //       meetingData?.status === "in_progress" &&
  //       meetingData?.location === null
  //     ) {
  //       const hasPermission = await startRecording();
  //       if (!hasPermission) {
  //         setLoading(false);
  //         return; // Stop if recording didn't start
  //       }
  //     }
  //   };

  //   initiateRecording();
  // }, []);

    const handleStartRecording = async () => {
    try {
      // const success = await startRecording();
      // if (!success) {
      //   setErrorMessage("Unknown error starting recording.");
      //   setShowErrorModal(true);
      // }

       const success = await startRecording();
    
    if (success) {
      // Recording started successfully
      if (meetingData?.meet_link) {
        window.open(meetingData.meet_link, "_blank"); // Open meeting link in new tab
      }
    } else {
       setErrorMessage("Unknown error starting recording.");
        setShowErrorModal(true);
    }
    } catch (error) {
      setErrorMessage(error.message || "Failed to start recording.");
      setShowErrorModal(true);
    }
  };

  const handleRetry = async () => {
    setShowErrorModal(false);
    handleStartRecording();
  };

 const starting = async () => {
     
       if (meetingData?.audio_shared) {
      // If audio is already shared, just open the meeting immediately
      if (meetingData?.meet_link) {
        window.open(meetingData.meet_link, "_blank");
      }
    }else{
      
      setShowConfirmationPopup(true);
    }

  };

  // 1. Check if we should initiate recording
  useEffect(() => {
    if (
      meetingData?.prise_de_notes === "Automatic" &&
      meetingData?.status === "in_progress" &&
      meetingData?.location === null
    ) {
      // Show the first confirmation popup
      setShowConfirmationPopup(true);
    }
  }, []);


  const initiateRecording = async () => {
  setShowConfirmationPopup(false); // Close confirmation popup
  setLoading(true);

  try {
    // Try to update audio_shared status but don't block if it fails
    try {
      const payload = {
        audio_shared: true
      };

      await axios.post(`${API_BASE_URL}/meeting-audio-shared/${meetingData?.id}`, payload, {
        headers: {
          'Content-Type': 'application/json', // Changed from multipart/form-data since we're sending JSON
          // 'Authorization': `Bearer ${token}`,
        }
      });
    } catch (apiError) {
      console.warn("Failed to update audio shared status, continuing anyway:", apiError);
      // Continue with recording despite API failure
    }

    // Proceed with recording regardless of API success
    const hasPermission = await startRecording();
    
    if (hasPermission) {
      if (meetingData?.meet_link) {
        window.open(meetingData.meet_link, "_blank");
      }
    } else {
      setLoading(false);
      setErrorMessage("Recording permission denied");
      setShowErrorModal(true);
    }
  } catch (recordingError) {
    setLoading(false);
    setErrorMessage(recordingError.message || "Recording failed");
    setShowErrorModal(true);
  } finally {
    setLoading(false);
  }
};


  const getYoutubeEmbedUrl = (url) => {
    if (!url) {
      return false;
    }
    if (url.includes("youtube.com/watch")) {
      const videoUrl = new URL(url);
      const videoId = videoUrl.searchParams.get("v");

      if (videoId) {
        return `https://www.youtube.com/embed/${videoId}`;
      }
      // Handle the shortened YouTube URL (youtu.be)
    }
    if (url.includes("youtu.be/")) {
      const videoId = url.split("youtu.be/")[1];
      if (videoId) {
        return `https://www.youtube.com/embed/${videoId}`;
      }
    }

    return false; // Return false if it's not a valid YouTube URL
  };
  const sanitizeContent = (content) => {
    if (!content) return null;

    const sanitizedContent = DOMPurify.sanitize(content, {
      ADD_TAGS: [
        "table",
        "tr",
        "td",
        "th",
        "tbody",
        "thead",
        "tfoot",
        "caption",
        "iframe",
      ],
      ADD_ATTR: [
        "allow",
        "allowfullscreen",
        "frameborder",
        "scrolling",
        "src",
        "title",
        "style",
      ],
    });

    // Create a temporary div to hold the sanitized HTML and parse it
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = sanitizedContent;

    // Find all iframe tags within the content
    const iframes = tempDiv.querySelectorAll("iframe");

    // Replace each iframe tag with a link while preserving its surrounding structure
    iframes.forEach((iframe) => {
      const iframeSrc = iframe.getAttribute("src");

      if (iframeSrc) {
        const linkElement = document.createElement("a");
        linkElement.href = iframeSrc;
        linkElement.target = "_blank";

        // Create a more user-friendly link text (optional improvement)
        // linkElement.textContent = `Click here to view the content`;
        linkElement.textContent = iframeSrc;

        // Apply the truncation class to the link element
        linkElement.classList.add("truncated-link");
        // Replace iframe with the link while keeping it inside the parent tag (e.g., table, td)
        iframe.parentNode.replaceChild(linkElement, iframe);
      }
    });

    // Return the updated HTML as a string
    return tempDiv.innerHTML;
  };
  const rawContent =
    meetingData?.steps &&
    Array.isArray(meetingData?.steps) &&
    meetingData?.steps[currentStepIndex] &&
    meetingData?.steps[currentStepIndex]?.editor_content
      ? meetingData?.steps[currentStepIndex].editor_content
      : " ";
  const sanitizedContent = sanitizeContent(rawContent);

  const GradientSvg = (
    <svg height="0px">
      <defs>
        <linearGradient id="your-unique-id" x1="1" y1="0" x2="1" y2="1">
          <stop offset="10%" stopColor="#F2E358" />
          <stop offset="90%" stopColor="#CB690F" />
        </linearGradient>
      </defs>
    </svg>
  );
  const GradientSvg2 = (
    <svg height="0px">
      <defs>
        <linearGradient id="your-unique-id2" x1="1" y1="0" x2="1" y2="1">
          <stop offset="20%" stopColor="#F25861" />
          <stop offset="90%" stopColor="#CB0F1A" />
        </linearGradient>
      </defs>
    </svg>
  );
  const GradientSvg3 = (
    <svg height="0px">
      <defs>
        <linearGradient id="your-unique-id1" x1="1" y1="0" x2="1" y2="1">
          <stop offset="10%" stopColor="#CB0C17" />
          <stop offset="90%" stopColor="#5AAFD6" />
        </linearGradient>
      </defs>
    </svg>
  );

  const sanitizeContent1 = (html) => {
    if (!html) return null;
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, "text/html");

    // Find all iframe elements
    const iframes = doc.querySelectorAll("iframe");

    iframes.forEach((iframe) => {
      const src = iframe.getAttribute("src");
      if (src) {
        // Replace iframe with a link to the source
        const link = doc.createElement("a");
        link.href = src;
        link.target = "_blank";
        link.rel = "noopener noreferrer";
        link.textContent = `${src}`;

        iframe.replaceWith(link);
      }
    });

    return doc.body.innerHTML;
  };

  const sanitizeIframeContent = (content) => {
    if (!content) return null;
    return content.replace(
      /<iframe.*?src="(.*?)".*?<\/iframe>/gi,
      (match, src) => {
        return `<a href="${src}" target="_blank" rel="noopener noreferrer">${src}</a>`;
      }
    );
  };
  // Toggles
  const [iFrameLoad, setIFrameLoad] = useState(true);
  const [loading, setLoading] = useState(true);
  const [tableData, setTableData] = useState([]);
  const [stepNotes, setStepNotes] = useState([]);
  // const [decision, setDecision] = useState([]);
  const [stepData, setStepData] = useState([]);

  const [showNewDecisionModal, setShowNewDecisionModal] = useState(false);
  const [currentDecisionIndex, setCurrentDecisionIndex] = useState(0);

  // Add a new decision for the current step
  const addDecisionForStep = (stepIndex) => {
    const updated = [...decision];
    if (!updated[stepIndex]) updated[stepIndex] = [];
    updated[stepIndex].push({
      decision_type: "",
      decision: "",
      creation_date: "",
      creation_time: "",
      milestone_date: "",
      budget_amount: "",
      currency: "EUR",
      decision_apply: "",
    });
    setDecision(updated);
    setCurrentDecisionIndex(updated[stepIndex].length - 1); // set last added
    setShowNewDecisionModal(true);
  };

  // Handle select changes
  const handleSelectChange = (selectedOption, field, decisionIndex) => {
    const updatedDecision = [...decision];
    const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const currentDateTime = new Date().toLocaleString("en-US", {
      timeZone: userTimeZone,
    });
    const [date, time] = currentDateTime?.split(", ");

    if (!updatedDecision[activeStepIndex]) {
      updatedDecision[activeStepIndex] = [];
    }

    const existingDecision =
      updatedDecision[activeStepIndex][decisionIndex] || {};

    updatedDecision[activeStepIndex][decisionIndex] = {
      ...existingDecision,
      [field]: selectedOption.value,
      creation_date: new Date().toISOString().split("T")[0],
      creation_time: time,
    };

    setDecision(updatedDecision);
  };

  // Handle text changes
  const handleTextChange = (event, decisionIndex) => {
    const updatedDecision = [...decision];
    const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const currentDateTime = new Date().toLocaleString("en-US", {
      timeZone: userTimeZone,
    });
    const [date, time] = currentDateTime?.split(", ");

    if (!updatedDecision[activeStepIndex]) {
      updatedDecision[activeStepIndex] = [];
    }

    const existingDecision =
      updatedDecision[activeStepIndex][decisionIndex] || {};

    updatedDecision[activeStepIndex][decisionIndex] = {
      ...existingDecision,
      decision: event.target.value,
      creation_date: new Date().toISOString().split("T")[0],
      creation_time: time,
    };

    setDecision(updatedDecision);
  };

  const closeDecisionModal = () => {
    setDecision((prev) => {
      const updatedDecision = [...prev];

      if (updatedDecision[activeStepIndex]) {
        const filteredDecisions = updatedDecision[activeStepIndex].filter(
          (d) => {
            // Check if all meaningful fields are empty
            return Object.entries(d).some(
              ([key, value]) =>
                value !== null && value !== undefined && value !== ""
            );
          }
        );

        updatedDecision[activeStepIndex] = filteredDecisions;
      }

      return updatedDecision;
    });

    setShowNewDecisionModal(false); // Close the modal
  };

  const userTeams =
    (meetingData && meetingData?.steps[currentStepIndex]?.user_teams) || [];

  // Dynamically map `userTeams` to the required format
  const teamOptions = userTeams.map((team) => ({
    value: team.team_name, // Use the team_name from the user_teams array
    label: team.team_name, // Same for the label
  }));

  // Combine the static options (Enterprise, Private) with the dynamic options
  const combinedOptions = [
    { value: "Enterprise", label: "Enterprise" },
    { value: "Private", label: "Private" },
    ...teamOptions, // Append dynamic team options here
  ];

  const [clickedToggle, setClickedToggle] = useState(false);
  const [stepNoteEditor, setStepEditor] = useState({
    value: "",
    showEditor: false,
  });
  const [show, setShow] = useState({
    value: "",
    showEditor: false,
  });
  const [isAutomatic, setIsAutomatic] = useState(false);
  const [previousSteps, setPreviousSteps] = useState([]);
  const [myStepNoteId, setMyStepNoteId] = useState(null);
  const [editorContent, setEditorContent] = useState(true);
  const [showSignUp, setShowSignUp] = useState(false);
  const handleShowSignUp = () => {
    setShowSignUp(true);
  };
  const handleCloseSignUp = () => setShowSignUp(false);

 

  // ================>TEXT EDITORS TOGGLE FUNCTIONS: <====================
  const handleDecisionEditorToggle = () => {
    setClickedToggle((prev) => !prev);
    setNotesEditor((prev) => ({ ...prev, showEditor: false })); // Close the notes editor if it's open
    setPlanDActionEditor((prev) => ({ ...prev, showEditor: false })); // Close the notes editor if it's open
    setStepEditor((prev) => ({ ...prev, showEditor: false })); // Close the notes editor if it's open
    setShow((prev) => ({ ...prev, showEditor: false })); // Close the notes editor if it's open
    setFileEditor((prev) => ({ ...prev, showEditor: false })); // Close the notes editor if it's open
    setDecisionEditor((prev) => {
      return {
        ...prev,
        showEditor: !prev.showEditor,
      };
    });
    setShowStepContentEditor(false);
  };

  const handleFileEditor = () => {
    setClickedToggle((prev) => !prev);
    setNotesEditor((prev) => ({ ...prev, showEditor: false })); // Close the notes editor if it's open
    setPlanDActionEditor((prev) => ({ ...prev, showEditor: false })); // Close the notes editor if it's open
    setDecisionEditor((prev) => ({ ...prev, showEditor: false })); // Close the decision editor if it's open
    setStepEditor((prev) => ({ ...prev, showEditor: false })); // Close the notes editor if it's open
    setShow((prev) => ({ ...prev, showEditor: false })); // Close the notes editor if it's open
    setShowStepContentEditor(false);

    setFileEditor((prev) => {
      return {
        ...prev,
        showEditor: !prev.showEditor,
      };
    });
  };

  const handleNotesEditorToggle = () => {
    setClickedToggle((prev) => !prev);
    setFileEditor((prev) => ({ ...prev, showEditor: false })); // Close the notes editor if it's open
    setDecisionEditor((prev) => ({ ...prev, showEditor: false })); // Close the decision editor if it's open
    setPlanDActionEditor((prev) => ({ ...prev, showEditor: false })); // Close the notes editor if it's open
    setStepEditor((prev) => ({ ...prev, showEditor: false })); // Close the step editor if it's open
    setShow((prev) => ({ ...prev, showEditor: false })); // Close the all notes editor if it's open

    setNotesEditor((prev) => {
      return {
        ...prev,
        showEditor: !prev.showEditor,
      };
    });
    setShowStepContentEditor(false);
  };

  // Function to handle eye button click
  const handlePlanDActionEditor = () => {
    setClickedToggle((prev) => !prev);
    setFileEditor((prev) => ({ ...prev, showEditor: false })); // Close the notes editor if it's open
    setDecisionEditor((prev) => ({ ...prev, showEditor: false }));
    setNotesEditor((prev) => ({ ...prev, showEditor: false }));
    setStepEditor((prev) => ({ ...prev, showEditor: false })); // Close step notes editor if it's open
    setShow((prev) => ({ ...prev, showEditor: false })); // Close the all notes editor if it's open
    setPlanDActionEditor((prev) => ({
      ...prev,
      showEditor: !prev.showEditor,
    }));

    // If closing the editor, update entered data
    if (planDActionEditor.showEditor) {
      const enteredDataString = tableData?.map((rowData) => ({
        action: rowData.action,
        action_days: rowData.action_days,
      }));
      // setEnteredData(enteredDataString);
    }
    setShowStepContentEditor(false);
  };
  const handleTableDataChange = (e, index) => {
    const { name, value } = e.target;
    setTableData((prevTableData) =>
      prevTableData?.map((rowData, i) =>
        i === index
          ? {
              ...rowData,
              [name]: value,
              // participant_id: newArray,
              step_id: meetingData?.steps[currentStepIndex].id,
              status: "Todo",
            }
          : rowData
      )
    );
  };

  const [showStrategyModal, setShowStrategyModal] = useState(false);
  const handleButtonClose = () => {
    setShowStrategyModal(false);
    setEditingStrategy(null);
    setTableData([]);
  };
  const handleButtonClick = () => {
    setShowStrategyModal(true);
    if (Array.isArray(tableData) && tableData.length > 0) {
      setTableData([
        ...tableData,
        {
          order: 1,
          action: "",
          action_days: 1,
          participant_id: "",
          step_id: meetingData?.steps[currentStepIndex].id,
          status: "Todo",
        },
      ]);
    } else {
      setTableData([
        {
          order: 1,
          action: "",
          action_days: 1,
          participant_id: "",
          step_id: meetingData?.steps[currentStepIndex].id,
          status: "Todo",
        },
      ]);
    }
  };

  const handleButtonDelete = async (index) => {
    const actionToBeDeleted = tableData[index];
    const id = actionToBeDeleted.id;
    //Send API Call only if the action is already saved in the database.
    const foundInDatabase = actionToBeDeleted.id; // If the action is already saved in the database, it will have an id.
    //----API CALL TO DELETE ACTION
    if (foundInDatabase) {
      try {
        const response = await axios.delete(
          `${API_BASE_URL}/planDactions/${id}`,
          {
            headers: {
              Authorization: `Bearer ${
                sessionStorage.getItem("token") || localStorage.getItem("token")
              }`,
            },
          }
        );
        console.clear();
      } catch (error) {
        console.log("error", error);
        return;
      }
    }

    const updatedTableData = [...tableData];
    updatedTableData.splice(index, 1);
    setTableData(updatedTableData);
  };
  const handleDeleteStrategy = async (strategy) => {
    const id = strategy?.id;

    if (id) {
      try {
        const response = await axios.delete(
          `${API_BASE_URL}/planDactions/${id}`,
          {
            headers: {
              Authorization: `Bearer ${
                sessionStorage.getItem("token") || localStorage.getItem("token")
              }`,
            },
          }
        );
      } catch (error) {
        console.error("Delete error:", error);
        toast.error(error?.response?.data?.message || "server error");
      } finally {
        getMeetingById(); // Refresh the meeting data after deletion
      }
    }

    // Update tableData by filtering out the deleted strategy
    const updatedTableData = tableData.filter((item) => item.id !== id);
    setTableData(updatedTableData);
  };

  const handleIncrementCount = (index) => {
    setTableData((prevTableData) =>
      prevTableData.map((rowData, i) =>
        i === index
          ? {
              ...rowData,
              // action_days: Math.min(parseFloat(rowData.action_days) + 1, 5),
              action_days: Math.min(parseFloat(rowData.action_days) + 1, 100),
            }
          : rowData
      )
    );
  };

  const handleDecrementCount = (index) => {
    setTableData((prevTableData) =>
      prevTableData.map((rowData, i) =>
        i === index
          ? {
              ...rowData,
              action_days: Math.max(parseFloat(rowData.action_days) - 1, 0),
            }
          : rowData
      )
    );
  };

  const handleStepContentEditor = async () => {
    if (showStepContentEditor === true) {
      const optimizedEditorContent = optimizeEditorContent(
        meetingData?.steps[currentStepIndex]?.editor_content
      );
      await saveEditorContent(optimizedEditorContent);
    }
    setFileEditor((prev) => ({ ...prev, showEditor: false })); // Close the notes editor if it's open
    setDecisionEditor((prev) => ({ ...prev, showEditor: false }));
    setNotesEditor((prev) => ({ ...prev, showEditor: false }));
    setPlanDActionEditor((prev) => ({ ...prev, showEditor: false }));
    setStepEditor((prev) => ({ ...prev, showEditor: false })); // Close the step editor if it's open
    setShow((prev) => ({ ...prev, showEditor: false })); // Close the all notes editor if it's open
    setShowStepContentEditor((prev) => !prev);
  };
  const saveEditorContent = async (editorContent) => {
    const _OPTIMIZED_EDITOR_CONTENT = await optimizeEditorContent(
      editorContent
    );
    const stepId = meetingData?.steps[currentStepIndex]?.id;
    const URL = `${API_BASE_URL}/play-meetings/steps/${stepId}`;
    const postData = {
      ...meetingData?.steps[currentStepIndex],
      editor_content: _OPTIMIZED_EDITOR_CONTENT,
    };
    try {
      const token =
        sessionStorage.getItem("token") || localStorage.getItem("token");
      const response = await axios.post(URL, postData, {
        headers: {
          "Content-Type": "application/json",
          Authorization: ` Bearer ${token}`,
        },
      });
      if (response.status) {
        // toast.success(response.data?.message);
        toast.success("Content saved successfully");
      }
    } catch (error) {
      console.log("error", error);
    }
  };

  const [isLoading, setIsLoading] = useState(false);
  const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

  const [isLoadingNext, setIsLoadingNext] = useState(false);
  const next = async () => {
    setIsLoadingNext(true);

    try {
      const currentStep = meetingData?.steps[currentStepIndex];
      const nextStep = meetingData?.steps[currentStepIndex + 1];
      const stepId = currentStep?.id;
      const myNextStepId = nextStep?.id;

      const optimizedEditorContent = await optimizeEditorContent(
        currentStep?.editor_content
      );
      const currentTime = new Date();

      // User's time zone
      const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

      // Format dates and times
      const formattedEndDate = currentTime.toLocaleDateString("en-GB", {
        day: "numeric",
        month: "numeric",
        year: "numeric",
        timeZone: userTimeZone,
      });
      const formattedEndTime = currentTime.toLocaleString("en-GB", {
        timeZone: userTimeZone,
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        hour12: false,
      });
      const formattedCurrentDate = currentTime.toISOString().split("T")[0];

      const options = { timeZone: userTimeZone };
      const timeInUserZone = new Date(
        currentTime.toLocaleString("en-US", options)
      );

      const formattedTime = formatTime(timeInUserZone);
      const formattedDate = formatDate(timeInUserZone);
      const postData = {
        ...currentStep,
        editor_content: optimizedEditorContent || null,
        savedTime:
          currentStep?.savedTime === 0 ? 0 : savedTime != 0 ? savedTime : 0,
        negative_time:
          savedTime === 0
            ? negativeTimes[activeStepIndex] !== 0
              ? negativeTimes[activeStepIndex]
              : 0
            : 0,
        totaldecision: decision.join(" "),
        totalstepnotes: null,
        note: null,
        original_note: null,
        decision: decision[currentStepIndex] || [],
        actions: tableData || [],

        url: currentStep?.url || null,
        meeting_id: meetId,
        status: "completed",
        step_status: "completed",
        end_time: formattedEndTime,
        end_date: formattedEndDate,
        next_step_id: myNextStepId,
        delay: currentStep?.negative_time === "99" ? stepDelay?.delay : null,
        real_time: formattedEndTime,
        real_date: formattedEndDate,
        pause_current_time: formattedTime,
        pause_current_date: formattedDate,
      };

      delete postData?.time_taken;

      const token =
        sessionStorage.getItem("token") || localStorage.getItem("token");

      // Post current step data
      const response = await axios.post(
        `${API_BASE_URL}/play-meetings/steps/${stepId}/step-note-and-action?current_time=${formattedTime}&current_date=${formattedDate}&pause_current_time=${formattedTime}&pause_current_date=${formattedDate}`,
        postData,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.status) {
        //   await getMeetingById();
        setTableData(response?.data?.data?.planDActions);

        const estimate_time = response?.data?.data?.estimate_time;
        const type = response?.data?.data?.type;
        const timezone = response?.data?.data?.timezone;
        if (estimate_time) {
          const formattedDateTime = parseAndFormatDateTime(
            estimate_time,
            type,
            timezone
          );

          setEstimateTime(formattedDateTime.formattedTime);
          setEstimateDate(formattedDateTime.formattedDate);
        }
      }

      // Handle the next step
      if (nextStep) {
        const stepResponse = await axios.get(
          `${API_BASE_URL}/steps/${myNextStepId}`,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          }
        );

        if (stepResponse.status) {
          const nextStepData = stepResponse.data.data;
          const payload = {
            ...nextStepData,
            step_status: "in_progress",
            current_time: nextStep.current_time || formattedEndTime,
            current_date: nextStep.current_date || formattedCurrentDate,
            real_time: formattedEndTime,
            real_date: formattedEndDate,
            pause_current_time: formattedTime,
            pause_current_date: formattedDate,
          };

          delete payload.time_taken;

          const nextStepResponse = await axios.post(
            `${API_BASE_URL}/play-meetings/steps/${myNextStepId}/step-note-and-action?current_time=${formattedTime}&current_date=${formattedDate}&pause_current_time=${formattedTime}&pause_current_date=${formattedDate}`,
            payload,
            {
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
              },
            }
          );

          if (nextStepResponse.status) {
            //   await getMeetingById();
            const nextEstimateTime =
              nextStepResponse?.data?.data?.estimate_time;
            if (nextEstimateTime) {
              const [date, timeWithMilliseconds] = nextEstimateTime.split("T");
              const timeOnly = timeWithMilliseconds.split(".")[0];
              const formattedTime = timeOnly.slice(0, 5).replace(":", "h");

              setEstimateTime(formattedTime);
              setEstimateDate(date);
            }
          }
        }
      }
    } catch (error) {
      console.error("Error in next step processing:", error);
    } finally {
      setIsLoadingNext(false);
      setCurrentStepIndex((prevIndex) => prevIndex + 1);
      setShow((prev) => ({ ...prev, showEditor: false }));
      setNextActiveStep();
      await getMeetingById();
    }
  };

  // useEffect(() => {
  //   let timer;
  //   if (showProgressBar) {
  //     timer = setInterval(() => {
  //       setProgress((prevProgress) =>
  //         prevProgress >= 100 ? 100 : prevProgress + 1
  //       );
  //     }, 100);
  //   }
  //   return () => clearInterval(timer);
  // }, [showProgressBar]);

  const saveEndData = async () => {
    setIsLoading(true);
    const currentStep = meetingData?.steps[currentStepIndex];
    const stepId = currentStep.id;

    const endTime = new Date();
    // Get the user's time zone
    const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    // Convert currentDateTime to a string in the user's local time zone
    const localEndTime = endTime.toLocaleString("en-GB", {
      timeZone: userTimeZone,
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: false,
    });
    // Format end_date to dd/mm/yyyy
    const formatEndDate = (date) => {
      const day = String(date.getUTCDate()).padStart(2, "0");
      const month = String(date.getUTCMonth() + 1).padStart(2, "0"); // Months are zero-based
      const year = date.getUTCFullYear();
      return `${day}/${month}/${year}`;
    };
    const currentTime = new Date();

    const options = { timeZone: userTimeZone };
    const timeInUserZone = new Date(
      currentTime.toLocaleString("en-US", options)
    );

    const formattedTime = formatTime(timeInUserZone);
    const formattedDate = formatDate(timeInUserZone);
    // ..
    const formattedEndDate = formatEndDate(endTime);
    const postData = {
      ...currentStep,
      savedTime: savedTime != 0 ? savedTime : 0,
      negative_time:
        savedTime === 0
          ? negativeTimes[activeStepIndex] !== 0
            ? negativeTimes[activeStepIndex]
            : 0
          : 0,
      totalstepnotes: null,
      note: null,
      original_note: null,
      decision: decision[currentStepIndex] || [],
      actions: tableData ? tableData : [],
      meeting_id: meetId,
      url: meetingData?.steps[currentStepIndex].url
        ? meetingData?.steps[currentStepIndex].url
        : null,
      status: "completed",
      step_status: "completed",
      end_time: localEndTime,
      end_date: formattedEndDate,
      delay: currentStep?.negative_time === "99" ? stepDelay?.delay : null,
      real_time: localEndTime,
      real_date: formattedEndDate,
      pause_current_time: formattedTime,
      pause_current_date: formattedDate,
    };

    try {
      const token =
        sessionStorage.getItem("token") || localStorage.getItem("token");
      const response = await axios.post(
        `${API_BASE_URL}/play-meetings/steps/${stepId}/step-note-and-action?current_time=${formattedTime}&current_date=${formattedDate}&pause_current_time=${formattedTime}&pause_current_date=${formattedDate}`,
        postData,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: ` Bearer ${token}`,
          },
        }
      );
      if (response.status) {
        return response?.data?.data;
      }
    } catch (error) {
      console.log("error", error);
      toast.error(error?.response?.data?.message);
    }
  };

  //auto notes functionality
  const close = async () => {
    const invalidActions = tableData?.filter((action) => !action.action);

    if (invalidActions?.length > 0) {
      toast.error(t("Please fill in all required fields in actions."));
      //   setButtonDisabled(false);
      return; // Prevent API call if validation fails
    }
    // setButtonDisabled(true);
    setIsLoading(true);
    const currentStep = meetingData?.steps[currentStepIndex];
    const stepId = currentStep.id;

    const responseNotes = await saveEndData();
    setIsLoading(true);
        // stopRecording();

    let updatedStepData = [...meetingData?.steps];
    updatedStepData[updatedStepData.length - 1] = responseNotes;

    localStorage.setItem("lastURL", "/play");

    // Parse the start time string
    const [hour, minute] = meetingData?.start_time?.split(":").map(Number);

    // Add one hour to the hour component
    let endHour = hour + 1;

    // If end hour is greater than or equal to 24, subtract 24
    if (endHour >= 24) {
      endHour -= 24;
    }

    // Format the end time as a string
    const endTimeStr = `${String(endHour).padStart(2, "0")}:${String(
      minute
    ).padStart(2, "0")}`;

    const updatedDatWithClosingTime = {
      ...meetingData,
      real_end_time: moment().format("HH:mm:ss"),
      _method: "put",
      status: "closed",
      timezone: userTimeZone,
      plan_d_actions: tableData ? tableData : [],
      steps: updatedStepData?.map(({ assigned_to, ...step }) => ({
        ...step,
        step_status: "completed",
        status: "completed",
      })),
      step_decisions: decision.filter((decision) => decision != ""),
      end_time: endTimeStr,
      moment_privacy_teams:
        meetingData?.moment_privacy === "team" &&
        meetingData?.moment_privacy_teams?.length &&
        typeof meetingData?.moment_privacy_teams[0] === "object"
          ? meetingData?.moment_privacy_teams.map((team) => team.id)
          : meetingData?.moment_privacy_teams || [], // Send as-is if IDs are already present
    };

    try {
      const response = await axios.post(
        `${API_BASE_URL}/public-meetings-update/${meetId}`,
        updatedDatWithClosingTime
        // {
        //   headers: {
        //     Authorization: `Bearer ${sessionStorage.getItem("token")}`,
        //   },
        // }
      );
      if (response.status) {
        const steps = response?.data?.data?.steps;
        setStepData(steps);
      }
    } catch (error) {
      console.log("error", error);
    }
    setIsLoading(true);
    const realEndTime = moment().format("HH:mm:ss");
    // // const updatedSteps = [...stepData];
    // // updatedStepData
    // for (let i = 0; i < updatedStepData.length; i++) {
    //   const notes = updatedStepData[i];

    //   let count2 = notes?.count2; // Get the count2 value
    //   const timeUnit = notes?.time_unit; // Get the time unit from the step data

    //   // Convert count2 into seconds based on the time unit
    //   if (timeUnit === "minutes") {
    //     count2 *= 60; // Convert minutes to seconds
    //   } else if (timeUnit === "hours") {
    //     count2 *= 3600; // Convert hours to seconds
    //   }
    // }

    try {
      const postData = {
        real_end_time: realEndTime,
        status: "closed",
        _method: "put",
      };
      const response = await axios.post(
        `${API_BASE_URL}/meetings/${meetId}/status`,
        postData,
        {
          headers: {
            Authorization: `Bearer ${
              sessionStorage.getItem("token") || localStorage.getItem("token")
            }`,
          },
        }
      );
      if (response.status) {
        const data = response?.data?.data;
        setIsLoading(false);
        setIsModalOpen(false);
        await getMeetingById()

        stopRecording();

        setIsLoading(false);

        if (data?.plan_d_actions?.length > 0) {
          createStrategyMoment(data, t);
        }
      }
    } catch (error) {
      console.log("error ", error);
      setIsLoading(false);
    }
  };
  const closeEarly = async () => {
    const invalidActions = tableData?.filter((action) => !action.action);

    if (invalidActions?.length > 0) {
      toast.error(t("Please fill in all required fields in actions."));
      //   setButtonDisabled(false);
      return; // Prevent API call if validation fails
    }
    // setButtonDisabled(true);
    setIsLoading(true);
    const currentStep = meetingData?.steps[currentStepIndex];
    const stepId = currentStep.id;

    const responseNotes = await saveEndData();
    // setIsLoading(true);
    let updatedStepData = [...meetingData?.steps];
    updatedStepData[currentStepIndex] = responseNotes;

    localStorage.setItem("lastURL", "/play");

    // Parse the start time string
    const [hour, minute] = meetingData?.start_time?.split(":").map(Number);

    // Add one hour to the hour component
    let endHour = hour + 1;

    // If end hour is greater than or equal to 24, subtract 24
    if (endHour >= 24) {
      endHour -= 24;
    }

    // Format the end time as a string
    const endTimeStr = `${String(endHour).padStart(2, "0")}:${String(
      minute
    ).padStart(2, "0")}`;

    const updatedDatWithClosingTime = {
      ...meetingData,
      real_end_time: moment().format("HH:mm:ss"),
      _method: "put",
      status: "closed",
      timezone: userTimeZone,
      plan_d_actions: tableData ? tableData : [],
      steps: updatedStepData?.map(({ assigned_to, ...step }) => ({
        ...step,
        step_status: "completed",
        status: "completed",
      })),
      step_decisions: decision.filter((decision) => decision != ""),
      end_time: endTimeStr,
      moment_privacy_teams:
        meetingData?.moment_privacy === "team" &&
        meetingData?.moment_privacy_teams?.length &&
        typeof meetingData?.moment_privacy_teams[0] === "object"
          ? meetingData?.moment_privacy_teams.map((team) => team.id)
          : meetingData?.moment_privacy_teams || [], // Send as-is if IDs are already present
    };

    try {
      const response = await axios.post(
        `${API_BASE_URL}/public-meetings-update/${meetId}`,
        updatedDatWithClosingTime
        // {
        //   headers: {
        //     Authorization: `Bearer ${sessionStorage.getItem("token")}`,
        //   },
        // }
      );
      if (response.status) {
        const steps = response?.data?.data?.steps;
        setStepData(steps);
      }
    } catch (error) {
      console.log("error", error);
    }
    setIsLoading(true);
    const realEndTime = moment().format("HH:mm:ss");

    try {
      const postData = {
        real_end_time: realEndTime,
        status: "closed",
        _method: "put",
      };
      const response = await axios.post(
        `${API_BASE_URL}/meetings/${meetId}/status`,
        postData,
        {
          headers: {
            Authorization: `Bearer ${
              sessionStorage.getItem("token") || localStorage.getItem("token")
            }`,
          },
        }
      );
      if (response.status) {
        const data = response?.data?.data;
        setIsLoading(false);
        setIsModalOpen(false);
        setShowTimerModal(false);
        await getMeetingById()

        stopRecording();




        if (data?.plan_d_actions?.length > 0) {
          createStrategyMoment(data, t);
        }
      }
    } catch (error) {
      console.log("error ", error);
      setIsLoading(false);
    }
  };

  const [isPause, setIsPause] = useState(false);
  //-------------------------------Pause Step
  const handlePauseStep = async () => {
    // Get the user's time zone
    const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const currentTime = new Date();

    const formattedCurrentTime = currentTime.toLocaleString("en-GB", {
      timeZone: userTimeZone,
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: false,
    });
    const formattedCurrentDate = currentTime.toISOString().split("T")[0];
    const currentStep = meetingData?.steps[currentStepIndex];
    const stepId = currentStep?.id;

    try {
      const payload = {
        step_status: "to_finish",
        status: "to_finish",
        step_id: parseInt(stepId),
        pause_current_time: formattedCurrentTime,
        pause_current_date: formattedCurrentDate,
      };
      const response = await axios.post(
        `${API_BASE_URL}/make-step-pause?pause_current_time=${formattedCurrentTime}&pause_current_date=${formattedCurrentDate}`,
        payload,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${
              sessionStorage.getItem("token") || localStorage.getItem("token")
            }`,
          },
        }
      );
      if (response?.status) {
        getMeetingById();
        window.location.reload();
        setIsModalOpen(false);
      }
    } catch (error) {
      console.log("error", error);
      toast.error(error?.response?.data?.message || "server error");
    }
  };
  const [isNext, setIsNext] = useState(false);

  const handlenextPage = async (val) => {
    if (meetingData && currentStepIndex < meetingData?.steps?.length - 1) {
      setIsNext(true);
      // handlePlayPause(currentStepIndex, false);

      const currentStep = meetingData?.steps[currentStepIndex];
      const nextStep = meetingData?.steps[currentStepIndex + 1];
      const stepId = currentStep?.id;
      const myNextStepId = nextStep?.id;

      const optimizedEditorContent = await optimizeEditorContent(
        currentStep?.editor_content
      );
      const endTime = new Date();
      const currentTime = new Date();
      const formattedCurrentDate = currentTime.toISOString().split("T")[0];

      // Get the user's time zone
      const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

      // Convert endTime to a date string in the format "4/8/2024"
      const formattedEndDate = endTime.toLocaleDateString("en-GB", {
        day: "numeric",
        month: "numeric",
        year: "numeric",
        timeZone: userTimeZone,
      });

      // Convert currentDateTime to a string in the user's local time zone
      const localEndTime = endTime.toLocaleString("en-GB", {
        timeZone: userTimeZone,
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        hour12: false,
      });

      const options = { timeZone: userTimeZone };
      const timeInUserZone = new Date(
        currentTime.toLocaleString("en-US", options)
      );

      const formattedTime = formatTime(timeInUserZone);
      const formattedDate = formatDate(timeInUserZone);

      const postData = {
        ...currentStep,
        editor_content: optimizedEditorContent || "",
        savedTime:
          currentStep?.savedTime === 0 ? 0 : savedTime != 0 ? savedTime : 0,
        negative_time:
          savedTime === 0
            ? negativeTimes[activeStepIndex] !== 0
              ? negativeTimes[activeStepIndex]
              : 0
            : 0,

        step_status: "completed",
        totalstepnotes: stepNotes[currentStepIndex],
        totaldecision: decision.join(" "),
        note: stepNotes[currentStepIndex],
        original_note: stepNotes[currentStepIndex],
        status: "completed",
        url: meetingData?.steps[currentStepIndex].url
          ? meetingData?.steps[currentStepIndex].url
          : null,
        meeting_id: meetId,
        decision: decision[currentStepIndex] || [],
        actions: tableData ? tableData : [],
        end_time: localEndTime,
        end_date: formattedEndDate,
        next_step_id: myNextStepId,
        delay: currentStep?.negative_time === "99" ? stepDelay?.delay : null,
        real_time: localEndTime,
        real_date: formattedEndDate,
        pause_current_time: formattedTime,
        pause_current_date: formattedDate,
      };
      delete postData.time_taken;

      try {
        const response = await axios.post(
          `${API_BASE_URL}/play-meetings/steps/${stepId}/step-note-and-action?current_time=${formattedTime}&current_date=${formattedDate}&pause_current_time=${formattedTime}&pause_current_date=${formattedDate}`,
          postData,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${
                sessionStorage.getItem("token") || localStorage.getItem("token")
              }`,
            },
          }
        );
        if (response.status) {
          setTableData(response.data?.data?.planDActions); // Set
          const estimate_time = response?.data?.data?.estimate_time;
          const type = response?.data?.data?.type;
          const timezone = response?.data?.data?.timezone;
          if (estimate_time) {
            const formattedDateTime = parseAndFormatDateTime(
              estimate_time,
              type,
              timezone
            );
            setEstimateTime(formattedDateTime.formattedTime);
            setEstimateDate(formattedDateTime.formattedDate);
          }
        }
      } catch (error) {
        // toast.error(error.response?.data?.message);
      }

      try {
        const nextStepId = nextStep.id;
        const stepResponse = await axios.get(
          `${API_BASE_URL}/steps/${nextStepId}`,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${
                sessionStorage.getItem("token") || localStorage.getItem("token")
              }`,
            },
          }
        );

        if (stepResponse.status) {
          const nextStepData = stepResponse.data.data;
          const payload = {
            ...nextStepData,
            step_status: "in_progress",
            current_time: nextStep.current_time
              ? nextStep.current_time
              : localEndTime,
            current_date: nextStep.current_date
              ? nextStep.current_date
              : formattedCurrentDate,
            real_time: localEndTime,
            real_date: formattedEndDate,
            pause_current_time: formattedTime,
            pause_current_date: formattedDate,
          };

          delete payload.time_taken;

          // Make the second API call with the retrieved step data
          const response = await axios.post(
            `${API_BASE_URL}/play-meetings/steps/${nextStepId}/step-note-and-action?current_time=${formattedTime}&current_date=${formattedDate}&pause_current_time=${formattedTime}&pause_current_date=${formattedDate}`,
            payload,
            {
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${
                  sessionStorage.getItem("token") ||
                  localStorage.getItem("token")
                }`,
              },
            }
          );

          if (response.status) {
            const step = response?.data?.data;
            // Additional logic for handling the response
            // await getMeetingById();
            const estimate_time = response?.data?.data?.estimate_time;
            const type = response?.data?.data?.type;
            const timezone = response?.data?.data?.timezone;
            if (estimate_time) {
              const formattedDateTime = parseAndFormatDateTime(
                estimate_time,
                type,
                timezone
              );

              setEstimateTime(formattedDateTime.formattedTime);
              setEstimateDate(formattedDateTime.formattedDate);
            }
          }
        }
      } catch (error) {
        console.log("Error updating next step status:", error);
      }
      setIsNext(false);
      setCurrentStepIndex((prevIndex) => prevIndex + 1);
      setShow((prev) => ({ ...prev, showEditor: false })); // Close the showEditor
      setNextActiveStep();
      await getMeetingById();
    }
    return;
  };

  const [isPrevious, setIsPrevious] = useState(false);

  const previousStep = async () => {
    if (meetingData && currentStepIndex > 0) {
      setIsPrevious(true);

      const currentStep = meetingData?.steps[currentStepIndex];
      const previousStep = meetingData?.steps[currentStepIndex - 1];

      const currentStepId = currentStep?.id;
      const previousStepId = previousStep?.id;

      const currentTime = new Date();
      const formattedCurrentDate = currentTime.toISOString().split("T")[0];

      const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

      const options = { timeZone: userTimeZone };
      const timeInUserZone = new Date(
        currentTime.toLocaleString("en-US", options)
      );

      const realTime = formatTime(timeInUserZone);
      const realDate = formatDate(timeInUserZone);
      const formattedDate = currentTime.toLocaleDateString("en-GB", {
        day: "numeric",
        month: "numeric",
        year: "numeric",
        timeZone: userTimeZone,
      });
      const formattedTime = currentTime.toLocaleTimeString("en-GB", {
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        hour12: false,
        timeZone: userTimeZone,
      });

      try {
        // 1. Update current step to "to_finish"
        const toFinishPayload = {
          ...currentStep,
          step_status: "to_finish",
          status: "to_finish",
          real_time: formattedTime,
          real_date: formattedDate,
          pause_current_time: realTime,
          pause_current_date: realDate,
        };
        delete toFinishPayload.time_taken;

        await axios.post(
          `${API_BASE_URL}/play-meetings/steps/${currentStepId}/step-note-and-action?current_time=${realTime}&current_date=${realDate}&pause_current_time=${realTime}&pause_current_date=${realDate}`,
          toFinishPayload,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${
                sessionStorage.getItem("token") || localStorage.getItem("token")
              }`,
            },
          }
        );

        // 2. Update previous step to "in_progress"
        const prevStepResponse = await axios.get(
          `${API_BASE_URL}/steps/${previousStepId}`,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${
                sessionStorage.getItem("token") || localStorage.getItem("token")
              }`,
            },
          }
        );

        if (prevStepResponse.status) {
          const prevStepData = prevStepResponse.data.data;
          const prevPayload = {
            ...prevStepData,
            step_status: "in_progress",
            status: "in_progress",
            current_time: previousStep.current_time || formattedTime,
            current_date: previousStep.current_date || formattedCurrentDate,
            real_time: formattedTime,
            real_date: formattedDate,
            end_time: null,
            end_date: null,
            pause_current_time: realTime,
            pause_current_date: realDate,
          };
          delete prevPayload.time_taken;

          await axios.post(
            `${API_BASE_URL}/play-meetings/steps/${previousStepId}/step-note-and-action?current_time=${realTime}&current_date=${realDate}&pause_current_time=${realTime}&pause_current_date=${realDate}`,
            prevPayload,
            {
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${
                  sessionStorage.getItem("token") ||
                  localStorage.getItem("token")
                }`,
              },
            }
          );
        }

        setCurrentStepIndex((prevIndex) => prevIndex - 1);
        setShow((prev) => ({ ...prev, showEditor: false })); // Close the showEditor
        setPreviousActiveStep();
        await getMeetingById();
      } catch (error) {
        console.log("Error while going to previous step:", error);
      } finally {
        setIsPrevious(false);
      }
    }
  };

  const [saveDecision, setSaveDecision] = useState(false);
  const [saveStrategy, setSaveStrategy] = useState(false);
  const saveNewDecision = async (val) => {
    setIsNext(true);
    setSaveDecision(true);
    // handlePlayPause(currentStepIndex, false);

    const currentStep = meetingData?.steps[currentStepIndex];
    const nextStep = meetingData?.steps[currentStepIndex + 1];
    const stepId = currentStep?.id;
    const myNextStepId = nextStep?.id;

    const optimizedEditorContent = await optimizeEditorContent(
      currentStep?.editor_content
    );
    const endTime = new Date();
    const currentTime = new Date();
    const formattedCurrentDate = currentTime.toISOString().split("T")[0];

    // Get the user's time zone
    const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

    // Convert endTime to a date string in the format "4/8/2024"
    const formattedEndDate = endTime.toLocaleDateString("en-GB", {
      day: "numeric",
      month: "numeric",
      year: "numeric",
      timeZone: userTimeZone,
    });

    // Convert currentDateTime to a string in the user's local time zone
    const localEndTime = endTime.toLocaleString("en-GB", {
      timeZone: userTimeZone,
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: false,
    });

    const currentStepDecisions = decision[currentStepIndex] || [];

    const options = { timeZone: userTimeZone };
    const timeInUserZone = new Date(
      currentTime.toLocaleString("en-US", options)
    );

    const formattedTime = formatTime(timeInUserZone);
    const formattedDate = formatDate(timeInUserZone);
    // let isValid = true;
    // let errorMessage = "";

    // // Validate each decision entry based on its type
    // for (let i = 0; i < currentStepDecisions.length; i++) {
    //   const d = currentStepDecisions[i];
    //   const type = d?.decision_type?.trim();

    //   if (!type) {
    //     isValid = false;
    //     errorMessage = `Decision type is required for decision ${i + 1}`;
    //     break;
    //   }

    //   if (type === "milestone") {
    //     if (!d?.milestone_date?.trim() || !d?.decision_apply?.trim()) {
    //       isValid = false;
    //       errorMessage = `Milestone Date and Decision Apply are required for Milestone decision ${
    //         i + 1
    //       }`;
    //       break;
    //     }
    //   }

    //   if (type === "budget") {
    //     if (!d?.budget_amount?.toString().trim()) {
    //       isValid = false;
    //       errorMessage = `Budget Amount is required for Budget decision ${
    //         i + 1
    //       }`;
    //       break;
    //     }
    //   }

    //   if (type === "rule") {
    //     if (!d?.decision?.trim() || !d?.decision_apply?.trim()) {
    //       isValid = false;
    //       errorMessage = `Decision and Decision Apply are required for Rule decision ${
    //         i + 1
    //       }`;
    //       break;
    //     }
    //   }
    // }

    // // If validation fails, show toast and stop the process
    // if (!isValid) {
    //   toast.error(errorMessage);
    //   setSaveDecision(false);

    //   return;
    // }

    // 🔥 Clean empty decisions (but don't show error)
    const cleanedDecision = (decision[currentStepIndex] || []).filter((d) => {
      return Object.entries(d).some(([key, value]) => {
        if (key === "currency") return false;
        return (
          value !== null &&
          value !== undefined &&
          value.toString().trim() !== ""
        );
      });
    });

    const postData = {
      ...currentStep,
      editor_content: optimizedEditorContent || "",
      savedTime:
        currentStep?.savedTime === 0 ? 0 : savedTime != 0 ? savedTime : 0,
      negative_time:
        savedTime === 0
          ? negativeTimes[activeStepIndex] !== 0
            ? negativeTimes[activeStepIndex]
            : 0
          : 0,

      totalstepnotes: stepNotes[currentStepIndex],
      totaldecision: decision.join(" "),
      note: stepNotes[currentStepIndex],
      original_note: stepNotes[currentStepIndex],
      url: meetingData?.steps[currentStepIndex].url
        ? meetingData?.steps[currentStepIndex].url
        : null,
      meeting_id: meetId,
      decision: cleanedDecision,

      actions: tableData ? tableData : [],
      end_time: localEndTime,
      next_step_id: myNextStepId,
      delay: currentStep?.negative_time === "99" ? stepDelay?.delay : null,
      real_time: localEndTime,
      real_date: formattedEndDate,
      pause_current_time: formattedTime,
      pause_current_date: formattedDate,
    };
    delete postData.time_taken;

    try {
      const response = await axios.post(
        `${API_BASE_URL}/play-meetings/steps/${stepId}/step-note-and-action?current_time=${formattedTime}&current_date=${formattedDate}&pause_current_time=${formattedTime}&pause_current_date=${formattedDate}`,
        postData,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${
              sessionStorage.getItem("token") || localStorage.getItem("token")
            }`,
          },
        }
      );
      if (response.status) {
        setTableData(response.data?.data?.planDActions); // Set
        const estimate_time = response?.data?.data?.estimate_time;
        const type = response?.data?.data?.type;
        const timezone = response?.data?.data?.timezone;
        if (estimate_time) {
          const formattedDateTime = parseAndFormatDateTime(
            estimate_time,
            type,
            timezone
          );

          setEstimateTime(formattedDateTime.formattedTime);
          setEstimateDate(formattedDateTime.formattedDate);
          setSaveDecision(false);
        }
      }
    } catch (error) {
      // toast.error(error.response?.data?.message);
      setSaveDecision(false);
    }

    setIsNext(false);
    setShow((prev) => ({ ...prev, showEditor: false })); // Close the

    // Reset the decision fields
    const updatedDecision = [...decision];
    updatedDecision[activeStepIndex][currentDecisionIndex] = {
      decision_type: "",
      decision: "",
      creation_date: "",
      creation_time: "",
      milestone_date: "",
      budget_amount: "",
      currency: "",
      decision_apply: "",
    };

    setDecision(updatedDecision);

    // Close the modal
    setShowNewDecisionModal(false);
    setSaveDecision(false);

    await getMeetingById();
  };

  const [editingStrategy, setEditingStrategy] = useState(null);

  const handleEditStrategy = (strategy) => {
    setEditingStrategy(strategy);
    setShowStrategyModal(true);
  };

  useEffect(() => {
    if (editingStrategy) {
      setTableData([
        {
          ...editingStrategy,
          step_id: meetingData?.steps[currentStepIndex]?.id,
        },
      ]);
    }
  }, [editingStrategy]);

  const saveNewStrategy = async (val) => {
    setIsNext(true);
    setSaveStrategy(true);

    const invalidActions = tableData?.filter((action) => !action.action);

    if (invalidActions.length > 0) {
      toast.error("Some actions are missing!");
      setSaveStrategy(false);
      setIsNext(false);
      return;
    }

    // handlePlayPause(currentStepIndex, false);

    const currentStep = meetingData?.steps[currentStepIndex];
    const nextStep = meetingData?.steps[currentStepIndex + 1];
    const stepId = currentStep?.id;
    const myNextStepId = nextStep?.id;

    const optimizedEditorContent = await optimizeEditorContent(
      currentStep?.editor_content
    );
    const endTime = new Date();
    const currentTime = new Date();
    const formattedCurrentDate = currentTime.toISOString().split("T")[0];

    // Get the user's time zone
    const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

    // Convert endTime to a date string in the format "4/8/2024"
    const formattedEndDate = endTime.toLocaleDateString("en-GB", {
      day: "numeric",
      month: "numeric",
      year: "numeric",
      timeZone: userTimeZone,
    });

    // Convert currentDateTime to a string in the user's local time zone
    const localEndTime = endTime.toLocaleString("en-GB", {
      timeZone: userTimeZone,
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: false,
    });
    const options = { timeZone: userTimeZone };
    const timeInUserZone = new Date(
      currentTime.toLocaleString("en-US", options)
    );

    const formattedTime = formatTime(timeInUserZone);
    const formattedDate = formatDate(timeInUserZone);
    const currentStepDecisions = decision[currentStepIndex] || [];
    let isValid = true;
    let errorMessage = "";

    const postData = {
      ...currentStep,
      editor_content: optimizedEditorContent || "",
      savedTime:
        currentStep?.savedTime === 0 ? 0 : savedTime != 0 ? savedTime : 0,
      negative_time:
        savedTime === 0
          ? negativeTimes[activeStepIndex] !== 0
            ? negativeTimes[activeStepIndex]
            : 0
          : 0,

      totalstepnotes: stepNotes[currentStepIndex],
      totaldecision: decision.join(" "),
      note: stepNotes[currentStepIndex],
      original_note: stepNotes[currentStepIndex],
      url: meetingData?.steps[currentStepIndex].url
        ? meetingData?.steps[currentStepIndex].url
        : null,
      meeting_id: meetId,
      actions: tableData ? tableData : [],
      end_time: localEndTime,
      next_step_id: myNextStepId,
      delay: currentStep?.negative_time === "99" ? stepDelay?.delay : null,
      real_time: localEndTime,
      real_date: formattedEndDate,
      pause_current_time: formattedTime,
      pause_current_date: formattedDate,
    };
    delete postData.time_taken;

    try {
      const response = await axios.post(
        `${API_BASE_URL}/play-meetings/steps/${stepId}/step-note-and-action?current_time=${formattedTime}&current_date=${formattedDate}&pause_current_time=${formattedTime}&pause_current_date=${formattedDate}`,
        postData,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${
              sessionStorage.getItem("token") || localStorage.getItem("token")
            }`,
          },
        }
      );
      if (response.status) {
        setTableData(response.data?.data?.planDActions); // Set
        const estimate_time = response?.data?.data?.estimate_time;
        const type = response?.data?.data?.type;
        const timezone = response?.data?.data?.timezone;
        if (estimate_time) {
          const formattedDateTime = parseAndFormatDateTime(
            estimate_time,
            type,
            timezone
          );
          setEstimateTime(formattedDateTime.formattedTime);
          setEstimateDate(formattedDateTime.formattedDate);
          setSaveStrategy(false);
        }
      }
    } catch (error) {
      setSaveStrategy(false);

      // toast.error(error.response?.data?.message);
    }

    setIsNext(false);
    setShow((prev) => ({ ...prev, showEditor: false })); // Close the

    // Close the modal
    setShowStrategyModal(false);
    setTableData([]);
    await getMeetingById();
    return;
  };

  const saveDataonEnd = async (val) => {
    const currentStep = meetingData?.steps[currentStepIndex];
    const stepId = currentStep.id;
    const endTime = new Date();

    const currentTime = new Date();
    // Get the user's time zone
    const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    // Convert currentDateTime to a string in the user's local time zone
    const localEndTime = endTime.toLocaleString("en-GB", {
      timeZone: userTimeZone,
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: false,
    });
    const options = { timeZone: userTimeZone };
    const timeInUserZone = new Date(
      currentTime.toLocaleString("en-US", options)
    );

    const realTime = formatTime(timeInUserZone);
    const realDate = formatDate(timeInUserZone);

    // Format end_date to dd/mm/yyyy
    const formatEndDate = (date) => {
      const day = String(date.getUTCDate()).padStart(2, "0");
      const month = String(date.getUTCMonth() + 1).padStart(2, "0"); // Months are zero-based
      const year = date.getUTCFullYear();
      return `${day}/${month}/${year}`;
    };
    const formattedEndDate = formatEndDate(endTime);
    const postData = {
      ...currentStep,
      savedTime: savedTime != 0 ? savedTime : 0,

      negative_time:
        savedTime === 0
          ? negativeTimes[activeStepIndex] !== 0
            ? negativeTimes[activeStepIndex]
            : 0
          : 0,
      totalstepnotes: stepNotes[currentStepIndex],
      note: stepNotes[currentStepIndex],
      original_note: stepNotes[currentStepIndex],
      totaldecision: decision.join(" "),
      decision: decision[currentStepIndex] || [],
      url: meetingData?.steps[currentStepIndex].url
        ? meetingData?.steps[currentStepIndex].url
        : null,
      status: "active",
      step_status: "completed",
      meeting_id: meetId,
      actions: tableData ? tableData : [],
      end_time: localEndTime,
      end_date: formattedEndDate,
      delay: currentStep?.negative_time === "99" ? stepDelay?.delay : null,
      real_time: localEndTime,
      real_date: formattedEndDate,
      pause_current_time: realTime,
      pause_current_date: realDate,
    };

    try {
      const token =
        sessionStorage.getItem("token") || localStorage.getItem("token");
      const response = await axios.post(
        `${API_BASE_URL}/play-meetings/steps/${stepId}/step-note-and-action?current_time=${realTime}&current_date=${realDate}&pause_current_time=${realTime}&pause_current_date=${realDate}`,
        postData,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: ` Bearer ${token}`,
          },
        }
      );
      if (response.status) {
        return response?.data?.data;
      }
    } catch (error) {
      console.log("error", error);
      toast.error(error?.response?.data?.message);
    }
  };

  const closeMeeting = async () => {
    // Validate actions in tableData
    const invalidActions = tableData?.filter((action) => !action.action);

    if (invalidActions?.length > 0) {
      toast.error(t("Please fill in all required fields in actions."));
      // setButtonDisabled(false);
      return; // Prevent API call if validation fails
    }

    const responseNotes = await saveDataonEnd();
    let updatedStepData = [...meetingData?.steps];
    updatedStepData[updatedStepData.length - 1] = responseNotes; // Update the note for the last step
    // updatedStepData[updatedStepData.length - 1] = responseNotes;
    setIsLoading(true);
    localStorage.setItem("lastURL", "/play");
    // Parse the start time string
    const [hour, minute] = meetingData?.start_time?.split(":").map(Number);

    // Add one hour to the hour component
    let endHour = hour + 1;

    // If end hour is greater than or equal to 24, subtract 24
    if (endHour >= 24) {
      endHour -= 24;
    }

    // Format the end time as a string
    const endTimeStr = `${String(endHour).padStart(2, "0")}:${String(
      minute
    ).padStart(2, "0")}`;

    const updatedDatWithClosingTime = {
      ...meetingData,
      real_end_time: moment().format("HH:mm:ss"),
      _method: "put",
      status: "closed",
      plan_d_actions: tableData ? tableData : [],
      steps: updatedStepData?.map(({ assigned_to, ...step }) => ({
        ...step,
        step_status: "completed",
        status: "completed",
      })),
      step_decisions: decision.filter((decision) => decision != ""),
      end_time: endTimeStr,
      moment_privacy_teams:
        meetingData?.moment_privacy === "team" &&
        meetingData?.moment_privacy_teams?.length &&
        typeof meetingData?.moment_privacy_teams[0] === "object"
          ? meetingData?.moment_privacy_teams.map((team) => team.id)
          : meetingData?.moment_privacy_teams || [], // Send as-is if IDs are already present
    };
    try {
      const response = await axios.post(
        `${API_BASE_URL}/public-meetings-update/${meetId}`,
        updatedDatWithClosingTime
        // {
        //   headers: {
        //     Authorization: `Bearer ${sessionStorage.getItem("token")}`,
        //   },
        // }
      );
    } catch (error) {
      // console.log("error", error);
    }
    // -------------------------------------------------- NOW UPDATE STATUS OF MEETING ----------------------------------------------
    const realEndTime = moment().format("HH:mm:ss");
    try {
      const postData = {
        real_end_time: realEndTime,
        status: "closed",
        _method: "put",
      };
      const response = await axios.post(
        `${API_BASE_URL}/meetings/${meetId}/status`,
        postData,
        {
          headers: {
            Authorization: `Bearer ${
              sessionStorage.getItem("token") || localStorage.getItem("token")
            }`,
          },
        }
      );
      // console.log("meeting status api", response);
      if (response.status) {
        // console.log("meeting status changed successfully", response.data);
        const data = response?.data?.data;
        setIsLoading(false);
        setIsModalOpen(false);
        getMeetingById();
        navigate(`/destination/${data?.unique_id}/${data?.id}`);
        if (data?.plan_d_actions?.length > 0) {
          createStrategyMoment(data, t);
        }
      }
    } catch (error) {
      console.log("error ", error);
      setIsLoading(false);
    }
  };
  const closeEarlyMeeting = async () => {
    // Validate actions in tableData
    const invalidActions = tableData?.filter((action) => !action.action);

    if (invalidActions?.length > 0) {
      toast.error(t("Please fill in all required fields in actions."));
      // setButtonDisabled(false);
      return; // Prevent API call if validation fails
    }

    const responseNotes = await saveDataonEnd();
    let updatedStepData = [...meetingData?.steps];
    updatedStepData[currentStepIndex] = responseNotes; //
    setIsLoading(true);
    localStorage.setItem("lastURL", "/play");
    // Parse the start time string
    const [hour, minute] = meetingData?.start_time?.split(":").map(Number);

    // Add one hour to the hour component
    let endHour = hour + 1;

    // If end hour is greater than or equal to 24, subtract 24
    if (endHour >= 24) {
      endHour -= 24;
    }

    // Format the end time as a string
    const endTimeStr = `${String(endHour).padStart(2, "0")}:${String(
      minute
    ).padStart(2, "0")}`;

    const updatedDatWithClosingTime = {
      ...meetingData,
      real_end_time: moment().format("HH:mm:ss"),
      _method: "put",
      status: "closed",
      plan_d_actions: tableData ? tableData : [],
      steps: updatedStepData?.map(({ assigned_to, ...step }) => ({
        ...step,
        step_status: "completed",
        status: "completed",
      })),
      step_decisions: decision.filter((decision) => decision != ""),
      end_time: endTimeStr,
      moment_privacy_teams:
        meetingData?.moment_privacy === "team" &&
        meetingData?.moment_privacy_teams?.length &&
        typeof meetingData?.moment_privacy_teams[0] === "object"
          ? meetingData?.moment_privacy_teams.map((team) => team.id)
          : meetingData?.moment_privacy_teams || [], // Send as-is if IDs are already present
    };
    try {
      const response = await axios.post(
        `${API_BASE_URL}/public-meetings-update/${meetId}`,
        updatedDatWithClosingTime
        // {
        //   headers: {
        //     Authorization: `Bearer ${sessionStorage.getItem("token")}`,
        //   },
        // }
      );
    } catch (error) {
      // console.log("error", error);
    }
    // -------------------------------------------------- NOW UPDATE STATUS OF MEETING ----------------------------------------------
    const realEndTime = moment().format("HH:mm:ss");
    try {
      const postData = {
        real_end_time: realEndTime,
        status: "closed",
        _method: "put",
      };
      const response = await axios.post(
        `${API_BASE_URL}/meetings/${meetId}/status`,
        postData,
        {
          headers: {
            Authorization: `Bearer ${
              sessionStorage.getItem("token") || localStorage.getItem("token")
            }`,
          },
        }
      );
      // console.log("meeting status api", response);
      if (response.status) {
        // console.log("meeting status changed successfully", response.data);
        const data = response?.data?.data;
        setIsLoading(false);
        setIsModalOpen(false);
        setShowTimerModal(false);
        getMeetingById();
        navigate(`/destination/${data?.unique_id}/${data?.id}`);
        if (data?.plan_d_actions?.length > 0) {
          createStrategyMoment(data, t);
        }
      }
    } catch (error) {
      console.log("error ", error);
      setIsLoading(false);
    }
  };

  const { recordedChunks, micStream, systemStream, setIsRecording, recorder } =
    useRecording();

  const [existingAudioBlob, setExistingAudioBlob] = useState(null);

  const fetchExistingAudio = async () => {
    try {
      const response = await axios.get(
        `${API_BASE_URL}/audio-route/${meetId}`,
        {
          headers: {
            Authorization: `Bearer ${
              sessionStorage.getItem("token") || localStorage.getItem("token")
            }`,
          },
        }
      );
      setExistingAudioBlob(response?.data?.data?.voice_notes); // Save the existing audio blob
      // setAudioUrl(response?.data?.data?.voice_blob);
    } catch (error) {
      console.error("Error fetching existing audio:", error);
    }
  };

  useEffect(() => {
    if (meetId) {
      fetchExistingAudio(); // Fetch the existing audio if the meeting is in progress
    }
  }, [meetId]);

  const fetchAudioBlob = async (audioUrl) => {
    try {
      const response = await fetch(audioUrl);
      if (!response.ok) {
        throw new Error("Failed to fetch the existing audio");
      }
      const audioBlob = await response.blob(); // Convert the response to a Blob
      return audioBlob;
    } catch (error) {
      console.error("Error fetching audio blob:", error);
      return null;
    }
  };

  const appendAudio = async (existingAudioUrl, newBlob) => {
    const existingAudioBlob = await fetchAudioBlob(existingAudioUrl);
    if (!existingAudioBlob) {
      console.error("No existing audio to append to.");
      return newBlob; // Return just the new blob if there's no existing audio
    }

    const existingAudioBuffer = await existingAudioBlob.arrayBuffer();
    const newAudioBuffer = await newBlob.arrayBuffer();

    const combinedBuffer = new Uint8Array(
      existingAudioBuffer.byteLength + newAudioBuffer.byteLength
    );

    combinedBuffer.set(new Uint8Array(existingAudioBuffer), 0);
    combinedBuffer.set(
      new Uint8Array(newAudioBuffer),
      existingAudioBuffer.byteLength
    );

    return new Blob([combinedBuffer], { type: "audio/webm" });
  };


//  const uploadAudioToUpmeet = async (newBlob) => {
//   setShowProgressBar(true);
//   setProgress(0);
// getMeetingById();

//   const interval = setInterval(() => {
//     setProgress((prev) => (prev >= 90 ? 90 : prev + 10));
//   }, 200);

//   const formData = new FormData();
//   const file = new File([newBlob], "audio.wav", { type: "audio/wav" });

//   formData.append("meeting_id", meetId);
//   formData.append("file", file);

//   const token = sessionStorage.getItem("token") || localStorage.getItem("token");
//   let attempts = 0;
//   const maxRetries = 5;
//   const delay = (ms) => new Promise((res) => setTimeout(res, ms));

//   try {
//     let response;
//     while (attempts < maxRetries) {
//       try {
//         response = await axios.post(`${API_BASE_URL}/upmeet-upload`, formData, {
//           headers: { 
//             Authorization: `Bearer ${token}`,
//             'Content-Type': 'multipart/form-data'
//           },
//           // timeout: 30000
//         });

//         if (response?.status === 201 || response?.status === 200) {
//           const data = response.data?.data;
//           await getMeetingById();
          
//           // if (meetingData?.location === "Google Meet" && meetingData?.prise_de_notes === "Automatic") {
//           //   await onUploadSuccess();
//           // }
          
//           return data;
//         }
//         break;
//       } catch (err) {
//         attempts++;
//         if (attempts >= maxRetries) throw err;
//         await delay(1000 * attempts);
//       }
//     }
//   } catch (error) {
//     console.error("Upmeet upload failed:", error);
//     throw error;
//   } finally {
//     clearInterval(interval);
//     setProgress(100);
//     setShowProgressBar(false);
//   }
// };

// const uploadAudioToS3 = async (newBlob) => {
//   setShowProgressBar(true);
//   setProgress(0);

//   const interval = setInterval(() => {
//     setProgress((prev) => {
//       if (prev >= 90) {
//         clearInterval(interval);
//         return 90;
//       }
//       return prev + 10;
//     });
//   }, 200);

//   let combinedAudioBlob;
//   if (existingAudioBlob) {
//     combinedAudioBlob = await appendAudio(existingAudioBlob, newBlob);
//   } else {
//     combinedAudioBlob = newBlob;
//   }

//   const formData = new FormData();
//   const file = new File([combinedAudioBlob], "audio.wav", {
//     type: "audio/wav",
//   });

//   const now = new Date();
//   const timestamp = now.toISOString().replace(/[:.]/g, "-");
//   const rawTitle = meetingData?.title || "tektime";
//   const safeTitle = rawTitle?.replace(/[^a-zA-Z0-9-_]/g, "_");
//   const filename = `record_${safeTitle}_${timestamp}.mp3`;

//   // Optional: Download locally
//   const downloadUrl = URL.createObjectURL(file);
//   const a = document.createElement("a");
//   a.href = downloadUrl;
//   a.download = filename;
//   document.body.appendChild(a);
//   a.click();
//   document.body.removeChild(a);
//   URL.revokeObjectURL(downloadUrl);

//   formData.append("meeting_id", meetId);
//   formData.append("voice_notes", file);

//   const endPoint = `${API_BASE_URL}/audio-route`;
//   const token = sessionStorage.getItem("token") || localStorage.getItem("token");

//   let attempts = 0;
//   const maxRetries = 5;
//   const delay = (ms) => new Promise((res) => setTimeout(res, ms));

//   try {
//     let response;
//     while (attempts < maxRetries) {
//       try {
//         response = await axios.post(endPoint, formData, {
//           headers: { Authorization: `Bearer ${token}` },
//         });

//         if (response?.status === 200) {
//           const data = response.data?.data;
//           if (data?.status === "closed") {
//             setProgress(100);
//             // getMeetingById();
//             navigate(`/destination/${data?.unique_id}/${data?.id}`);
//             return data;
//           }
//         }
//         break; // exit loop if successful
//       } catch (err) {
//         attempts++;
//         if (attempts >= maxRetries) throw err;
//         await delay(1000 * attempts); // exponential backoff: 1s, 2s, 3s
//       }

//     }
//   } catch (error) {
//     console.error("Error uploading audio:", error);
//     toast.error("Audio uploading failed!");
//     toast.error(error?.response?.data?.message || error.message);
//     throw new Error("Failed to upload audio in database");
//   } finally {
//     clearInterval(interval);
//     setProgress(100);
//     setShowProgressBar(false);
//   }
// };

// const handleAudioUpload = async (audioBlob) => {
//   try {
//     // if (meetingData?.location === "Google Meet" && meetingData?.prise_de_notes === "Automatic") {
//       // Start both uploads in parallel
//       await Promise.allSettled([
//         uploadAudioToUpmeet(audioBlob)
//           .then(() => onUploadSuccess())
//           .catch(e => console.error("Upmeet final error:", e)),
//         uploadAudioToS3(audioBlob).catch(e => console.error("S3 final error:", e))
//       ]);
  
//   } catch (error) {
//     console.error("Meeting upload failed:", error);
//     toast.error("Failed to process meeting recording");
//   }
// };
  // Stop recording and upload audio
  
  // let isUploading = false;

  const uploadAudioToUpmeet = async (newBlob) => {
  const formData = new FormData();
  const file = new File([newBlob], "audio.wav", { type: "audio/wav" });

  formData.append("meeting_id", meetId);
  formData.append("file", file);

  const token = sessionStorage.getItem("token") || localStorage.getItem("token");
  let attempts = 0;
  const maxRetries = 5;
  const delay = (ms) => new Promise((res) => setTimeout(res, ms));

  try {
    let response;
    while (attempts < maxRetries) {
      try {
        response = await axios.post(`${API_BASE_URL}/upmeet-upload`, formData, {
          headers: { 
            Authorization: `Bearer ${token}`,
            'Content-Type': 'multipart/form-data'
          },
        });

        if (response?.status === 201 || response?.status === 200) {
          const data = response.data?.data;
          // await getMeetingById();
          return data;
        }
        break;
      } catch (err) {
        attempts++;
        if (attempts >= maxRetries) {
          console.error("Upmeet upload failed after retries:", err);
          throw err;
        }
        await delay(1000 * attempts);
      }
    }
  } catch (error) {
    console.error("Upmeet upload failed:", error);
    throw error;
  }
};

const uploadAudioToS3 = async (newBlob) => {
  let combinedAudioBlob;
  if (existingAudioBlob) {
    combinedAudioBlob = await appendAudio(existingAudioBlob, newBlob);
  } else {
    combinedAudioBlob = newBlob;
  }

  const formData = new FormData();
  const file = new File([combinedAudioBlob], "audio.wav", {
    type: "audio/wav",
  });

  const now = new Date();
  const timestamp = now.toISOString().replace(/[:.]/g, "-");
  const rawTitle = meetingData?.title || "tektime";
  const safeTitle = rawTitle?.replace(/[^a-zA-Z0-9-_]/g, "_");
  const filename = `record_${safeTitle}_${timestamp}.mp3`;

  // Optional: Download locally
  const downloadUrl = URL.createObjectURL(file);
  const a = document.createElement("a");
  a.href = downloadUrl;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(downloadUrl);

  formData.append("meeting_id", meetId);
  formData.append("voice_notes", file);

  const endPoint = `${API_BASE_URL}/audio-route`;
  const token = sessionStorage.getItem("token") || localStorage.getItem("token");

  let attempts = 0;
  const maxRetries = 5;
  const delay = (ms) => new Promise((res) => setTimeout(res, ms));

  try {
    let response;
    while (attempts < maxRetries) {
      try {
        response = await axios.post(endPoint, formData, {
          headers: { Authorization: `Bearer ${token}` },
        });

        if (response?.status === 200) {
          const data = response.data?.data;
          if (data?.status === "closed") {
            navigate(`/destination/${data?.unique_id}/${data?.id}`);
            return data;
          }
        }
        break;
      } catch (err) {
        attempts++;
        if (attempts >= maxRetries) {
          console.error("S3 upload failed after retries:", err);
          throw err;
        }
        await delay(1000 * attempts);
      }
    }
  } catch (error) {
    console.error("Error uploading audio:", error);
    toast.error("Audio uploading failed!");
    toast.error(error?.response?.data?.message || error.message);
    throw new Error("Failed to upload audio in database");
  }
};


  const handleAudioUpload = async (audioBlob) => {
  setShowProgressBar(true);
  setProgress(0);
      setIsUploading(true) // Set uploading flag
  // Start progress animation
  const interval = setInterval(() => {
    setProgress((prev) => (prev >= 90 ? 90 : prev + 10));
  }, 200);

  try {
    // Start both uploads in parallel
    const results = await Promise.allSettled([
      uploadAudioToUpmeet(audioBlob)
        .then(() => onUploadSuccess())
        .catch(e => {
          console.error("Upmeet final error:", e);
          return null; // Return null instead of throwing
        }),
      uploadAudioToS3(audioBlob).catch(e => {
        console.error("S3 final error:", e);
        return null; // Return null instead of throwing
      })
    ]);

    // Check if any upload failed completely (after all retries)
    const failedUploads = results?.filter(result => result.status === 'rejected' || result?.value === null);
    
    // Optional: You can add some logic here to handle partial success
    // For example, if one succeeded and one failed
    if (failedUploads?.length === results?.length) {
      // Both uploads failed completely
      toast.error("Failed to upload meeting recording");
    } else if (failedUploads?.length > 0) {
      // One succeeded, one failed
      console.log("Partial success - one upload completed");
    }

  } catch (error) {
    console.error("Meeting upload failed:", error);
    // Don't show error to user since we're handling silently
  } finally {
    clearInterval(interval);
    setProgress(100);
      setTimeout(() => {
      setShowProgressBar(false);
      setIsUploading(false)
    }, 500);
  }
};

  const stopRecording = async () => {
    if (!recorder.current || recorder.current.state !== "recording") return;

    // Stop the recorder first
    recorder.current.stop();

    // Stop the mic and system streams
    if (micStream.current) {
      micStream.current.getTracks().forEach((track) => track.stop());
      micStream.current = null; // Clear the reference
    }
    if (systemStream.current) {
      systemStream.current.getTracks().forEach((track) => track.stop());
      systemStream.current = null; // Clear the reference
    }

    setIsRecording(false);

    // Ensure `onstop` runs correctly
    recorder.current.onstop = async () => {
      if (recordedChunks.current.length === 0) {
        console.error("No recorded audio data available.");
        return;
      }

      // Create Blob from recorded chunks
      const blob = new Blob(recordedChunks.current, { type: "audio/webm" });

      // Reset recorded chunks
      recordedChunks.current = [];

      // if(meetingData?.location === "Google Meet" && meetingData?.prise_de_notes === "Automatic"){
       await handleAudioUpload(blob)
      // }else{

      //   // Upload the audio
      //   await uploadAudioToCloudinary(blob);
      // }
    };
  };



  useEffect(() => {
    const handleBeforeUnload = (event) => {
      // stopRecording(); // your custom function

      const message =
        "You have unsaved changes. Are you sure you want to leave?";
      event.returnValue = message;
      return message;
    };

    window.addEventListener("beforeunload", handleBeforeUnload);

    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, []);

  //   const handleBeforeUnload = (event) => {
  //   stopRecording(); // your custom function

  //   const message = "You have unsaved changes. Are you sure you want to leave?";
  //   event.returnValue = message;
  //   return message;
  // };

  // useEffect(() => {
  //   window.addEventListener("beforeunload", handleBeforeUnload);
  //   return () => {
  //     window.removeEventListener("beforeunload", handleBeforeUnload);
  //   };
  // }, []);



  const [isFileUploaded, setIsFileUploaded] = useState(false);
  const [isModalOpen2, setIsModalOpen2] = useState(false);
  const [modalContent, setModalContent] = useState(null);

  const openModal = (file) => {
    setModalContent(file);
    setIsModalOpen2(true);
  };

  const closeModal = () => {
    setIsModalOpen2(false);
    setModalContent(null);
  };

  const [showTimerModal, setShowTimerModal] = useState(false);

  const formattedDateTime = parseAndFormatDateTime(
    stepDelay?.estimate_time,
    meetingData?.type,
    meetingData?.timezone
  );

  const [emailCampaign, setEmailCampaign] = useState(null);

  useEffect(() => {
    const getNewsLetterStats = async () => {
      if (meetingData && meetingData?.type === "Newsletter") {
        try {
          const response = await axios.get(
            `${API_BASE_URL}/get-newsletter-stats/${meetingData?.id}/${meetingData?.steps[activeStepIndex]?.id}`
          );
          if (response?.data?.data) {
            const data = response.data?.data;
            setEmailCampaign(data);
          }
        } catch (error) {}
      }
    };

    getNewsLetterStats();

    const interval = setInterval(getNewsLetterStats, 20000);
    return () => clearInterval(interval);
  }, [meetingData, activeStepIndex]);

  const updateCallApi = (value) => {
    setCallApi(value);
    sessionStorage.setItem("callApi", value);
  };

  const [isRun, setIsRun] = useState(false);
  const handleRunStep = async (step) => {
    updateCallApi(true);
    setIsRun(true);
    // Get the user's time zone
    const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const currentTime = new Date();

    const formattedCurrentTime = currentTime.toLocaleString("en-GB", {
      timeZone: userTimeZone,
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: false,
    });
    const formattedCurrentDate = currentTime.toISOString().split("T")[0];
    try {
      const postData = {
        step_status: "in_progress",
        status: "in_progress",
        current_time: formattedCurrentTime,
        current_date: formattedCurrentDate,
      };

      const response = await axios.post(
        `${API_BASE_URL}/run-upcoming-step/${step?.id}?pause_current_time=${formattedCurrentTime}&pause_current_date=${formattedCurrentDate}`,
        postData,
        {
          headers: {
            Authorization: `Bearer ${
              sessionStorage.getItem("token") || localStorage.getItem("token")
            }`,
          },
        }
      );
      if (response?.status) {
        await getMeetingById();
        window.location.reload();
        setIsModalOpen(true);
      }
    } catch (error) {
      console.log("error", error);
    } finally {
      setIsRun(false);
    }
  };

  const [isReOpen, setIsReOpen] = useState(false);

  const handleReRunStep = async (step) => {
    updateCallApi(true);
    setIsReOpen(true);

    const currentTime = new Date();
    const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

    const options = { timeZone: userTimeZone };
    const timeInUserZone = new Date(
      currentTime.toLocaleString("en-US", options)
    );

    const formattedTime = formatTime(timeInUserZone);
    const formattedDate = formatDate(timeInUserZone);

    const payload = {
      ...step,
      step_status: "in_progress",
      status: "in_progress",
      re_open_to_finish_step: true,
      pause_current_time: formattedTime,
      pause_current_date: formattedDate,
    };
    try {
      const response = await axios.post(
        `${API_BASE_URL}/play-meetings/steps/${step?.id}/step-note-and-action?current_time=${formattedTime}&current_date=${formattedDate}&pause_current_time=${formattedTime}&pause_current_date=${formattedDate}`,
        payload,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${
              sessionStorage.getItem("token") || localStorage.getItem("token")
            }`,
          },
        }
      );
      if (response?.status) {
        await markToFinish(step?.id);
        await getMeetingById();
        window.location.reload();
        setIsModalOpen(true);
      }
    } catch (error) {
      console.error("Error starting step:", error);
    } finally {
      setIsReOpen(false);
    }
  };

  return (
    <>
      <div>
        <div className="email-invite w-100">
          {!isModalOpen && (
            <>
              {meetingData?.destination_banner ? (
                <img
                  src={meetingData?.destination_banner}
                  alt="Destination Banner"
                  style={{
                    width: "100%",
                    height: "338px",
                    objectFit: "cover",
                    filter: "opacity(0.5)",
                  }}
                />
              ) : (
                <div className="gradient-header">
                  <svg
                    width="100%"
                    height="338"
                    viewBox="0 0 1453 338"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g filter="url(#filter0_f_902_7997)">
                      <rect
                        width="100%"
                        height="271"
                        fill="url(#paint0_linear_902_7997)"
                      />
                    </g>
                    <defs>
                      <filter
                        id="filter0_f_902_7997"
                        x="-66.5"
                        y="-66.5"
                        width="1573"
                        height="404"
                        filterUnits="userSpaceOnUse"
                        color-interpolation-filters="sRGB"
                      >
                        <feFlood
                          flood-opacity="0"
                          result="BackgroundImageFix"
                        />
                        <feBlend
                          mode="normal"
                          in="SourceGraphic"
                          in2="BackgroundImageFix"
                          result="shape"
                        />
                        <feGaussianBlur
                          stdDeviation="33.25"
                          result="effect1_foregroundBlur_902_7997"
                        />
                      </filter>
                      <linearGradient
                        id="paint0_linear_902_7997"
                        x1="856"
                        y1="281.934"
                        x2="863.131"
                        y2="-138.913"
                        gradientUnits="userSpaceOnUse"
                      >
                        <stop stop-color="white" />
                        <stop offset="1" stop-color="#76C3EE" />
                      </linearGradient>
                    </defs>
                  </svg>
                </div>
              )}
            </>
          )}

          <div className="content">
            {!isModalOpen && (
              <div className="row report-row" style={{ height: "35vh" }}>
                <div className="col-12 col-md-10 d-flex flex-column flex-md-row align-items-center align-items-md-start text-center text-md-start">
                  <h5 className="content-heading fw-bold">
                    {meetingData?.objective}
                    {/* {meetingData?.clients[0]?.client_need || meetingData?.objective} */}
                  </h5>
                </div>

                <div className="col-md-2">
                  <div className="position-relative">
                    <Card className="mt-3 host-card tektime-dev-team">
                      <Card.Body>
                        <div className="d-flex justify-content-center">
                          <div className="profile-logo">
                            <Card.Img
                              className="avatar-img"
                              style={{
                                objectFit: "cover",
                                objectPosition: "top",
                              }}
                              src={
                                meetingData?.destination?.clients?.client_logo
                                  ? meetingData?.destination?.clients?.client_logo?.startsWith(
                                      "http"
                                    )
                                    ? meetingData?.destination?.clients
                                        .client_logo
                                    : `${Assets_URL}/${meetingData?.destination?.clients?.client_logo}`
                                  : "/Assets/logo2.png" || "/Assets/logo2.png"
                              }
                            />
                          </div>
                        </div>

                        <Card.Title className="text-center mt-3 card-heading">
                          {meetingData?.destination?.clients?.name || ""}
                        </Card.Title>
                        {/* <Card.Subtitle className="mb-2 card-subtext">
    {meeting?.user?.post} -{" "}
    {meeting?.user?.teams?.map((item) => item.name)}
  </Card.Subtitle> */}
                      </Card.Body>
                    </Card>
                  </div>
                </div>

                {/* ------------------------------------------------ HOST */}
              </div>
            )}
            <div className="row align-items-center report-row mt-5 mt-lg-0">
              {!isModalOpen && (
                <div className="col-md-8">
                  <div className="dropdown-container" ref={dropdownRef}>
                    <h5 className="content-heading-title ms-0">
                      {renderIcon()}
                      {/* // </div> */}
                      &nbsp;
                      {selectedTitleOrder}&nbsp;
                      {meetingData?.title} &nbsp;&nbsp;
                      {meetingData?.status === "active" && (
                        <span
                          className={`badge ms-2 ${
                            moment().isAfter(
                              moment(
                                `${meetingData?.date} ${meetingData?.start_time}`,
                                "YYYY-MM-DD HH:mm"
                              )
                            )
                              ? "late"
                              : "future"
                          }`}
                          // style={{ padding: "3px 8px 3px 8px" }}
                        >
                          {moment().isAfter(
                            moment(
                              `${meetingData?.date} ${meetingData?.start_time}`,
                              "YYYY-MM-DD HH:mm"
                            )
                          )
                            ? t("badge.late")
                            : t("badge.future")}
                        </span>
                      )}
                      {meetingData?.status === "in_progress" && (
                        // <span className="mx-2 badge status-badge-inprogress1">
                        <span
                          className={`${
                            meetingData?.steps?.some(
                              (moment) =>
                                moment?.step_status === "in_progress" &&
                                convertTimeTakenToSeconds(moment?.time_taken) >
                                  convertCount2ToSeconds(
                                    moment?.count2,
                                    moment?.time_unit
                                  )
                            )
                              ? "status-badge-red1"
                              : "status-badge-inprogress1"
                          } mx-2 badge h-100`}
                        >
                          {t("badge.inprogress")}
                        </span>
                      )}
                      {meetingData?.status === "closed" && (
                        <span className="mx-2 badge inprogrss">
                          {t("badge.finished")}
                        </span>
                      )}
                      {meetingData?.status === "abort" && (
                        <span className="mx-2 badge late">
                          {t("badge.cancel")}
                        </span>
                      )}
                      {meetingData?.status === "to_finish" && (
                        <span className="mx-2 badge status-badge-finish">
                          {t("badge.finish")}
                        </span>
                      )}
                      {meetingData?.status === "todo" && (
                        <span className="mx-2 badge status-badge-green">
                          {t("badge.Todo")}
                        </span>
                      )}
                      {/* {allMeetings && allMeetings?.length < 2 ? null : ( */}
                      {allMeetings?.length > 1 ? (
                        <span>
                          <MdKeyboardArrowDown
                            size={30}
                            onClick={toggleDropdown}
                            style={{
                              cursor: "pointer",
                              // marginLeft: ".6rem",
                              marginBottom: "6px",
                            }}
                          />
                        </span>
                      ) : null}
                    </h5>
                    {dropdownVisible && (
                      <div className="dropdown-content-filter">
                        <div className="dropdown-section">
                          {allMeetings
                            // ?.filter((item) => item.id !== meetId)
                            ?.filter(
                              (item) => item.id.toString() !== meetId.toString()
                            )
                            ?.map((item, index) => {
                              return (
                                <>
                                  <div
                                    key={index}
                                    onClick={() => applyFilter(item)}
                                    style={{ cursor: "pointer" }}
                                  >
                                    <b>{item.title_order}.</b>&nbsp;
                                    {item.title}
                                  </div>
                                </>
                              );
                            })}
                        </div>
                      </div>
                    )}
                  </div>

                  <div className="d-flex gap-4 items mt-0 mt-md-2 audio-items">
                    <div className="type">
                      <svg
                        width="20"
                        height="20"
                        viewBox="0 0 16 16"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M8.33333 2.99984C8.33333 3.3665 8.20289 3.6805 7.942 3.94184C7.68111 4.20317 7.36711 4.33362 7 4.33317C6.85556 4.33317 6.72222 4.31362 6.6 4.2745C6.47778 4.23539 6.35556 4.17162 6.23333 4.08317C5.96667 4.17206 5.75289 4.33317 5.592 4.5665C5.43111 4.79984 5.35044 5.05539 5.35 5.33317H14L13.3333 9.99984H10.0667V8.6665H12.1833C12.2389 8.33317 12.2862 7.99984 12.3253 7.6665C12.3644 7.33317 12.4116 6.99984 12.4667 6.6665H3.53333C3.58889 6.99984 3.63622 7.33317 3.67533 7.6665C3.71444 7.99984 3.76156 8.33317 3.81667 8.6665H5.93333V9.99984H2.66667L2 5.33317H4C4 4.78873 4.15 4.29428 4.45 3.84984C4.75 3.40539 5.15556 3.07762 5.66667 2.8665C5.7 2.52206 5.84444 2.23606 6.1 2.0085C6.35556 1.78095 6.65556 1.66695 7 1.6665C7.36667 1.6665 7.68067 1.79717 7.942 2.0585C8.20333 2.31984 8.33378 2.63362 8.33333 2.99984ZM6.51667 12.6665H9.48333L9.86667 8.6665H6.13333L6.51667 12.6665ZM5.33333 13.9998L4.83333 8.79984C4.78889 8.41095 4.9 8.06939 5.16667 7.77517C5.43333 7.48095 5.76111 7.33362 6.15 7.33317H9.85C10.2389 7.33317 10.5667 7.4805 10.8333 7.77517C11.1 8.06984 11.2111 8.41139 11.1667 8.79984L10.6667 13.9998H5.33333Z"
                          fill="#8590A3"
                        />
                      </svg>
                      {/* <span className="time">{meeting?.type}</span> */}
                      <span className="time">
                        {meetingData?.solution
                          ? meetingData?.solution?.title
                          : meetingData?.type === "Google Agenda Event"
                          ? "Google Agenda Event"
                          : meetingData?.type === "Special"
                          ? "Media"
                          : meetingData?.type === "Prise de contact"
                          ? "Prise de contact"
                          : t(`types.${meetingData?.type}`)}
                      </span>
                    </div>
                    {/* <div className="priority">
                      <svg
                        width="20"
                        height="20"
                        viewBox="0 0 16 16"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M12.346 6.79075C12.3618 6.77463 12.3808 6.76199 12.4018 6.75362C12.4228 6.74526 12.4453 6.74137 12.4679 6.74218C12.4905 6.743 12.5126 6.74851 12.533 6.75836C12.5533 6.76821 12.5714 6.78219 12.586 6.79941C13.4616 7.83748 13.9592 9.1419 13.9973 10.4994C13.9978 10.5213 13.9938 10.543 13.9857 10.5633C13.9776 10.5835 13.9656 10.602 13.9502 10.6175C13.9349 10.6331 13.9165 10.6454 13.8964 10.6537C13.8762 10.6621 13.8545 10.6663 13.8327 10.6661H10.8293C10.7849 10.6653 10.7424 10.6476 10.7104 10.6167C10.6785 10.5857 10.6595 10.5438 10.6573 10.4994C10.627 10.0165 10.4657 9.5509 10.1907 9.15275C10.167 9.11952 10.1557 9.07907 10.1588 9.0384C10.1618 8.99773 10.179 8.95941 10.2073 8.93008L12.346 6.79075ZM11.866 6.07941C11.9393 6.14075 11.9427 6.25141 11.8753 6.31941L9.73532 8.45875C9.70603 8.48691 9.66784 8.50399 9.62732 8.50703C9.5868 8.51007 9.54649 8.49889 9.51332 8.47541C9.20249 8.26075 8.84958 8.11463 8.47799 8.04675C8.43781 8.03991 8.4013 8.01924 8.37475 7.98831C8.34821 7.95739 8.33332 7.91816 8.33265 7.87741V4.85208C8.33265 4.75608 8.41265 4.68008 8.50865 4.68808C9.74476 4.79382 10.9177 5.27947 11.866 6.07941ZM7.66599 4.85275C7.66625 4.8301 7.66178 4.80765 7.65287 4.78684C7.64395 4.76602 7.63079 4.74729 7.61423 4.73186C7.59766 4.71642 7.57805 4.70461 7.55666 4.69719C7.53526 4.68976 7.51256 4.68689 7.48999 4.68875C6.25395 4.7943 5.08102 5.28038 4.13265 6.08008C4.11544 6.09471 4.10146 6.11276 4.0916 6.1331C4.08175 6.15343 4.07624 6.17559 4.07542 6.19817C4.07461 6.22075 4.0785 6.24325 4.08687 6.26424C4.09523 6.28523 4.10787 6.30424 4.12399 6.32008L6.26399 8.45941C6.29315 8.48781 6.33137 8.50505 6.37196 8.5081C6.41255 8.51114 6.45292 8.49981 6.48599 8.47608C6.7968 8.2614 7.14972 8.11528 7.52132 8.04741C7.56149 8.04057 7.59801 8.0199 7.62455 7.98898C7.65109 7.95806 7.66599 7.91883 7.66665 7.87808L7.66599 4.85275ZM5.80865 9.15275C5.83205 9.11951 5.84311 9.07915 5.83995 9.03862C5.83679 8.9981 5.81959 8.95995 5.79132 8.93075L3.65199 6.79075C3.63611 6.77467 3.61705 6.76207 3.59604 6.75377C3.57502 6.74546 3.55251 6.74163 3.52993 6.74251C3.50735 6.74338 3.4852 6.74896 3.46489 6.75887C3.44459 6.76878 3.42657 6.78282 3.41199 6.80008C2.53685 7.83833 2.03977 9.14273 2.00199 10.5001C2.00154 10.5219 2.00546 10.5435 2.01351 10.5638C2.02156 10.584 2.03358 10.6024 2.04886 10.618C2.06415 10.6335 2.08238 10.6458 2.1025 10.6542C2.12261 10.6626 2.1442 10.6668 2.16599 10.6667H5.16932C5.26132 10.6667 5.33599 10.5927 5.34132 10.5001C5.37132 10.0154 5.53465 9.54941 5.80799 9.15341"
                          fill="#8590A3"
                          fill-opacity="0.25"
                        />
                        <path
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M8.33203 7.87077C8.33203 7.95477 8.3947 8.02477 8.47737 8.0401C8.85073 8.10802 9.20529 8.25485 9.51737 8.47077C9.55067 8.49434 9.59116 8.50551 9.63183 8.50234C9.67251 8.49918 9.71079 8.48187 9.74004 8.45344L12.3467 5.84677C12.3628 5.83102 12.3756 5.8121 12.384 5.79119C12.3925 5.77029 12.3966 5.74786 12.3959 5.72531C12.3953 5.70276 12.39 5.68059 12.3804 5.66019C12.3708 5.63979 12.357 5.6216 12.34 5.60677C11.2636 4.6834 9.92079 4.12735 8.5067 4.01944C8.48426 4.01788 8.46174 4.02097 8.44055 4.02851C8.41936 4.03606 8.39996 4.04791 8.38356 4.0633C8.36717 4.0787 8.35412 4.09732 8.34526 4.11799C8.33639 4.13866 8.33189 4.16094 8.33203 4.18344V7.87077Z"
                          fill="#8590A3"
                        />
                      </svg>
                      <span className="time">
                        {t(
                          `meeting.newMeeting.options.priorities.${meetingData?.priority}`
                        )}
                      </span>
                    </div> */}
                  </div>

                  <div className="mt-3 d-flex align-items-center gap-2 content-body stepcard-content ps-2 ps-md-4 ps-lg-0">
                    <div className="d-flex align-items-center flex-wrap gap-2">
                      {meetingData?.type === "Action" ||
                      meetingData?.type === "Newsletter" ||
                      meetingData?.type === "Strategy" ? (
                        <>
                          <img
                            src="/Assets/invite-date.svg"
                            height="28px"
                            width="28px"
                          />
                          <span className="fw-bold formate-date">
                            {formattedDate}
                            &nbsp; -
                          </span>
                          <span className="fw-bold formate-date">
                            {/* {formattedDateActive} */}
                            {formattedEndDate}
                          </span>
                        </>
                      ) : (
                        <>
                          <img src="/Assets/invite-date.svg" />

                          <span className="fw-bold formate-date">
                            {formattedDate}
                            &nbsp; {t("at")}
                          </span>
                          <span className="fw-bold formate-date">
                            {/* {formattedTime} */}
                            {/* {convertTo12HourFormat(
              meetingData?.start_time,
              meetingData?.steps
            )}{" "} */}
                            {meetingData?.status === "in_progress"
                              ? convertTo12HourFormat(
                                  meetingData?.starts_at,
                                  meetingData?.date,
                                  meetingData?.steps,
                                  meetingData?.timezone
                                )
                              : convertTo12HourFormat(
                                  meetingData?.start_time,
                                  meetingData?.date,
                                  meetingData?.steps,
                                  meetingData?.timezone
                                )}{" "}
                            -{" "}
                          </span>

                          <span className="fw-bold formate-date">
                            {/* {formattedEndDateInHoursForEmailInvite} */}
                            {formattedDateTime.formattedDate || estimateDate}
                            &nbsp; {t("at")}
                          </span>
                          <span className="fw-bold formate-date">
                            {/* {lastStepEndTime} */}
                            {formattedDateTime.formattedTime || estimateTime}
                          </span>
                          {/* <span className="fw-bold formate-date">
            {convertTo12HourFormat1(
              meetingData?.start_time,
              meetingData?.steps
            )}{" "}
            -{" "}
          </span>
          <span className="fw-bold formate-date">
            {calculateEndTime(
              meetingData?.start_time?.slice(0, 5),
              meetingData?.steps
            )}
          </span> */}

                          <span className="fw-bold">
                            {getTimezoneSymbol(
                              localStorage.getItem("timezone")
                            )}
                          </span>
                        </>
                      )}
                    </div>
                  </div>

                  <div className="ps-2 ps-md-4 ps-lg-0">
                    {(meetingData?.location &&
                      meetingData?.location !== "None") ||
                    (meetingData?.agenda && meetingData?.agenda !== "None") ? (
                      <div className="d-flex gap-4 align-items-center mt-2 mb-2">
                        {meetingData?.location &&
                          meetingData?.location !== "None" && (
                            <p className="d-flex gap-2 justify-content-start ps-0 fw-bold align-items-center mb-0">
                              <span>
                                <svg
                                  width="28px"
                                  height="28px"
                                  viewBox="0 0 32 32"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <g
                                    id="SVGRepo_bgCarrier"
                                    stroke-width="0"
                                  ></g>
                                  <g
                                    id="SVGRepo_tracerCarrier"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                  ></g>
                                  <g id="SVGRepo_iconCarrier">
                                    {" "}
                                    <path
                                      d="M2 11.9556C2 8.47078 2 6.7284 2.67818 5.39739C3.27473 4.22661 4.22661 3.27473 5.39739 2.67818C6.7284 2 8.47078 2 11.9556 2H20.0444C23.5292 2 25.2716 2 26.6026 2.67818C27.7734 3.27473 28.7253 4.22661 29.3218 5.39739C30 6.7284 30 8.47078 30 11.9556V20.0444C30 23.5292 30 25.2716 29.3218 26.6026C28.7253 27.7734 27.7734 28.7253 26.6026 29.3218C25.2716 30 23.5292 30 20.0444 30H11.9556C8.47078 30 6.7284 30 5.39739 29.3218C4.22661 28.7253 3.27473 27.7734 2.67818 26.6026C2 25.2716 2 23.5292 2 20.0444V11.9556Z"
                                      fill="white"
                                    ></path>{" "}
                                    <path
                                      d="M5 23.5601C5 24.3557 5.64998 25.0001 6.45081 25.0001H6.47166C5.65857 25.0001 5 24.3557 5 23.5601Z"
                                      fill="#FBBC05"
                                    ></path>{" "}
                                    <path
                                      d="M17.4678 12.4V16.1596L22.5364 12.0712V8.43999C22.5364 7.6444 21.8864 7 21.0856 7H10.1045L10.0947 12.4H17.4678Z"
                                      fill="#FBBC05"
                                    ></path>{" "}
                                    <path
                                      d="M17.4671 19.9207H10.0818L10.0732 25.0003H21.085C21.887 25.0003 22.5358 24.3559 22.5358 23.5603V20.2819L17.4671 16.1611V19.9207Z"
                                      fill="#34A853"
                                    ></path>{" "}
                                    <path
                                      d="M10.1042 7L5 12.4H10.0956L10.1042 7Z"
                                      fill="#EA4335"
                                    ></path>{" "}
                                    <path
                                      d="M5 19.9204V23.56C5 24.3556 5.65857 25 6.47166 25H10.0736L10.0821 19.9204H5Z"
                                      fill="#1967D2"
                                    ></path>{" "}
                                    <path
                                      d="M10.0956 12.3999H5V19.9203H10.0821L10.0956 12.3999Z"
                                      fill="#4285F4"
                                    ></path>{" "}
                                    <path
                                      d="M26.9926 22.2796V9.9197C26.7068 8.27931 24.9077 10.1597 24.9077 10.1597L22.5371 12.0713V20.2804L25.9305 23.0392C27.1557 23.2 26.9926 22.2796 26.9926 22.2796Z"
                                      fill="#34A853"
                                    ></path>{" "}
                                    <path
                                      d="M17.4678 16.1594L22.5377 20.2814V12.0723L17.4678 16.1594Z"
                                      fill="#188038"
                                    ></path>{" "}
                                  </g>
                                </svg>
                              </span>
                              <span className="solutioncards option-text">
                                {meetingData?.user?.google_full_name}
                              </span>
                            </p>
                          )}
                        {meetingData?.agenda &&
                          meetingData?.agenda !== "None" && (
                            <p className="d-flex gap-2 justify-content-start ps-0 fw-bold align-items-center mb-0">
                              <span>
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  aria-label="Google Calendar"
                                  role="img"
                                  viewBox="0 0 512 512"
                                  width="28px"
                                  height="28px"
                                  fill="#000000"
                                >
                                  <g
                                    id="SVGRepo_bgCarrier"
                                    stroke-width="0"
                                  ></g>
                                  <g
                                    id="SVGRepo_tracerCarrier"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                  ></g>
                                  <g id="SVGRepo_iconCarrier">
                                    <rect
                                      width="512"
                                      height="512"
                                      rx="15%"
                                      fill="#ffffff"
                                    ></rect>
                                    <path
                                      d="M100 340h74V174H340v-74H137Q100 100 100 135"
                                      fill="#4285f4"
                                    ></path>
                                    <path
                                      d="M338 100v76h74v-41q0-35-35-35"
                                      fill="#1967d2"
                                    ></path>
                                    <path
                                      d="M338 174h74V338h-74"
                                      fill="#fbbc04"
                                    ></path>
                                    <path
                                      d="M100 338v39q0 35 35 35h41v-74"
                                      fill="#188038"
                                    ></path>
                                    <path
                                      d="M174 338H338v74H174"
                                      fill="#34a853"
                                    ></path>
                                    <path
                                      d="M338 412v-74h74"
                                      fill="#ea4335"
                                    ></path>
                                    <path
                                      d="M204 229a25 22 1 1 1 25 27h-9h9a25 22 1 1 1-25 27M270 231l27-19h4v-7V308"
                                      stroke="#4285f4"
                                      stroke-width="15"
                                      stroke-linejoin="bevel"
                                      fill="none"
                                    ></path>
                                  </g>
                                </svg>
                              </span>
                              <span className="solutioncards option-text">
                                {meetingData?.user?.google_full_name}
                              </span>
                            </p>
                          )}
                      </div>
                    ) : null}
                    <div className="ps-0">
                      {meetingData?.street ||
                      meetingData?.city ||
                      meetingData?.country ||
                      meetingData?.zip ? (
                        <p className="d-flex gap-2 align-items-center justify-content-start ps-0 ms-0 mt-2">
                          <FaLocationDot size={25} />
                          <span>
                            {meetingData?.street && `${meetingData?.street}, `}
                            {meetingData?.city && `${meetingData?.city}, `}
                            {meetingData?.country &&
                              `${meetingData?.country}, `}
                            {meetingData?.zip && `${meetingData?.zip}`}
                          </span>
                        </p>
                      ) : null}
                    </div>
                    {meetingData?.room_details ? (
                      <div>
                        <p className="d-flex gap-2 mt-2 justify-content-start align-items-top ps-0">
                          <BsPersonWorkspace size={25} />
                          <p className="m-0">
                            {meetingData?.room_details &&
                              meetingData?.room_details}
                          </p>
                        </p>
                      </div>
                    ) : null}
                    {meetingData?.phone ? ( // Check if the phone field exists
                      <div>
                        <p className="d-flex gap-2 align-items-center justify-content-start ps-0 mt-2">
                          <span>
                            <FaPhoneAlt size={25} />
                          </span>
                          <a
                            href={`tel:${meetingData?.phone}`}
                            className="text-decoration-none"
                          >
                            <span className="">{meetingData?.phone}</span>{" "}
                            {/* Display the phone number */}
                          </a>
                        </p>
                      </div>
                    ) : null}
                  </div>

                  {/* Options */}
                  <div className="row mt-2">
                    <div className="col-md-12 d-flex align-items-center gap-3">
                      {meetingData?.prise_de_notes === "Automatic" && (
                        <>
                          <div>
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="28"
                              height="28"
                              viewBox="0 0 28 28"
                              fill="none"
                            >
                              <g filter="url(#filter0_d_1_1154)">
                                <circle
                                  cx="14"
                                  cy="12"
                                  r="10"
                                  stroke="url(#paint0_linear_1_1154)"
                                  strokeWidth="4"
                                />
                              </g>
                              <defs>
                                <filter
                                  id="filter0_d_1_1154"
                                  x="0"
                                  y="0"
                                  width="28"
                                  height="28"
                                  filterUnits="userSpaceOnUse"
                                  colorInterpolationFilters="sRGB"
                                >
                                  <feFlood
                                    floodOpacity="0"
                                    result="BackgroundImageFix"
                                  />
                                  <feColorMatrix
                                    in="SourceAlpha"
                                    type="matrix"
                                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                                    result="hardAlpha"
                                  />
                                  <feOffset dy="2" />
                                  <feGaussianBlur stdDeviation="1" />
                                  <feColorMatrix
                                    type="matrix"
                                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
                                  />
                                  <feBlend
                                    mode="normal"
                                    in2="BackgroundImageFix"
                                    result="effect1_dropShadow_1_1154"
                                  />
                                  <feBlend
                                    mode="normal"
                                    in="SourceGraphic"
                                    in2="effect1_dropShadow_1_1154"
                                    result="shape"
                                  />
                                </filter>
                                <linearGradient
                                  id="paint0_linear_1_1154"
                                  x1="14"
                                  y1="0"
                                  x2="20.375"
                                  y2="21.75"
                                  gradientUnits="userSpaceOnUse"
                                >
                                  <stop stopColor="#B11FAB" />
                                  <stop offset="0.514" stopColor="#56E8F1" />
                                  <stop offset="1" stopColor="#2F47C1" />
                                </linearGradient>
                              </defs>
                            </svg>
                            <span className="solutioncards option-text">
                              {t("meeting.formState.Automatic note taking")}
                            </span>
                          </div>
                        </>
                      )}
                      {meetingData?.note_taker === true && (
                        <>
                          <div className="d-flex align-items-center gap-2">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="28px"
                              height="28px"
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="#3D57B5"
                              stroke-width="2"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            >
                              <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                              <g
                                id="SVGRepo_tracerCarrier"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              ></g>
                              <g id="SVGRepo_iconCarrier">
                                {" "}
                                <rect
                                  x="3"
                                  y="11"
                                  width="18"
                                  height="10"
                                  rx="2"
                                ></rect>{" "}
                                <circle cx="12" cy="5" r="2"></circle>{" "}
                                <path d="M12 7v4"></path>{" "}
                                <line x1="8" y1="16" x2="8" y2="16"></line>{" "}
                                <line x1="16" y1="16" x2="16" y2="16"></line>{" "}
                              </g>
                            </svg>
                            <span className="solutioncards option-text">
                              {t("meeting.formState.Note Taker")}
                            </span>
                          </div>
                        </>
                      )}

                      {meetingData?.alarm === true && (
                        <>
                          <div>
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="25"
                              height="24"
                              viewBox="0 0 25 24"
                              fill="none"
                            >
                              <path
                                fill-rule="evenodd"
                                clip-rule="evenodd"
                                d="M12.5001 1.35999C12.2879 1.35999 12.0844 1.44427 11.9344 1.5943C11.7844 1.74433 11.7001 1.94781 11.7001 2.15999V5.63519C11.7001 5.84736 11.7844 6.05084 11.9344 6.20087C12.0844 6.3509 12.2879 6.43519 12.5001 6.43519C12.7122 6.43519 12.9157 6.3509 13.0658 6.20087C13.2158 6.05084 13.3001 5.84736 13.3001 5.63519V2.99519C15.3173 3.17457 17.2159 4.02613 18.6915 5.41333C20.167 6.80054 21.134 8.64304 21.4373 10.6454C21.7407 12.6478 21.363 14.694 20.3646 16.4561C19.3662 18.2181 17.8051 19.5939 15.9315 20.3628C14.058 21.1317 11.9805 21.2492 10.0321 20.6965C8.08379 20.1437 6.37749 18.9528 5.1868 17.3145C3.99611 15.6763 3.39001 13.6857 3.46567 11.6619C3.54134 9.63811 4.29438 7.69833 5.60407 6.15358C5.67546 6.07402 5.73018 5.98095 5.765 5.87989C5.79981 5.77882 5.81402 5.6718 5.80678 5.56514C5.79954 5.45849 5.771 5.35437 5.72285 5.25893C5.67469 5.1635 5.6079 5.07868 5.52641 5.00949C5.44493 4.9403 5.3504 4.88815 5.24842 4.8561C5.14644 4.82406 5.03907 4.81278 4.93265 4.82293C4.82624 4.83308 4.72293 4.86446 4.62885 4.91521C4.53476 4.96595 4.4518 5.03504 4.38487 5.11839C2.81701 6.96726 1.92749 9.29609 1.86357 11.7194C1.79964 14.1427 2.56513 16.5152 4.03333 18.4442C5.50153 20.3731 7.58441 21.7429 9.9372 22.3268C12.29 22.9106 14.7716 22.6736 16.9713 21.6548C19.171 20.6361 20.9569 18.8967 22.0333 16.7247C23.1098 14.5526 23.4122 12.0781 22.8907 9.71074C22.3691 7.34336 21.0548 5.22506 19.1652 3.70646C17.2757 2.18787 14.9242 1.36003 12.5001 1.35999ZM11.2841 12.928L7.25847 7.31679C7.20487 7.23976 7.18006 7.14634 7.18838 7.05287C7.19669 6.9594 7.23761 6.87183 7.30396 6.80548C7.37031 6.73912 7.45789 6.69821 7.55135 6.68989C7.64482 6.68158 7.73824 6.70639 7.81527 6.75999L13.4297 10.784C13.6103 10.914 13.7605 11.0818 13.8699 11.2757C13.9793 11.4695 14.0453 11.6848 14.0632 11.9067C14.0812 12.1286 14.0507 12.3517 13.9738 12.5606C13.897 12.7695 13.7757 12.9592 13.6183 13.1166C13.4609 13.274 13.2712 13.3953 13.0623 13.4722C12.8534 13.549 12.6303 13.5795 12.4084 13.5615C12.1865 13.5436 11.9712 13.4776 11.7773 13.3682C11.5835 13.2588 11.4157 13.1086 11.2857 12.928"
                                fill="#3D57B5"
                              />
                            </svg>
                            <span
                              className="solutioncards"
                              style={{ color: "#3D57B5" }}
                            >
                              {t("meeting.formState.Beep alarm")}
                            </span>
                          </div>
                        </>
                      )}

                      {meetingData?.share_by === "email" && (
                        <>
                          <div>
                            <span>
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 30 30"
                                width="30px"
                                height="30px"
                              >
                                <path
                                  d="M 23 3 A 4 4 0 0 0 19 7 A 4 4 0 0 0 19.09375 7.8359375 L 10.011719 12.376953 A 4 4 0 0 0 7 11 A 4 4 0 0 0 3 15 A 4 4 0 0 0 7 19 A 4 4 0 0 0 10.013672 17.625 L 19.089844 22.164062 A 4 4 0 0 0 19 23 A 4 4 0 0 0 23 27 A 4 4 0 0 0 27 23 A 4 4 0 0 0 23 19 A 4 4 0 0 0 19.986328 20.375 L 10.910156 15.835938 A 4 4 0 0 0 11 15 A 4 4 0 0 0 10.90625 14.166016 L 19.988281 9.625 A 4 4 0 0 0 23 11 A 4 4 0 0 0 27 7 A 4 4 0 0 0 23 3 z"
                                  fill="#3D57B5"
                                />
                              </svg>
                            </span>
                            {t("Shareby")}
                          </div>
                        </>
                      )}
                    </div>
                  </div>

                  {/* Casting Type */}

                  {/* Privacy */}
                  <div className="row ">
                                                <div className="col-md-12 mt-2 ms-1 d-flex align-items-center gap-3">
                                                  <span
                                                    style={{
                                                      fontFamily: "Inter",
                                                      fontSize: "12px",
                                                      fontWeight: 400,
                                                      lineHeight: "14.52px",
                                                      textAlign: "left",
                                                      color: "#8590a3",
                                                    }}
                                                  >
                                                    {t("Privacy")}:
                                                  </span>
                                                  {/* <div className=""> */}
                                                  <div className="d-flex align-items-center flex-wrap">
                                                    {meetingData?.moment_privacy ===
                                                    "public" ? (
                                                      <Avatar
                                                        src="/Assets/Tek.png"
                                                        style={{ borderRadius: "0" }}
                                                      />
                                                    ) : meetingData?.moment_privacy ===
                                                      "team" ? (
                                                      <Avatar.Group>
                                                        {meetingData?.moment_privacy_teams_data?.map(
                                                          (item) => {
                                                            return (
                                                              <>
                                                                <Tooltip
                                                                  title={item?.name}
                                                                  placement="top"
                                                                >
                                                                  <Avatar
                                                                    size="large"
                                                                    src={
                                                                      item?.logo?.startsWith(
                                                                        "http"
                                                                      )
                                                                        ? item.logo
                                                                        : Assets_URL +
                                                                          "/" +
                                                                          item.logo
                                                                    }
                                                                  />
                                                                </Tooltip>
                                                              </>
                                                            );
                                                          }
                                                        )}
                                                      </Avatar.Group>
                                                    ) : meetingData?.moment_privacy ===
                                                      "participant only" ? (
                                                      <Avatar.Group>
                                                        {meetingData?.user_with_participants?.map(
                                                          (item) => {
                                                            return (
                                                              <>
                                                                <AntdTooltip
                                                                  title={item?.full_name}
                                                                  placement="top"
                                                                >
                                                                  <Avatar
                                                                    size="large"
                                                                    src={
                                                                      item?.participant_image?.startsWith(
                                                                        "http"
                                                                      )
                                                                        ? item.participant_image
                                                                        : Assets_URL +
                                                                          "/" +
                                                                          item.participant_image
                                                                    }
                                                                  />
                                                                </AntdTooltip>
                                                              </>
                                                            );
                                                          }
                                                        )}
                                                      </Avatar.Group>
                                                    ) : meetingData?.moment_privacy ===
                                                      "tektime members" ? (
                                                      <img
                                                        src={
                                                          meetingData?.user?.enterprise?.logo?.startsWith(
                                                            "http"
                                                          )
                                                            ? meetingData?.user?.enterprise
                                                                ?.logo
                                                            : Assets_URL +
                                                              "/" +
                                                              meetingData?.user?.enterprise
                                                                ?.logo
                                                        }
                                                        alt="Logo"
                                                        style={{
                                                          width: "30px",
                                                          height: "30px",
                                                          objectFit: "fill",
                                                          borderRadius: "50%",
                                                        }}
                                                      />
                                                    ) : meetingData?.moment_privacy ===
                                                      "enterprise" ? (
                                                      <AntdTooltip
                                                        title={
                                                          meetingData?.user?.enterprise?.name
                                                        }
                                                        placement="top"
                                                      >
                                                        <img
                                                          src={
                                                            meetingData?.user?.enterprise?.logo?.startsWith(
                                                              "http"
                                                            )
                                                              ? meetingData?.user?.enterprise
                                                                  ?.logo
                                                              : Assets_URL +
                                                                "/" +
                                                                meetingData?.user?.enterprise
                                                                  ?.logo
                                                          }
                                                          alt="Logo"
                                                          style={{
                                                            width: "30px",
                                                            height: "30px",
                                                            objectFit: "fill",
                                                            borderRadius: "50%",
                                                          }}
                                                        />
                                                      </AntdTooltip>
                                                    ) : meetingData?.moment_privacy ===
                                                      "password" ? (
                                                      <svg
                                                        width="37px"
                                                        height="36px"
                                                        viewBox="0 0 24 24"
                                                        fill="none"
                                                        xmlns="http://www.w3.org/2000/svg"
                                                      >
                                                        <g
                                                          id="SVGRepo_bgCarrier"
                                                          stroke-width="0"
                                                        ></g>
                                                        <g
                                                          id="SVGRepo_tracerCarrier"
                                                          stroke-linecap="round"
                                                          stroke-linejoin="round"
                                                        ></g>
                                                        <g id="SVGRepo_iconCarrier">
                                                          {" "}
                                                          <path
                                                            d="M7 10.0288C7.47142 10 8.05259 10 8.8 10H15.2C15.9474 10 16.5286 10 17 10.0288M7 10.0288C6.41168 10.0647 5.99429 10.1455 5.63803 10.327C5.07354 10.6146 4.6146 11.0735 4.32698 11.638C4 12.2798 4 13.1198 4 14.8V16.2C4 17.8802 4 18.7202 4.32698 19.362C4.6146 19.9265 5.07354 20.3854 5.63803 20.673C6.27976 21 7.11984 21 8.8 21H15.2C16.8802 21 17.7202 21 18.362 20.673C18.9265 20.3854 19.3854 19.9265 19.673 19.362C20 18.7202 20 17.8802 20 16.2V14.8C20 13.1198 20 12.2798 19.673 11.638C19.3854 11.0735 18.9265 10.6146 18.362 10.327C18.0057 10.1455 17.5883 10.0647 17 10.0288M7 10.0288V8C7 5.23858 9.23858 3 12 3C14.7614 3 17 5.23858 17 8V10.0288"
                                                            stroke="#000000"
                                                            stroke-width="2"
                                                            stroke-linecap="round"
                                                            stroke-linejoin="round"
                                                          ></path>{" "}
                                                        </g>
                                                      </svg>
                                                    ) : (
                                                      <AntdTooltip
                                                        title={meetingData?.user?.full_name}
                                                        placement="top"
                                                      >
                                                        <Avatar
                                                          src={
                                                            meetingData?.user?.image.startsWith(
                                                              "users/"
                                                            )
                                                              ? Assets_URL +
                                                                "/" +
                                                                meetingData?.user?.image
                                                              : meetingData?.user?.image
                                                          }
                                                        />
                                                      </AntdTooltip>
                                                    )}
                
                                                    <span
                                                      className={`badge ms-2 ${
                                                        meetingData?.moment_privacy ===
                                                        "private"
                                                          ? "solution-badge-red"
                                                          : meetingData?.moment_privacy ===
                                                            "public"
                                                          ? "solution-badge-green"
                                                          : meetingData?.moment_privacy ===
                                                              "enterprise" ||
                                                            meetingData?.moment_privacy ===
                                                              "participant only" ||
                                                            meetingData?.moment_privacy ===
                                                              "tektime members"
                                                          ? "solution-badge-blue"
                                                          : meetingData?.moment_privacy ===
                                                            "password"
                                                          ? "solution-badge-red"
                                                          : "solution-badge-yellow"
                                                      }`}
                                                      style={{ padding: "3px 8px 3px 8px" }}
                                                    >
                                                      {meetingData?.moment_privacy === "private"
                                                        ? t("solution.badge.private")
                                                        : meetingData?.moment_privacy ===
                                                          "public"
                                                        ? t("solution.badge.public")
                                                        : meetingData?.moment_privacy ===
                                                          "enterprise"
                                                        ? t("solution.badge.enterprise")
                                                        : meetingData?.moment_privacy ===
                                                          "participant only"
                                                        ? t("solution.badge.participantOnly")
                                                        : meetingData?.moment_privacy ===
                                                          "tektime members"
                                                        ? t("solution.badge.membersOnly")
                                                        : meetingData?.moment_privacy ===
                                                          "password"
                                                        ? t("solution.badge.password")
                                                        : t("solution.badge.team")}
                                                    </span>
                                                  </div>
                                                  {/* </div> */}
                                                </div>
                                              </div>

                  <div className="paragraph-parent mt-3 ps-2 ps-md-4 ps-lg-0">
                    <span className="paragraph paragraph-images">
                      <div
                        dangerouslySetInnerHTML={{
                          __html: meetingData?.description || "",
                        }}
                      />
                    </span>
                  </div>
                </div>
              )}

              {/* Inside Report Div Counter  */}
              {/* <div className="col-md-4">
              <CounterContainer
                alarm={meetingData?.alarm || false}
                progress={false}
                estimateTime={estimateTime}
                estimateDate={estimateDate}
              />
            </div> */}
            {meetingData && meetingData?.status === "in_progress" && (
  <div className="col-md-4">
   {meetingData?.guides?.some(
                      (item) =>
                        item?.email === sessionStorage.getItem("email") ||
                        item?.email === localStorage.getItem("email")
                    ) && <>

    {!isModalOpen && (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          marginBottom: "10px",
          gap: "6px",
        }}
      >
        <button
                style={{
                                      backgroundColor: "red",
                                      color: "#fff",
                                      border: "none",
                                      padding: "9px 26px",
                                      fontSize: "16px",
                                      cursor: "pointer",
                                      borderRadius: "5px",
                                      transition: "background-color 0.3s",
                                      display: "flex",
                                      alignItems: "center",
                                    }}
          onClick={() => {
            setShowTimerModal(true)
          }}
        >
              {t("Close")}
        </button>
      </div>
    )}
    </>}
                  <div
                    className={`counter-wrapper ${
                      isModalOpen ? "modal-open" : ""
                    }`}
                    style={{
                      position: isModalOpen ? "fixed" : "relative",
                      top: isModalOpen ? "30px" : "auto",
                      left: isModalOpen ? "50%" : "auto",
                      transform: isModalOpen ? "translateX(-50%)" : "none",
                      zIndex: isModalOpen ? 1001 : "auto",
                      pointerEvents: "none",
                    }}
                  >
                    <CounterContainer
                      alarm={meetingData?.alarm || false}
                      progress={false}
                      estimateTime={estimateTime}
                      estimateDate={estimateDate}
                      isModalOpen={isModalOpen}
                      stepTitle={meetingData?.steps[currentStepIndex]?.title}
                      stepOrder={meetingData?.steps[currentStepIndex]?.order_no}
                    />
                  </div>
                  {!isModalOpen && (
                    <>
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          marginTop: "-20px",
                          // marginRight: "10px",
                          marginBottom: "10px",
                          gap: "6px",
                        }}
                      >
                        <button
                          style={{
                            backgroundColor: "#0026b1",
                            color: "#fff",
                            border: "none",
                            padding: "10px 20px",
                            fontSize: "16px",
                            cursor: "pointer",
                            borderRadius: "5px",
                            transition: "background-color 0.3s",
                            display: "flex",
                            alignItems: "center",
                            whiteSpace: "nowrap",
                          }}
                          onClick={() => setIsModalOpen(true)}
                        >
                          <FaExpand
                            style={{ marginRight: "8px", fontSize: "20px" }}
                          />
                          {t("View Full Screen")}
                        </button>
                        {meetingData?.location === "Google Meet" && (
                          <button
                            className="btn"
                            style={{
                              backgroundColor: "#0026b1",
                              color: "#fff",
                              border: "none",
                              padding: "9px 26px",
                              fontSize: "16px",
                              cursor: "pointer",
                              borderRadius: "5px",
                              transition: "background-color 0.3s",
                              display: "flex",
                              alignItems: "center",
                              whiteSpace: "nowrap",
                            }}
                            onClick={async () => {
                              if (
                                meetingData?.prise_de_notes === "Automatic" &&
                                meetingData?.meet_link
                              ) {
                                await starting();
                                // window.open(meetingData?.meet_link, "_blank");
                              } else if (
                                meetingData?.meet_link &&
                                meetingData?.prise_de_notes === "Manual"
                              ) {
                                window.open(meetingData?.meet_link, "_blank");
                              } else if (
                                meetingData?.prise_de_notes === "Automatic" &&
                                !meetingData?.meet_link
                              ) {
                                await starting();
                              } else if (
                                meetingData?.prise_de_notes === "Manual" &&
                                !meetingData?.meet_link
                              ) {
                                window.open(meetingData?.meet_link, "_blank");
                              } else {
                                await starting();
                                // window.open(meetingData?.meet_link, "_blank");
                              }
                            }}
                          >
                            {t("meeting.formState.join with google meet")}
                          </button>
                        )}
                      </div>
                    </>
                  )}
                </div>
              )}

              {!isModalOpen && meetingData?.type === "Newsletter" && (
                <>
                  <div className="col-md-4">
                    <Card>
                      <Card.Body className="d-flex flex-column">
                        <h4
                          style={{
                            fontFamily: "Roboto",
                            fontSize: "20px",
                            fontWeight: 600,
                            lineHeight: "20px",
                            textAlign: "left",
                            color: "#344054",
                          }}
                        >
                          {t("Join Now")}
                        </h4>
                        <h6
                          style={{
                            fontFamily: "Roboto",
                            fontSize: "14px",
                            fontWeight: 400,
                            lineHeight: "16.41px",
                            textAlign: "left",
                            color: "#92929D",
                          }}
                        >
                          {t("Sign up to be a part of this moment.")}
                        </h6>
                        <div className="subscribe-button mt-2">
                          <button
                            className="btn moment-btn w-100"
                            style={{
                              padding: "12px 20px 12px 20px",
                              gap: "8px",
                              borderRadius: "8px",
                              background: "#2C48AE",
                              border: "1px solid #E2E2E2",
                              color: "white",
                            }}
                            onClick={() => handleShowSignUp()}
                          >
                            {t("Subscribe")}{" "}
                          </button>
                        </div>
                      </Card.Body>
                    </Card>
                  </div>
                </>
              )}
            </div>
            {!isModalOpen && (
              <div className="cards-section">
                <div style={{ marginTop: "5rem" }}>
                  <span className="participant-heading">
                    {showHostProfile && (
                      <IoArrowBackSharp
                        onClick={hideHostShow}
                        size={25}
                        style={{
                          cursor: "pointer",
                          marginRight: "1rem",
                        }}
                      />
                    )}
                    {meetingData?.guides?.length > 1 ? "Guides" : "Guide"}
                  </span>
                  <div
                    className="host"
                    style={{
                      background: showHostProfile && "white",
                    }}
                  >
                    <HostCard
                      data={meetingData?.user}
                      guides={meetingData?.guides}
                      handleShow={handleHostShow}
                      handleHide={hideHostShow}
                      showProfile={showHostProfile}
                      meeting={meetingData}
                    />
                  </div>
                </div>

                {/* ------------------------------------------------ Participants */}
                {isContentBlurred && (
                  <div
                    style={{
                      filter: isContentBlurred ? "none" : "blur(13px)",
                    }}
                  >
                    {meetingData?.type !== "Newsletter" && (
                      <>
                        {meetingData?.participants?.filter(
                          (item) =>
                            // item.isCreator === 0 &&
                            !guideEmails?.has(item.email)
                        )?.length > 0 && (
                          <div style={{ marginTop: "5rem" }}>
                            <span className="participant-heading">
                              {showProfile && (
                                <IoArrowBackSharp
                                  onClick={hideShow}
                                  size={25}
                                  style={{
                                    cursor: "pointer",
                                    marginRight: "1rem",
                                  }}
                                />
                              )}
                              {t("invite")}
                            </span>
                            <div className="row">
                              <div className="col-md-3">
                                <ParticipantCard />
                              </div>
                              <div className="col-md-3">
                                <ParticipantCard />
                              </div>
                              <div className="col-md-3">
                                <ParticipantCard />
                              </div>
                              <div className="col-md-3">
                                <ParticipantCard />
                              </div>
                            </div>

                            <div
                              style={{
                                background: showProfile && "white",
                              }}
                              className="participant"
                            >
                              <ParticipantCard
                                data={meetingData?.participants}
                                guides={meetingData?.guides}
                                handleShow={handleShow}
                                handleHide={hideShow}
                                showProfile={showProfile}
                                meeting={meetingData}
                              />
                            </div>
                          </div>
                        )}
                      </>
                    )}
                  </div>
                )}

                {/* ---------------- Steps --------------- */}

                <div style={{ marginTop: "5rem" }}>
                  <span className="participant-heading">
                    {`${t("meeting.newMeeting.labels.Program")} `}
                  </span>
                  {/* <StepCard data={meeting?.steps} startTime={formattedTime} users={{ ...meeting?.user, image: meeting?.user?.image || '/Assets/avatar.jpeg' }}  /> */}
                  <ActiveReportStepCard
                    setIsModalOpen1={setIsModalOpen}
                    setCurrentStepIndex={setCurrentStepIndex}
                    data={meetingData?.steps}
                    startTime={formattedTime}
                    users={{
                      ...meetingData?.user,
                      firstName: meetingData?.user?.name,
                      lastName: meetingData?.user?.last_name,
                      image:
                        meetingData?.user?.assigned_to_image ||
                        meetingData?.user?.image ||
                        "/Assets/avatar.jpeg",
                    }}
                    meetingId={meetingData?.id}
                    meeting={meetingData}
                    currentStepIndex={currentStepIndex}
                    runStep={handleRunStep}
                    isRun={isRun}
                    isReOpen={isReOpen}
                    reRunStep={handleReRunStep}
                  />
                </div>

                {meetingData?.meeting_files?.length > 0 && (
                  <div className="cards-section">
                    <div>
                      <span className="participant-heading">
                        {`${t("meeting.newMeeting.labels.file")} `}
                      </span>
                      <ReportStepFile
                        data={meetingData?.meeting_files}
                        startTime={formattedTime}
                        users={{
                          ...meetingData?.user,
                          firstName: meetingData?.user?.name,
                          lastName: meetingData?.user?.last_name,
                          image:
                            meetingData?.user?.assigned_to_image ||
                            meetingData?.user?.image ||
                            "/Assets/avatar.jpeg",
                        }}
                        meeting1={meetingData?.id}
                      />
                    </div>
                  </div>
                )}

          <div style={{ marginTop: "5rem" }}>
                  <span className="participant-heading">
                    {`${t("meeting.newMeeting.labels.discussion")} `}
                  </span>
                  <MeetingDiscussion
                   meetingId={meetId}
                                                              messages={meetingMessages}
                                                              selectedMoment={meetingData}
                                                              onMessagesUpdate={(newMeetings) => setMeetingMessages(newMeetings)}
                  />
                </div>


              </div>
            )}
          </div>
        </div>
        <div>
          {GradientSvg}
          {GradientSvg2}
          {GradientSvg3}
        </div>
      </div>
      <SignUp
        show={showSignUp}
        handleClose={handleCloseSignUp}
        // handleShowSignIn={handleShowSignIn}
        meetingId={meetId}
      />
      {isModalOpen && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            height: "100vh",
            width: "100vw",
            backgroundColor: "#fff",
            zIndex: 1000,
            // overflowY: "auto",
            // padding: "40px 20px",
            padding: "0px 10px",
            display: "flex",
            flexDirection: "column",
          }}
          className="tektime"
        >
          <div
            className="d-flex align-items-center full-screen-top-row"
            style={{ flexShrink: 0 }}
          >
            {/* Left section - Empty */}
            <div className="col-md-4">
              {meetingData?.prise_de_notes === "Automatic" && (
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "12px",
                    marginTop: "5px",
                  }}
                >
                  {/* Icon and Text */}
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="28"
                      height="28"
                      viewBox="0 0 28 28"
                      fill="none"
                    >
                      <g filter="url(#filter0_d_1_1154)">
                        <circle
                          cx="14"
                          cy="12"
                          r="10"
                          stroke="url(#paint0_linear_1_1154)"
                          strokeWidth="4"
                        />
                      </g>
                      <defs>
                        <filter
                          id="filter0_d_1_1154"
                          x="0"
                          y="0"
                          width="28"
                          height="28"
                          filterUnits="userSpaceOnUse"
                          colorInterpolationFilters="sRGB"
                        >
                          <feFlood
                            floodOpacity="0"
                            result="BackgroundImageFix"
                          />
                          <feColorMatrix
                            in="SourceAlpha"
                            type="matrix"
                            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                            result="hardAlpha"
                          />
                          <feOffset dy="2" />
                          <feGaussianBlur stdDeviation="1" />
                          <feColorMatrix
                            type="matrix"
                            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
                          />
                          <feBlend
                            mode="normal"
                            in2="BackgroundImageFix"
                            result="effect1_dropShadow_1_1154"
                          />
                          <feBlend
                            mode="normal"
                            in="SourceGraphic"
                            in2="effect1_dropShadow_1_1154"
                            result="shape"
                          />
                        </filter>
                        <linearGradient
                          id="paint0_linear_1_1154"
                          x1="14"
                          y1="0"
                          x2="20.375"
                          y2="21.75"
                          gradientUnits="userSpaceOnUse"
                        >
                          <stop stopColor="#B11FAB" />
                          <stop offset="0.514" stopColor="#56E8F1" />
                          <stop offset="1" stopColor="#2F47C1" />
                        </linearGradient>
                      </defs>
                    </svg>
                    <span
                      className="solutioncards option-text"
                      style={{ marginLeft: "8px" }}
                    >
                      {t("meeting.formState.Automatic note taking")}
                    </span>
                  </div>
                </div>
              )}
            </div>

            {/* Center section - Title */}
            <div className="col-md-4 text-center">
              <Tooltip
                title={
                  meetingData?.steps[currentStepIndex]?.order_no +
                  ".\u00A0" +
                  meetingData?.steps[currentStepIndex]?.title
                }
              >
                <h4
                  style={{
                    overflow: "hidden",
                    // textOverflow: "ellipsis",
                    // display: "inline-block",
                    // maxWidth: "100%",
                    // verticalAlign: "bottom",
                    margin: 0, // optional: remove extra spacing
                  }}
                  className="truncated-text"
                >
                  {meetingData?.steps[currentStepIndex]?.order_no}.
                  {meetingData?.steps[currentStepIndex]?.title}
                </h4>
              </Tooltip>
            </div>

            {/* Right section - Button */}
            <div
              className="col-md-4"
              style={{
                // flex: 1,
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                marginTop: "8px",
              }}
            >
              {/* Action buttons */}
              <div className="d-flex gap-3 align-items-center play-meeting-btn action-buttons">
                <button
                  style={{
                    backgroundColor: "#0026b1",
                    color: "#fff",
                    border: "none",
                    padding: "9px 15px",
                    fontSize: "16px",
                    cursor: "pointer",
                    borderRadius: "5px",
                    transition: "background-color 0.3s",
                    display: "flex",
                    alignItems: "center",
                  }}
                  onClick={() => setIsModalOpen(false)}
                >
                  <FaExpand style={{ marginRight: "8px", fontSize: "20px" }} />
                  {t("Exit Full Screen")}
                </button>
                {meetingData?.type === "Newsletter" ? (
                  <>
                    {isAutomatic ? (
                      <div className="d-flex gap-2 prev-btn align-items-center">
                        {/* Next button */}
                        {currentStepIndex !== meetingData?.steps?.length - 1 ? (
                          <>
                            {isLoadingNext ? (
                              <button className="btn btn-primary">
                                <Spinner
                                  as="span"
                                  variant="light"
                                  size="sm"
                                  role="status"
                                  aria-hidden="true"
                                  animation="border"
                                />
                              </button>
                            ) : (
                              <button
                                className="btn"
                                style={{
                                  backgroundColor: "#0026b1",
                                  color: "#fff",
                                  border: "none",
                                  padding: "9px 26px",
                                  fontSize: "16px",
                                  cursor: "pointer",
                                  borderRadius: "5px",
                                  transition: "background-color 0.3s",
                                  display: "flex",
                                  alignItems: "center",
                                }}
                                onClick={() => next()}
                                disabled={isLoadingNext}
                              >
                                {t("Next")}
                              </button>
                            )}
                          </>
                        ) : null}
                        <div className="justify-content-center">
                          <div className="d-flex prev-btn">
                            {isLoading ? (
                              <button className="btn btn-success">
                                <Spinner
                                  as="span"
                                  variant="light"
                                  size="sm"
                                  role="status"
                                  aria-hidden="true"
                                  animation="border"
                                />
                              </button>
                            ) : (
                              <button
                                className="btn"
                                style={{
                                  backgroundColor:
                                    currentStepIndex ===
                                    meetingData?.steps?.length - 1
                                      ? "#198754"
                                      : "red",
                                  color: "#fff",
                                  border: "none",
                                  padding: "9px 26px",
                                  fontSize: "16px",
                                  cursor: "pointer",
                                  borderRadius: "5px",
                                  transition: "background-color 0.3s",
                                  display: "flex",
                                  alignItems: "center",
                                }}
                                // onClick={() => close()}
                                onClick={() =>
                                  currentStepIndex ===
                                  meetingData?.steps?.length - 1
                                    ? close()
                                    : setShowTimerModal(true)
                                }
                                disabled={isLoading}
                              >
                                {t("Close")}
                              </button>
                            )}
                          </div>
                        </div>
                      </div>
                    ) : (
                      <div className="d-flex justify-content-center">
                        <div className="d-flex gap-2 justify-content-center">
                          {currentStepIndex !==
                          meetingData?.steps?.length - 1 ? (
                            <>
                              <div className="d-flex prev-btn">
                                {isNext ? (
                                  <button className="btn btn-primary">
                                    <Spinner
                                      as="span"
                                      variant="light"
                                      size="sm"
                                      role="status"
                                      aria-hidden="true"
                                      animation="border"
                                    />
                                  </button>
                                ) : (
                                  <button
                                    className="btn"
                                    style={{
                                      backgroundColor: "#0026b1",
                                      color: "#fff",
                                      border: "none",
                                      padding: "9px 26px",
                                      fontSize: "16px",
                                      cursor: "pointer",
                                      borderRadius: "5px",
                                      transition: "background-color 0.3s",
                                      display: "flex",
                                      alignItems: "center",
                                    }}
                                    onClick={async () => {
                                      await handlenextPage();
                                    }}
                                  >
                                    {t("Next")}
                                  </button>
                                )}
                              </div>
                            </>
                          ) : null}
                          <div className="d-flex gap-3 prev-btn">
                            <button
                              className="btn"
                              style={{
                                backgroundColor:
                                  currentStepIndex ===
                                  meetingData?.steps?.length - 1
                                    ? "#198754"
                                    : "red",
                                color: "#fff",
                                border: "none",
                                padding: "9px 26px",
                                fontSize: "16px",
                                cursor: "pointer",
                                borderRadius: "5px",
                                transition: "background-color 0.3s",
                                display: "flex",
                                alignItems: "center",
                              }}
                              onClick={() =>
                                currentStepIndex ===
                                meetingData?.steps?.length - 1
                                  ? closeMeeting()
                                  : setShowTimerModal(true)
                              }
                            >
                              {isLoading ? (
                                <Spinner
                                  as="span"
                                  variant="light"
                                  size="sm"
                                  role="status"
                                  aria-hidden="true"
                                  animation="border"
                                />
                              ) : (
                                t("Close")
                              )}
                            </button>
                          </div>
                        </div>
                      </div>
                    )}
                  </>
                ) : (
                  <>
                    {meetingData?.guides?.some(
                      (item) =>
                        item?.email === sessionStorage.getItem("email") ||
                        item?.email === localStorage.getItem("email")
                    ) && (
                      <>
                        {isAutomatic ? (
                          <div className="d-flex gap-2 prev-btn align-items-center">
                            {/* Next button */}
                            {currentStepIndex !==
                            meetingData?.steps?.length - 1 ? (
                              <>
                                {isLoadingNext ? (
                                  <button className="btn btn-primary">
                                    <Spinner
                                      as="span"
                                      variant="light"
                                      size="sm"
                                      role="status"
                                      aria-hidden="true"
                                      animation="border"
                                    />
                                  </button>
                                ) : (
                                  <button
                                    className="btn"
                                    style={{
                                      backgroundColor: "#0026b1",
                                      color: "#fff",
                                      border: "none",
                                      padding: "9px 26px",
                                      fontSize: "16px",
                                      cursor: "pointer",
                                      borderRadius: "5px",
                                      transition: "background-color 0.3s",
                                      display: "flex",
                                      alignItems: "center",
                                    }}
                                    onClick={() => next()}
                                    disabled={isLoadingNext}
                                  >
                                    {t("Next")}
                                  </button>
                                )}
                              </>
                            ) : null}
                            <div className="justify-content-center">
                              <div className="d-flex prev-btn">
                                {isLoading ? (
                                  <button className="btn btn-success">
                                    <Spinner
                                      as="span"
                                      variant="light"
                                      size="sm"
                                      role="status"
                                      aria-hidden="true"
                                      animation="border"
                                    />
                                  </button>
                                ) : (
                                  <button
                                    className="btn"
                                    style={{
                                      backgroundColor:
                                        currentStepIndex ===
                                        meetingData?.steps?.length - 1
                                          ? "#198754"
                                          : "red",
                                      color: "#fff",
                                      border: "none",
                                      padding: "9px 26px",
                                      fontSize: "16px",
                                      cursor: "pointer",
                                      borderRadius: "5px",
                                      transition: "background-color 0.3s",
                                      display: "flex",
                                      alignItems: "center",
                                    }}
                                    // onClick={() => close()}
                                    onClick={() =>
                                      currentStepIndex ===
                                      meetingData?.steps?.length - 1
                                        ? close()
                                        : setShowTimerModal(true)
                                    }
                                    disabled={isLoading}
                                  >
                                    {t("Close")}
                                  </button>
                                )}
                              </div>
                            </div>
                          </div>
                        ) : (
                          <div className="d-flex justify-content-center">
                            <div className="d-flex gap-2 justify-content-center">
                              {currentStepIndex !==
                              meetingData?.steps?.length - 1 ? (
                                <>
                                  <div className="d-flex prev-btn">
                                    {isNext ? (
                                      <button className="btn btn-primary">
                                        <Spinner
                                          as="span"
                                          variant="light"
                                          size="sm"
                                          role="status"
                                          aria-hidden="true"
                                          animation="border"
                                        />
                                      </button>
                                    ) : (
                                      <button
                                        className="btn"
                                        style={{
                                          backgroundColor: "#0026b1",
                                          color: "#fff",
                                          border: "none",
                                          padding: "9px 26px",
                                          fontSize: "16px",
                                          cursor: "pointer",
                                          borderRadius: "5px",
                                          transition: "background-color 0.3s",
                                          display: "flex",
                                          alignItems: "center",
                                        }}
                                        onClick={async () => {
                                          await handlenextPage();
                                        }}
                                      >
                                        {t("Next")}
                                      </button>
                                    )}
                                  </div>
                                </>
                              ) : null}
                              <div className="d-flex gap-3 prev-btn">
                                <button
                                  className="btn"
                                  style={{
                                    backgroundColor:
                                      currentStepIndex ===
                                      meetingData?.steps?.length - 1
                                        ? "#198754"
                                        : "red",
                                    color: "#fff",
                                    border: "none",
                                    padding: "9px 26px",
                                    fontSize: "16px",
                                    cursor: "pointer",
                                    borderRadius: "5px",
                                    transition: "background-color 0.3s",
                                    display: "flex",
                                    alignItems: "center",
                                  }}
                                  onClick={() =>
                                    currentStepIndex ===
                                    meetingData?.steps?.length - 1
                                      ? closeMeeting()
                                      : setShowTimerModal(true)
                                  }
                                >
                                  {isLoading ? (
                                    <Spinner
                                      as="span"
                                      variant="light"
                                      size="sm"
                                      role="status"
                                      aria-hidden="true"
                                      animation="border"
                                    />
                                  ) : (
                                    t("Close")
                                  )}
                                </button>
                              </div>
                            </div>
                          </div>
                        )}
                      </>
                    )}
                  </>
                )}
              </div>
            </div>
          </div>

          {/* Top Row */}
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              flexWrap: "wrap",
              marginBottom: "40px",
              maxHeight: "100px",
              flexShrink: 0,
            }}
          >
            {/* Left Side Text/Button */}
            <div>
              {meetingData?.type === "Newsletter" ? (
                <div className="text-start mb-4" style={{ marginLeft: "21px" }}>
                  {meetingData?.newsletter_guide ? (
                    <div>
                      {meetingData?.newsletter_guide
                        ?.logo ? (
                        meetingData?.newsletter_guide
                          .logo !== "" ? (
                          <img
                            className="user-img"
                            width={50}
                            height={50}
                            src={meetingData?.newsletter_guide?.logo?.startsWith('http') ?   meetingData?.newsletter_guide?.logo :
                              Assets_URL +
                              "/" +
                              meetingData?.newsletter_guide?.logo
                            }
                            alt="logo"
                          />
                        ) : (
                          <FaUserCircle size={30} />
                        )
                      ) : (
                        <FaUserCircle size={30} />
                      )}
                      <span style={{ margin: "0px 5px 0px 12px" }}>
                        {
                          meetingData?.newsletter_guide
                            ?.name
                        }
                      </span>
                      {/* <span>{meetingData?.user?.last_name}</span> */}
                    </div>
                  ) : (
                    <FaUserCircle size={30} />
                  )}
                </div>
              ) : (
                <div className="text-start mb-4" style={{ marginLeft: "21px" }}>
                  {meetingData?.steps[currentStepIndex]?.assigned_to_name ===
                  null ? (
                    <div className="d-flex align-items-center gap-1">
                      {meetingData?.steps[currentStepIndex]?.image ? (
                        <img
                          className="user-img"
                          width={50}
                          height={50}
                          src={
                            meetingData?.user?.image?.startsWith("users/")
                              ? `${Assets_URL}/${meetingData?.steps[currentStepIndex]?.image}`
                              : meetingData?.steps[currentStepIndex]?.image
                          }
                          alt="logo1"
                        />
                      ) : (
                        <FaUserCircle size={30} />
                      )}
                      <span style={{ margin: "0px 5px 0px 12px" }}>
                        {meetingData?.user?.name}
                      </span>
                      <span>{meetingData?.user?.last_name}</span>
                    </div>
                  ) : (
                    <div className="d-flex align-items-center gap-1">
                      {meetingData?.steps[currentStepIndex]?.participant ? (
                        <img
                          className="user-img"
                          width={50}
                          height={50}
                          // src={`${Assets_URL}/${meetingData?.steps[currentStepIndex]?.assigned_to_image}`}
                          src={
                            meetingData?.steps[
                              currentStepIndex
                            ]?.participant?.participant_image?.startsWith(
                              "users/"
                            )
                              ? `${Assets_URL}/${meetingData?.steps[currentStepIndex]?.participant?.participant_image}`
                              : meetingData?.steps[currentStepIndex]
                                  ?.participant?.participant_image
                          }
                          alt="logo2"
                        />
                      ) : (
                        <FaUserCircle size={30} />
                      )}
                      <div className="mx-2">
                        <div className="text-base font-medium">
                          {
                            meetingData?.steps[currentStepIndex]?.participant
                              ?.full_name
                          }
                        </div>
                        <div className="text-sm text-gray-500">
                          {
                            meetingData?.steps[currentStepIndex]?.participant
                              ?.post
                          }
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              )}

              {/* Button next to text */}
              {meetingData?.location === "Google Meet" && (
                <button
                  className="btn"
                  style={{
                    backgroundColor: "#0026b1",
                    color: "#fff",
                    border: "none",
                    padding: "9px 26px",
                    fontSize: "16px",
                    cursor: "pointer",
                    borderRadius: "5px",
                    transition: "background-color 0.3s",
                    display: "flex",
                    alignItems: "center",
                  }}
                  onClick={async () => {
                    if (
                      meetingData?.prise_de_notes === "Automatic" &&
                      meetingData?.meet_link
                    ) {
                      await starting();
                      // window.open(meetingData?.meet_link, "_blank");
                    } else if (
                      meetingData?.meet_link &&
                      meetingData?.prise_de_notes === "Manual"
                    ) {
                      window.open(meetingData?.meet_link, "_blank");
                    } else if (
                      meetingData?.prise_de_notes === "Automatic" &&
                      !meetingData?.meet_link
                    ) {
                      await starting();
                    } else if (
                      meetingData?.prise_de_notes === "Manual" &&
                      !meetingData?.meet_link
                    ) {
                      window.open(meetingData?.meet_link, "_blank");
                    } else {
                      await starting();
                      // window.open(meetingData?.meet_link, "_blank");
                    }
                  }}
                >
                  {t("meeting.formState.join with google meet")}
                </button>
              )}
            </div>

            {/* Counter Centered */}

            {/* Right Side Text/Button */}
            {meetingData?.type === "Newsletter" ? (
              <>
                <div
                  style={{
                    textAlign: "right",
                  }}
                >
                  {/* Toggle Button */}
                  <div
                    className={`d-flex align-items-center  my-1 flex-wrap fullscreen-toggles`}
                    style={{
                      flexWrap: "nowrap",
                      overflow: "hidden",
                      gap:
                        meetingData?.prise_de_notes === "Automatic"
                          ? "1.9rem"
                          : "0.2rem",
                    }} // Prevent wrapping and keep items in a single row
                  >
                    <div
                      className="d-flex align-items-center"
                      style={{ fontSize: "13px" }}
                    >
                      <ReactToggle
                        checked={showStepContentEditor}
                        icons={false}
                        className="step-content-toggle toggle-playback"
                        onChange={handleStepContentEditor}
                        aria-label="Toggle Step Content Editor"
                        style={{ transform: "scale(0.8)" }}
                      />
                      <span style={{ fontSize: "13px" }}>
                        {t("presentation.Step")}
                      </span>
                    </div>

                    <div
                      className="d-flex align-items-center"
                      style={{
                        fontSize: "13px",
                        // marginLeft: "2px",
                      }}
                    >
                      <ReactToggle
                        checked={notesEditor.showEditor}
                        icons={false}
                        className={`toggle-icon toggle-playback ${
                          notesEditor.showEditor ? "active" : ""
                        }`}
                        onChange={handleNotesEditorToggle}
                        aria-label="Toggle Notes Editor"
                        style={{ transform: "scale(0.8)" }}
                      />
                      <span style={{ fontSize: "13px" }}>
                        {t("presentation.Notes")}
                      </span>
                    </div>

                    <div
                      className="d-flex align-items-center"
                      style={{
                        fontSize: "13px",
                        // marginLeft: "2px",
                      }}
                    >
                      <ReactToggle
                        checked={fileEditor.showEditor}
                        icons={false}
                        className={`toggle-icon toggle-playback ${
                          fileEditor.showEditor ? "active" : ""
                        }`}
                        onChange={handleFileEditor}
                        aria-label="Toggle Plan D'Action Editor"
                        style={{ transform: "scale(0.8)" }}
                      />
                      <span style={{ fontSize: "13px" }}>
                        {t("presentation.Files")}
                      </span>
                    </div>
                  </div>
                  {/* {parseInt(sessionStorage.getItem("user-id")) !== 66 && (
                    <button
                      className="btn"
                      style={{
                        backgroundColor: "#0026b1",
                        color: "#fff",
                        border: "none",
                        padding: "9px 26px",
                        fontSize: "16px",
                        cursor: "pointer",
                        borderRadius: "5px",
                        transition: "background-color 0.3s",
                        display: "flex",
                        alignItems: "center",
                      }}
                      onClick={async () => {
                        await previousStep();
                      }}
                    >
                      {t("Previous")}
                    </button>
                  )} */}
                </div>
              </>
            ) : (
              <div
                style={{
                  textAlign: "right",
                  visibility: meetingData?.guides?.some(
                    (item) =>
                      item?.email === sessionStorage.getItem("email") ||
                      item?.email === localStorage.getItem("email")
                  )
                    ? "visible"
                    : "hidden",
                }}
              >
                {/* Toggle Button */}
                <div
                  className={`d-flex align-items-center  my-1 flex-wrap`}
                  style={{
                    flexWrap: "nowrap",
                    overflow: "hidden",
                    gap:
                      meetingData?.prise_de_notes === "Automatic"
                        ? "1.9rem"
                        : "0.2rem",
                  }} // Prevent wrapping and keep items in a single row
                >
                  <div
                    className="d-flex align-items-center"
                    style={{ fontSize: "13px" }}
                  >
                    <ReactToggle
                      checked={showStepContentEditor}
                      icons={false}
                      className="step-content-toggle toggle-playback"
                      onChange={handleStepContentEditor}
                      aria-label="Toggle Step Content Editor"
                      style={{ transform: "scale(0.8)" }}
                    />
                    <span style={{ fontSize: "13px" }}>
                      {t("presentation.Step")}
                    </span>
                  </div>

                  {!isAutomatic && (
                    <div
                      className="d-flex align-items-center"
                      style={{
                        fontSize: "13px",
                        // marginLeft: "2px",
                      }}
                    >
                      <ReactToggle
                        checked={notesEditor.showEditor}
                        icons={false}
                        className={`toggle-icon toggle-playback ${
                          notesEditor.showEditor ? "active" : ""
                        }`}
                        onChange={handleNotesEditorToggle}
                        aria-label="Toggle Notes Editor"
                        disabled={meetingData?.type === "Newsletter"}
                        style={{ transform: "scale(0.8)" }}
                      />
                      <span style={{ fontSize: "13px" }}>
                        {t("presentation.Notes")}
                      </span>
                    </div>
                  )}

                  <div
                    className="d-flex align-items-center"
                    style={{
                      fontSize: "13px",
                      // marginLeft: "2px",
                    }}
                  >
                    <ReactToggle
                      checked={decisionEditor.showEditor}
                      icons={false}
                      className={`toggle-icon toggle-playback ${
                        decisionEditor.showEditor ? "active" : ""
                      }`}
                      onChange={handleDecisionEditorToggle}
                      aria-label="Toggle Decision Editor"
                      style={{ transform: "scale(0.8)" }} // Make the toggle smaller
                    />
                    <span style={{ fontSize: "13px" }}>
                      {t("presentation.Decision")}
                    </span>
                  </div>

                  <div
                    className="d-flex align-items-center"
                    style={{
                      fontSize: "13px",
                      // marginLeft: "2px",
                    }}
                  >
                    <ReactToggle
                      checked={planDActionEditor.showEditor}
                      icons={false}
                      className={`toggle-icon toggle-playback ${
                        planDActionEditor.showEditor ? "active" : ""
                      }`}
                      onChange={handlePlanDActionEditor}
                      aria-label="Toggle Plan D'Action Editor"
                      style={{ transform: "scale(0.8)" }}
                    />
                    <span style={{ fontSize: "13px" }}>
                      {t("presentation.Strategy")}
                    </span>
                  </div>

                  <div
                    className="d-flex align-items-center"
                    style={{
                      fontSize: "13px",
                      // marginLeft: "2px",
                    }}
                  >
                    <ReactToggle
                      checked={fileEditor.showEditor}
                      icons={false}
                      className={`toggle-icon toggle-playback ${
                        fileEditor.showEditor ? "active" : ""
                      }`}
                      onChange={handleFileEditor}
                      aria-label="Toggle Plan D'Action Editor"
                      style={{ transform: "scale(0.8)" }}
                    />
                    <span style={{ fontSize: "13px" }}>
                      {t("presentation.Files")}
                    </span>
                  </div>
                </div>
                {/* <button
                  className="btn"
                  style={{
                    backgroundColor: "#0026b1",
                    color: "#fff",
                    border: "none",
                    padding: "9px 26px",
                    fontSize: "16px",
                    cursor: "pointer",
                    borderRadius: "5px",
                    transition: "background-color 0.3s",
                    display: "flex",
                    alignItems: "center",
                  }}
                  onClick={async () => {
                    await previousStep();
                  }}
                >
                  {t("Previous")}
                </button> */}
              </div>
            )}
          </div>

          {/* Data Section */}
          <div
            style={{
              flex: 1,
              overflowY: "auto",
              minHeight: 0, // Important for flex children to scroll properly
            }}
          >
            {meetingData?.guides?.some(
              (item) =>
                item?.email === sessionStorage.getItem("email") ||
                item?.email === localStorage.getItem("email")
            ) && (
              <div className="d-flex justify-content-center align-items-center">
                <button
                  className="btn"
                  style={{
                    backgroundColor: "#0026b1",
                    color: "#fff",
                    border: "none",
                    padding: "9px 26px",
                    fontSize: "16px",
                    cursor: "pointer",
                    borderRadius: "5px",
                    transition: "background-color 0.3s",
                    display: "flex",
                    alignItems: "center",
                  }}
                  onClick={async () => {
                    await handlePauseStep();
                  }}
                >
                  {t("Pause")}
                </button>
              </div>
            )}
            {editorContent && (
              <div style={{ height: "100vh" }}>
                <div
                  className={`
                                 ${
                                   !decisionEditor.showEditor ||
                                   !notesEditor.showEditor ||
                                   !planDActionEditor.showEditor
                                     ? ""
                                     : "displaycard card-body"
                                 }
                                
                                 `}
                  style={{
                    maxHeight:
                      showStepContentEditor === false &&
                      !decisionEditor.showEditor &&
                      !notesEditor.showEditor &&
                      !planDActionEditor.showEditor &&
                      !fileEditor.showEditor &&
                      "100vh",
                    height:
                      showStepContentEditor === false &&
                      !decisionEditor.showEditor &&
                      !notesEditor.showEditor &&
                      !planDActionEditor.showEditor &&
                      !fileEditor.showEditor &&
                      "100vh",
                    border:
                      showStepContentEditor === false &&
                      !decisionEditor.showEditor &&
                      !notesEditor.showEditor &&
                      !planDActionEditor.showEditor &&
                      !fileEditor.showEditor &&
                      "2px solid #eee",
                    // overflowY:
                    //   showStepContentEditor === false &&
                    //   !decisionEditor.showEditor &&
                    //   !notesEditor.showEditor &&
                    //   !planDActionEditor.showEditor &&
                    //   !fileEditor.showEditor &&
                    //   "auto",
                    padding:
                      showStepContentEditor === false &&
                      !decisionEditor.showEditor &&
                      !notesEditor.showEditor &&
                      !planDActionEditor.showEditor &&
                      !fileEditor.showEditor &&
                      "10px",
                  }}
                >
                  {decisionEditor.showEditor === false &&
                    showStepContentEditor === false &&
                    notesEditor.showEditor === false &&
                    planDActionEditor.showEditor === false &&
                    fileEditor.showEditor === false &&
                    show.showEditor === false &&
                    (meetingData?.steps[currentStepIndex]?.editor_type ===
                      "File" ||
                    meetingData?.steps[currentStepIndex]?.editor_type ===
                      "Video" ||
                    meetingData?.steps[currentStepIndex]?.editor_type ===
                      "Photo" ? (
                      <div>
                        <iframe
                          src={
                            Assets_URL +
                            "/" +
                            meetingData?.steps[currentStepIndex]?.file
                          }
                          width="100%"
                          // height="90vh"
                          style={{ height: "100vh" }}
                        />
                      </div>
                    ) : meetingData?.steps[currentStepIndex]?.editor_type ===
                      "Excel" ? (
                      <div className="iframe-container">
                        <Spreadsheet
                          data={excelData || []}
                          // onChange={handleSpreadsheetChange}
                        />
                      </div>
                    ) : meetingData?.steps[currentStepIndex]?.editor_type ===
                      "Url" ? (
                      <div className="iframe-container">
                        <iframe
                          // ref={iframeRef}
                          // src={meetingData?.steps[currentStepIndex]?.url}
                          src={getYoutubeEmbedUrl(
                            meetingData?.steps[currentStepIndex]?.url
                          )}
                          width="100%"
                          style={{ height: "100vh" }}
                          onLoad={() => setIFrameLoad(false)}
                        />
                        {iFrameLoad && <div className="loader"></div>}
                      </div>
                    ) : meetingData?.steps[currentStepIndex]?.editor_type ===
                      "Google Meet Link" ? (
                      <div className="iframe-container d-flex justify-content-center align-items-center vh-100 bg-white">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          aria-label="Google Meet"
                          role="img"
                          viewBox="0 0 512 512"
                          width="104px"
                          height="104px"
                          fill="#000000"
                        >
                          <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                          <g
                            id="SVGRepo_tracerCarrier"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          ></g>
                          <g id="SVGRepo_iconCarrier">
                            <rect
                              width="512"
                              height="512"
                              rx="15%"
                              fill="#ffffff"
                            ></rect>
                            <path d="M166 106v90h-90" fill="#ea4335"></path>
                            <path
                              d="M166 106v90h120v62l90-73v-49q0-30-30-30"
                              fill="#ffba00"
                            ></path>
                            <path
                              d="M164 406v-90h122v-60l90 71v49q0 30-30 30"
                              fill="#00ac47"
                            ></path>
                            <path d="M286 256l90-73v146" fill="#00832d"></path>
                            <path
                              d="M376 183l42-34c9-7 18-7 18 7v200c0 14-9 14-18 7l-42-34"
                              fill="#00ac47"
                            ></path>
                            <path
                              d="M76 314v62q0 30 30 30h60v-92"
                              fill="#0066da"
                            ></path>
                            <path d="M76 196h90v120h-90" fill="#2684fc"></path>
                          </g>
                        </svg>
                      </div>
                    ) : (
                      <div
                        className="rendered-content"
                        dangerouslySetInnerHTML={{
                          __html: sanitizedContent,
                        }}
                      />
                    ))}

                  {/* NOTES EDITOR */}
                  {notesEditor.showEditor && (
                    <>
                      {meetingData?.type === "Newsletter" ? (
                        <div style={{ height: "100vh" }}>
                          <div
                            key={emailCampaign}
                            className="h-100"
                            style={{
                              overflowY: "auto",
                              borderBottom: "1px solid #ccc",
                              padding: "10px",
                              borderRadius: "5px",
                            }}
                          >
                            <div className="row d-flex flex-column">
                              <div className="d-flex gap-3 fs-4">
                                <h6>Campaign Name: </h6>
                                <h6>{emailCampaign?.campaign_name}</h6>
                              </div>
                              <div className="d-flex ga-3">
                                <h6>Total Sendings: </h6>
                                <h6>{emailCampaign?.total_sendings}</h6>
                              </div>
                              <div className="d-flex ga-3">
                                <h6>Total Recipients: </h6>
                                <h6>{emailCampaign?.total_recipients}</h6>
                              </div>
                              <div className="d-flex ga-3">
                                <h6>Total Opens: </h6>
                                <h6>{emailCampaign?.total_opens}</h6>
                              </div>
                              <div className="d-flex ga-3">
                                <h6>Total clicks: </h6>
                                <h6>{emailCampaign?.total_clicks}</h6>
                              </div>
                              <div className="d-flex ga-3">
                                <h6>Total Unsubscribes: </h6>
                                <h6>{emailCampaign?.total_unsubscribes}</h6>
                              </div>
                            </div>
                          </div>
                        </div>
                      ) : (
                        <Editor
                          onBlur={(value) => {
                            console.log("value", value);
                          }}
                          key={activeStepIndex}
                          apiKey={TINYMCEAPI}
                          value={stepNotes[activeStepIndex]}
                          init={{
                            statusbar: false,
                            branding: false,
                            height: 900,
                            menubar: true,
                            language: "fr_FR",
                            // language: "en_EN",
                            plugins:
                              "print preview paste searchreplace autolink directionality visualblocks visualchars fullscreen template codesample table charmap hr pagebreak nonbreaking anchor toc insertdatetime advlist lists wordcount imagetools textpattern",
                            toolbar:
                              "formatselect | bold italic underline strikethrough | forecolor backcolor blockquote | alignleft aligncenter alignright alignjustify | numlist bullist outdent indent | removeformat",
                            image_advtab: true,
                            file_picker_types: "image",

                            file_picker_callback: function (
                              callback,
                              value,
                              meta
                            ) {
                              if (meta.filetype === "image") {
                                const input = document.createElement("input");
                                input.setAttribute("type", "file");
                                input.setAttribute("accept", "image/*");

                                input.onchange = function () {
                                  const file = input.files[0];
                                  const reader = new FileReader();

                                  reader.onload = function (e) {
                                    const img = new Image();
                                    img.src = e.target.result;

                                    img.onload = function () {
                                      const canvas =
                                        document.createElement("canvas");
                                      const ctx = canvas.getContext("2d");
                                      const maxWidth = 700;
                                      const maxHeight = 394;

                                      let newWidth = img.width;
                                      let newHeight = img.height;

                                      if (img.width > maxWidth) {
                                        newWidth = maxWidth;
                                        newHeight =
                                          (img.height * maxWidth) / img.width;
                                      }

                                      if (newHeight > maxHeight) {
                                        newHeight = maxHeight;
                                        newWidth =
                                          (img.width * maxHeight) / img.height;
                                      }

                                      canvas.width = newWidth;
                                      canvas.height = newHeight;

                                      ctx.drawImage(
                                        img,
                                        0,
                                        0,
                                        newWidth,
                                        newHeight
                                      );

                                      const resizedImageData = canvas.toDataURL(
                                        file.type
                                      );

                                      // Pass the resized image data to the callback function
                                      callback(resizedImageData, {
                                        alt: file.name,
                                      });
                                    };

                                    img.src = e.target.result;
                                  };

                                  reader.readAsDataURL(file);
                                };

                                input.click();
                              }
                            },
                          }}
                          // onEditorChange={(value) => {
                          //   setNotes(value);
                          // }}
                          onEditorChange={(value) => {
                            setStepNotes((prev) => {
                              let newStepNotes = [...prev];
                              newStepNotes[activeStepIndex] = value;
                              return newStepNotes;
                            });
                          }}
                        />
                      )}
                    </>
                  )}

                  {/* DECISION EDITOR */}
                  {decisionEditor.showEditor && (
                    <div className="col-md-12 mt-4">
                      <div className="decision-editor-container">
                        <div className="d-flex justify-content-between align-items-center mb-2">
                          <h5>{t("Decisions")}</h5>
                          <button
                            className="btn btn-primary"
                            style={{
                              backgroundColor: "rgb(0, 38, 177)",
                            }}
                            onClick={() => addDecisionForStep(activeStepIndex)}
                          >
                            + {t("presentation.Add Decision")}
                          </button>
                        </div>

                        <div className="decision-table-scroll">
                          <Table bordered className="action-table">
                            <thead>
                              <tr className="table-row">
                                <th className="table-row-head text-center">
                                  {t("presentation.Decision Type")}
                                </th>
                                <th className="table-row-head text-center">
                                  {t("presentation.Description")}
                                </th>
                                <th className="table-row-head text-center">
                                  {t("presentation.Value")}
                                </th>

                                <th className="table-row-head text-center">
                                  {t("presentation.Apply Decision To")}
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              {meetingData?.steps?.map(
                                (step, stepIndex) =>
                                  step?.decision && step.decision.length > 0
                                    ? step.decision.map((decision, index) => (
                                        <tr key={index} className="table-data">
                                          <td>{decision?.decision_type}</td>
                                          <td>{decision?.decision}</td>
                                          <td>
                                            {decision?.decision_type ===
                                            "Milestone"
                                              ? decision?.milestone_date
                                              : decision?.decision_type ===
                                                "Budget"
                                              ? `${decision?.budget_amount} ${
                                                  decision?.currency || ""
                                                }`
                                              : decision?.creation_date}
                                          </td>
                                          {/* <td>
                                            {decision?.budget_amount
                                              ? `$${Number(
                                                  decision.budget_amount
                                                ).toLocaleString()}`
                                              : "-"}
                                          </td> */}
                                          <td>{decision?.decision_apply}</td>
                                        </tr>
                                      ))
                                    : null // Do nothing if there are no decisions
                              )}
                            </tbody>
                          </Table>
                        </div>
                      </div>
                    </div>
                  )}

                  {fileEditor.showEditor && (
                    <>
                      {fileEditor.showEditor && (
                        <>
                          {!isModalOpen2 && (
                            <StepFile
                              isFileUploaded={isFileUploaded}
                              setIsFileUploaded={setIsFileUploaded}
                              openModal={openModal}
                              meeting={meetingFile}
                              inProgressFiles={true}
                            />
                          )}
                          {isModalOpen2 && (
                            <>
                              {/* Delete and Close Buttons */}
                              <div className="d-flex gap-2 justify-content-end align-items-center mt-2 mb-2">
                                <button
                                  onClick={closeModal}
                                  className="delete-file-modal-button2"
                                  style={{ zIndex: 9999 }}
                                >
                                  Close
                                </button>
                              </div>
                              <div
                                style={{
                                  // width: "100vw",
                                  height: "100vh",
                                  zIndex: 9999, // make sure it's above everything
                                  // overflowY: "auto",
                                  // padding: "1rem",
                                }}
                              >
                                {modalContent ? (
                                  <>
                                    <div
                                      style={{
                                        width: "100vw",
                                        height: "100vh",
                                        zIndex: 9999, // make sure it's above everything
                                        // overflowY: "auto",
                                        // padding: "1rem",
                                      }}
                                    >
                                      {/* Show PDF or Other File Types */}
                                      {modalContent?.file_type &&
                                      modalContent?.file_type.includes(
                                        "pdf"
                                      ) ? (
                                        <iframe
                                          title="File Preview"
                                          src={`${
                                            modalContent
                                              ? `${Assets_URL}/${modalContent?.file_path}`
                                              : ""
                                          }#toolbar=0&view=fitH`}
                                          className="fileuploadingiframe w-100"
                                          width="100%"
                                          style={{ height: "100vh" }}
                                        ></iframe>
                                      ) : modalContent?.file_type?.includes(
                                          "video"
                                        ) ? (
                                        <iframe
                                          title="File Preview"
                                          src={`${
                                            modalContent
                                              ? `${Assets_URL}/${modalContent?.file_path}`
                                              : ""
                                          }#toolbar=0&view=fitH`}
                                          //  className="fileuploadingiframe w-100"
                                          width="100%"
                                          style={{ height: "100vh" }}
                                        ></iframe>
                                      ) : null}

                                      {/* Show Excel Preview if the file is Excel */}
                                      {modalContent?.file_type ===
                                      "application/vnd.ms-excel" ? (
                                        <div className="table-responsive">
                                          {loading ? (
                                            <Spinner
                                              as="span"
                                              variant="light"
                                              size="sm"
                                              role="status"
                                              aria-hidden="true"
                                              animation="border"
                                            />
                                          ) : (
                                            <div
                                              className="table-responsive"
                                              style={{
                                                maxHeight: "80vh",
                                                overflowY: "auto",
                                              }}
                                            >
                                              <table className="table table-bordered">
                                                <thead>
                                                  <tr>
                                                    {Object.keys(
                                                      excelData[0] || {}
                                                    ).map((key, index) => (
                                                      <th key={index}>{key}</th>
                                                    ))}
                                                  </tr>
                                                </thead>
                                                <tbody>
                                                  {excelData.map(
                                                    (row, rowIndex) => (
                                                      <tr key={rowIndex}>
                                                        {Object.values(row).map(
                                                          (value, colIndex) => (
                                                            <td key={colIndex}>
                                                              {value}
                                                            </td>
                                                          )
                                                        )}
                                                      </tr>
                                                    )
                                                  )}
                                                </tbody>
                                              </table>
                                            </div>
                                          )}
                                        </div>
                                      ) : (modalContent &&
                                          modalContent?.file_type ===
                                            "application/vnd.openxmlformats-officedocument.wordprocessingml.document") ||
                                        modalContent?.file_type ===
                                          "text/plain" ||
                                        modalContent?.file_type ===
                                          "image/png" ||
                                        modalContent?.file_type ===
                                          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" ? (
                                        <div
                                          className="file-viewer-container"
                                          style={{ height: "100vh" }}
                                        >
                                          <DocViewer
                                            documents={[
                                              {
                                                uri: `${Assets_URL}/${modalContent?.file_path}`,
                                              },
                                            ]}
                                            pluginRenderers={DocViewerRenderers}
                                            config={{
                                              header: {
                                                disableFileName: true,
                                                retainURLParams: true,
                                              },
                                            }}
                                          />
                                          {/* <iframe
  title="DOCX Preview"
  src={`https://docs.google.com/gview?url=${Assets_URL}/${modalContent?.file_path}&embedded=true`}
  style={{ width: "100%", height: "100vh" }}
  frameBorder="0"
/> */}
                                        </div>
                                      ) : null}
                                    </div>
                                  </>
                                ) : (
                                  <p>No content to display.</p>
                                )}
                              </div>
                            </>
                          )}
                        </>
                      )}
                    </>
                  )}

                  {!notesEditor.showEditor &&
                    !decisionEditor.showEditor &&
                    !showStepContentEditor &&
                    planDActionEditor.showEditor && (
                      <div className="col-md-12 mt-4">
                        <div className="decision-editor-container">
                          <div className="d-flex justify-content-between align-items-center mb-2">
                            <h5>{t("presentation.strategies")}</h5>
                            <button
                              className="btn btn-primary"
                              style={{
                                backgroundColor: "rgb(0, 38, 177)",
                              }}
                              onClick={() => handleButtonClick()}
                            >
                              + {t("presentation.Add Strategy")}
                            </button>
                          </div>

                          <div className="decision-table-scroll">
                            <Table bordered className="action-table">
                              <thead>
                                <tr className="table-row">
                                  <th className="table-row-head text-center">
                                    {t("order")}
                                  </th>
                                  <th
                                    className="table-row-head text-center"
                                    style={{
                                      paddingLeft: "38px",
                                    }}
                                  >
                                    {t("tasks")}
                                  </th>
                                  <th className="table-row-head text-center">
                                    {t("duration")}
                                  </th>
                                  <th className="table-row-head text-center">
                                    {t("participant")}
                                  </th>
                                  <th className="table-row-head text-center">
                                    {t("Actions")}
                                  </th>
                                </tr>
                              </thead>
                              <tbody>
                                {meetingData?.plan_d_actions &&
                                  meetingData?.plan_d_actions
                                    .reduce((acc, item) => {
                                      const exists = acc.find(
                                        (obj) =>
                                          obj.action === item.action &&
                                          obj.order === item.order &&
                                          obj.action_days === item.action_days
                                      );
                                      if (!exists) acc.push(item);
                                      return acc;
                                    }, [])
                                    ?.map((user, index) => (
                                      <tr className="table-data" key={user?.id}>
                                        <td
                                          style={
                                            {
                                              // width: "70%",
                                              // paddingLeft: "28px",
                                            }
                                          }
                                          className="table-data-row"
                                        >
                                          {user?.order}
                                        </td>
                                        <td
                                          style={{
                                            width: "50%",
                                            paddingLeft: "28px",
                                          }}
                                          className="table-data-row"
                                        >
                                          {user?.action}
                                        </td>
                                        <td className="text-center table-data-row ">
                                          <span className="duree">
                                            {
                                              String(user?.action_days).split(
                                                "."
                                              )[0]
                                            }
                                          </span>
                                        </td>
                                        <td className="text-center table-data-row">
                                          <Tooltip
                                            title={user?.participant_full_name}
                                            placement="top"
                                          >
                                            <Avatar
                                              src={
                                                user?.participant_image?.includes(
                                                  "users"
                                                )
                                                  ? Assets_URL +
                                                    "/" +
                                                    user?.participant_image
                                                  : user?.participant_image
                                              }
                                            />
                                          </Tooltip>
                                        </td>
                                        <td className="text-center table-data-row">
                                          <button
                                            className="btn-sm btn-outline-primary p-0"
                                            onClick={() =>
                                              handleEditStrategy(user)
                                            }
                                            style={{
                                              border: 0,
                                              background: "white",
                                              margin: "4px",
                                            }}
                                          >
                                            ✏️
                                          </button>
                                          <button
                                            className="btn-sm btn-outline-danger p-0"
                                            onClick={() =>
                                              handleDeleteStrategy(user)
                                            }
                                            style={{
                                              border: 0,
                                              background: "white",
                                              margin: "4px",
                                            }}
                                          >
                                            🗑️
                                          </button>
                                        </td>
                                      </tr>
                                    ))}
                              </tbody>
                            </Table>
                          </div>
                        </div>
                      </div>
                    )}
                  {
                    // STEP EDITORRRR
                    !notesEditor.showEditor &&
                    !decisionEditor.showEditor &&
                    !planDActionEditor.showEditor &&
                    showStepContentEditor ? (
                      <div>
                        {/* FILE UPLOADDD */}
                        <section>
                          <ShowIF
                            condition={
                              meetingData?.steps[currentStepIndex]
                                .editor_type === "File" ||
                              meetingData?.steps[currentStepIndex]
                                .editor_type === "Video" ||
                              meetingData?.steps[currentStepIndex]
                                .editor_type === "Photo"
                            }
                          >
                            <label>
                              {meetingData?.steps[currentStepIndex].file}
                            </label>
                            <input
                              type="file"
                              multiple="false"
                              // value={meetingData?.steps[currentStepIndex].file}
                              onChange={async (e) => {
                                const file = e.target.files[0];
                                let allowedFileTypes = [];
                                // Determine allowed file types based on modalType
                                if (
                                  meetingData?.steps[currentStepIndex]
                                    .editor_type === "File"
                                ) {
                                  allowedFileTypes = [
                                    "application/pdf",
                                    "application/vnd.ms-excel",
                                    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                                    "application/vnd.ms-powerpoint",
                                    "application/vnd.openxmlformats-officedocument.presentationml.presentation",
                                    "application/msword",
                                    "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
                                  ];
                                } else if (
                                  meetingData?.steps[currentStepIndex]
                                    .editor_type === "Video"
                                ) {
                                  allowedFileTypes = [
                                    "video/mp4",
                                    "video/x-msvideo",
                                    "video/x-matroska",
                                    "video/mpeg",
                                    "video/quicktime",
                                  ];
                                } else if (
                                  meetingData?.steps[currentStepIndex]
                                    .editor_type === "Photo"
                                ) {
                                  allowedFileTypes = [
                                    "image/jpeg",
                                    "image/png",
                                    "image/gif",
                                    "image/bmp",
                                    "image/webp",
                                    // Add other image MIME types if needed
                                  ];
                                } else if (
                                  meetingData?.steps[currentStepIndex]
                                    .editor_type === "Excel"
                                ) {
                                  allowedFileTypes = [
                                    "application/vnd.ms-excel",
                                    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                                  ];
                                }

                                // const allowedFileTypes = [
                                //   "application/pdf",
                                //   "application/vnd.ms-excel",
                                //   "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                                //   "application/vnd.ms-powerpoint",
                                //   "application/vnd.openxmlformats-officedocument.presentationml.presentation",
                                //   "application/msword",
                                //   "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
                                // ];
                                if (
                                  !file ||
                                  !allowedFileTypes.includes(file.type)
                                ) {
                                  alert("Please select a valid file type");
                                }
                                // PREPARE THE PAYLOAD
                                const updatedSteps = [
                                  ...(meetingData?.steps || []),
                                ];
                                const selectedStep =
                                  updatedSteps[currentStepIndex];
                                const filePayload = {
                                  ...selectedStep,
                                  title: selectedStep.title,
                                  count1: selectedStep.count1,
                                  count2: selectedStep.count2,
                                  time: selectedStep.count2,
                                  editor_type: selectedStep.editor_type,
                                  file: file,
                                  editor_content: null,
                                  _method: "put",
                                };
                                // SEND THE FILE TO THE SERVER
                                try {
                                  const response = await axios.post(
                                    `${API_BASE_URL}/steps/${selectedStep?.id}`,
                                    filePayload,
                                    {
                                      headers: {
                                        "Content-Type": "multipart/form-data",
                                        Authorization: `Bearer ${sessionStorage.getItem(
                                          "token"
                                        )}`,
                                      },
                                    }
                                  );

                                  if (response.status === 200) {
                                    // Update the file in the state
                                    const updatedSteps = [
                                      ...(meetingData?.steps || []),
                                    ];
                                    const selectedStep =
                                      updatedSteps[currentStepIndex];
                                    selectedStep.file = response.data.data.file;
                                    setMeetingData({
                                      ...meetingData,
                                      steps: updatedSteps,
                                    });
                                  }
                                } catch (error) {
                                  console.log(
                                    "error while uploading file",
                                    error
                                  );
                                }
                              }}
                            />
                          </ShowIF>
                        </section>

                        <ShowIF
                          condition={
                            meetingData?.steps[currentStepIndex].editor_type ===
                            "Excel"
                          }
                        >
                          <label>
                            {meetingData?.steps[currentStepIndex].file}
                          </label>
                          <input
                            type="file"
                            multiple="false"
                            // value={meetingData?.steps[currentStepIndex].file}
                            onChange={async (e) => {
                              const file = e.target.files[0];
                              let allowedFileTypes = [];
                              // Determine allowed file types based on modalType
                              if (
                                meetingData?.steps[currentStepIndex]
                                  .editor_type === "Excel"
                              ) {
                                allowedFileTypes = [
                                  "application/vnd.ms-excel",
                                  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                                ];
                              }

                              if (
                                !file ||
                                !allowedFileTypes.includes(file.type)
                              ) {
                                alert("Please select a valid file type");
                              }
                              // PREPARE THE PAYLOAD
                              const updatedSteps = [
                                ...(meetingData?.steps || []),
                              ];
                              const selectedStep =
                                updatedSteps[currentStepIndex];
                              const filePayload = {
                                ...selectedStep,
                                title: selectedStep.title,
                                count1: selectedStep.count1,
                                count2: selectedStep.count2,
                                time: selectedStep.count2,
                                editor_type: selectedStep.editor_type,
                                file: file,
                                editor_content: null,
                                _method: "put",
                              };
                              // SEND THE FILE TO THE SERVER
                              try {
                                const response = await axios.post(
                                  `${API_BASE_URL}/steps/${selectedStep?.id}`,
                                  filePayload,
                                  {
                                    headers: {
                                      "Content-Type": "multipart/form-data",
                                      Authorization: `Bearer ${sessionStorage.getItem(
                                        "token"
                                      )}`,
                                    },
                                  }
                                );

                                if (response.status === 200) {
                                  // Update the file in the state
                                  const updatedSteps = [
                                    ...(meetingData?.steps || []),
                                  ];
                                  const selectedStep =
                                    updatedSteps[currentStepIndex];
                                  selectedStep.file = response.data.data.file;
                                  setMeetingData({
                                    ...meetingData,
                                    steps: updatedSteps,
                                  });
                                }
                              } catch (error) {
                                console.log(
                                  "error while uploading file",
                                  error
                                );
                              }
                            }}
                          />
                        </ShowIF>
                        <ShowIF
                          condition={
                            meetingData?.steps[currentStepIndex].editor_type ===
                            "Editeur"
                          }
                        >
                          <Editor
                            onBlur={(value) => {
                              console.log("value", value);
                            }}
                            key={activeStepIndex}
                            apiKey={TINYMCEAPI}
                            value={
                              meetingData?.steps[activeStepIndex]
                                ?.editor_content
                            }
                            // style={{height:'100vh'}}

                            init={{
                              statusbar: false,
                              branding: false,
                              menubar: true,
                              height: 900,
                              language: "fr_FR",
                              // language: "en_EN",
                              plugins:
                                "print preview paste searchreplace image autolink directionality visualblocks visualchars fullscreen  link media template codesample table charmap hr pagebreak nonbreaking anchor toc insertdatetime advlist lists wordcount imagetools textpattern",
                              toolbar:
                                "formatselect | bold italic underline strikethrough | forecolor backcolor blockquote | image | imagePicker link media | alignleft aligncenter alignright alignjustify | numlist bullist outdent indent | removeformat",
                              // image_advtab: true,
                              file_picker_types: "image",
                              images_upload_handler:
                                image_upload_handler_callback,
                            }}
                            // onEditorChange={(content) => {
                            //   setMeetingData((prevData) => ({
                            //     ...prevData,
                            //     steps: prevData.steps.map(
                            //       (step, index) => {
                            //         if (index === activeStepIndex) {
                            //           return {
                            //             ...step,
                            //             editor_content: content,
                            //           };
                            //         }
                            //         return step;
                            //       }
                            //     ),
                            //   }));
                            // }}
                            onEditorChange={(content) => {
                              const sanitizedContent =
                                sanitizeIframeContent(content);
                              setMeetingData((prevData) => ({
                                ...prevData,
                                steps: prevData.steps.map((step, index) => {
                                  if (index === activeStepIndex) {
                                    return {
                                      ...step,
                                      editor_content: sanitizedContent,
                                    };
                                  }
                                  return step;
                                }),
                              }));
                            }}
                            onInit={(evt, editor) => {
                              editorRef.current = editor;
                            }}
                            onNodeChange={(e) => {
                              if (
                                e &&
                                e.element.nodeName.toLowerCase() == "img"
                              ) {
                                editorRef.current.dom.setAttribs(e.element, {
                                  width: "700px",
                                  height: "394px",
                                });
                              }
                            }}
                          />
                        </ShowIF>
                        <ShowIF
                          condition={
                            meetingData?.steps[currentStepIndex].editor_type ===
                            "Subtask"
                          }
                        >
                          <Editor
                            onBlur={(value) => {
                              console.log("value", value);
                            }}
                            key={activeStepIndex}
                            apiKey={TINYMCEAPI}
                            value={
                              meetingData?.steps[activeStepIndex]
                                ?.editor_content
                            }
                            // style={{height:'100vh'}}

                            init={{
                              statusbar: false,
                              branding: false,
                              menubar: true,
                              height: 900,
                              language: "fr_FR",
                              // language: "en_EN",
                              plugins:
                                "print preview paste searchreplace image autolink directionality visualblocks visualchars fullscreen  link media template codesample table charmap hr pagebreak nonbreaking anchor toc insertdatetime advlist lists wordcount imagetools textpattern",
                              toolbar:
                                "formatselect | bold italic underline strikethrough | forecolor backcolor blockquote | image | imagePicker link media | alignleft aligncenter alignright alignjustify | numlist bullist outdent indent | removeformat",
                              // image_advtab: true,
                              file_picker_types: "image",
                              images_upload_handler:
                                image_upload_handler_callback,
                            }}
                            // onEditorChange={(content) => {
                            //   setMeetingData((prevData) => ({
                            //     ...prevData,
                            //     steps: prevData.steps.map(
                            //       (step, index) => {
                            //         if (index === activeStepIndex) {
                            //           return {
                            //             ...step,
                            //             editor_content: content,
                            //           };
                            //         }
                            //         return step;
                            //       }
                            //     ),
                            //   }));
                            // }}
                            onEditorChange={(content) => {
                              const sanitizedContent =
                                sanitizeIframeContent(content);
                              setMeetingData((prevData) => ({
                                ...prevData,
                                steps: prevData.steps.map((step, index) => {
                                  if (index === activeStepIndex) {
                                    return {
                                      ...step,
                                      editor_content: sanitizedContent,
                                    };
                                  }
                                  return step;
                                }),
                              }));
                            }}
                            onInit={(evt, editor) => {
                              editorRef.current = editor;
                            }}
                            onNodeChange={(e) => {
                              if (
                                e &&
                                e.element.nodeName.toLowerCase() == "img"
                              ) {
                                editorRef.current.dom.setAttribs(e.element, {
                                  width: "700px",
                                  height: "394px",
                                });
                              }
                            }}
                          />
                        </ShowIF>
                        <ShowIF
                          condition={
                            meetingData?.steps[currentStepIndex].editor_type ===
                            "Email"
                          }
                        >
                          <Editor
                            onBlur={(value) => {
                              console.log("value", value);
                            }}
                            key={activeStepIndex}
                            apiKey={TINYMCEAPI}
                            value={
                              meetingData?.steps[activeStepIndex]
                                ?.editor_content
                            }
                            init={{
                              statusbar: false,
                              branding: false,
                              menubar: true,
                              language: "fr_FR",
                              height: 900,

                              // language: "en_EN",
                              plugins:
                                "print preview paste searchreplace image autolink directionality visualblocks visualchars fullscreen  link media template codesample table charmap hr pagebreak nonbreaking anchor toc insertdatetime advlist lists wordcount imagetools textpattern",
                              toolbar:
                                "formatselect | bold italic underline strikethrough | forecolor backcolor blockquote | image | imagePicker link media | alignleft aligncenter alignright alignjustify | numlist bullist outdent indent | removeformat",
                              // image_advtab: true,
                              file_picker_types: "image",
                              images_upload_handler:
                                image_upload_handler_callback,
                            }}
                            onEditorChange={(content) => {
                              setMeetingData((prevData) => ({
                                ...prevData,
                                steps: prevData.steps.map((step, index) => {
                                  if (index === activeStepIndex) {
                                    return {
                                      ...step,
                                      editor_content: content,
                                    };
                                  }
                                  return step;
                                }),
                              }));
                            }}
                            onInit={(evt, editor) => {
                              editorRef.current = editor;
                            }}
                            onNodeChange={(e) => {
                              if (
                                e &&
                                e.element.nodeName.toLowerCase() == "img"
                              ) {
                                editorRef.current.dom.setAttribs(e.element, {
                                  width: "700px",
                                  height: "394px",
                                });
                              }
                            }}
                          />
                        </ShowIF>
                        <ShowIF
                          condition={
                            meetingData?.steps[currentStepIndex].editor_type ===
                            "Url"
                          }
                        >
                          <label>
                            {meetingData?.steps[currentStepIndex]?.Url}
                          </label>
                          <input
                            type="text"
                            // placeholder="https://www.google.com"
                            value={meetingData?.steps[currentStepIndex]?.url}
                            // onChange={handleLinkUpload}
                            onChange={(e) => {
                              setMeetingData((prevData) => ({
                                ...prevData,
                                steps: prevData.steps.map((step, index) => {
                                  if (index === activeStepIndex) {
                                    return {
                                      ...step,
                                      url: e.target.value,
                                    };
                                  }
                                  return step;
                                }),
                              }));
                            }}
                            name="url"
                            style={{ width: "50%" }}
                          />
                        </ShowIF>
                      </div>
                    ) : null
                  }
                </div>
              </div>
            )}
          </div>
        </div>
      )}

      {showTimerModal && (
        <ConfirmationModal
          message={t(
            "presentation.are you sure you want to close this meeting?"
          )}
          onCancel={() => setShowTimerModal(false)}
          onConfirm={() => (isAutomatic ? closeEarly() : closeEarlyMeeting())}
        />
      )}

      {/* {showProgressBar && (
        <div className="progress-overlay">
          <div style={{ width: "50%" }}>
            <ProgressBar now={progress} animated />
            <h5 className="text-center my-3">{t("progressBarText")}</h5>
            <p
              style={{
                marginTop: "20px",
                textAlign: "center",
              }}
            >
              {t("Saving Audio Report...Don't close this window")},
              <a
                href="#"
                onClick={(e) => {
                  e.preventDefault(); // Prevent the default anchor behavior
                  window.open(
                    `https://tektime.io/meeting`,

                    "_blank"
                  ); // Open the current URL in a new tab
                }}
                style={{
                  marginLeft: "5px",
                  color: "#1890ff",
                  textDecoration: "underline",
                }}
              >
                {t("Click here to view the application in another window")}
              </a>
            </p>
          </div>
        </div>
      )} */}

      {showNewDecisionModal && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            height: "100vh",
            width: "100vw",
            backgroundColor: "#fff",
            zIndex: 1000,
            display: "flex",
            flexDirection: "column",
            overflowY: "auto",
          }}
          className="tektime"
        >
          <div
            className="d-flex align-items-center"
            style={{ width: "100%", padding: "1px" }}
          >
            {/* Left section - Empty */}
            <div style={{ flex: 1, textAlign: "start" }}></div>

            {/* Center section - Title */}
            <div style={{ flex: 1, textAlign: "center" }}>
              <Tooltip
                title={
                  meetingData?.steps[currentStepIndex]?.order_no +
                  ".\u00A0" +
                  meetingData?.steps[currentStepIndex]?.title
                }
              >
                <h4
                  style={{
                    overflow: "hidden",
                    // textOverflow: "ellipsis",
                    // display: "inline-block",
                    // maxWidth: "100%",
                    // verticalAlign: "bottom",
                    margin: 0, // optional: remove extra spacing
                  }}
                  className="truncated-text"
                >
                  {meetingData?.steps[currentStepIndex]?.order_no}. &nbsp;
                  {meetingData?.steps[currentStepIndex]?.title}
                </h4>
              </Tooltip>
            </div>

            {/* Right section - Button */}
            <div
              style={{
                flex: 1,
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                marginTop: "8px",
              }}
            >
              {/* Action buttons */}
            </div>
          </div>
          {/* Top Row */}
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              flexWrap: "wrap",
              marginBottom: "170px",
              maxHeight: "100px",
            }}
          ></div>

          <div
            style={{
              // maxHeight: "530px",
              overflowY: "auto",
              padding: "20px",
              borderRadius: "10px",
              backgroundColor: "#fff",
              boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
              height: "100vh",
            }}
          >
            {/* Header */}
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                marginBottom: "20px",
              }}
            >
              <h3 style={{ margin: 0 }}>📝 {t("presentation.New Decision")}</h3>

              <button
                onClick={closeDecisionModal}
                style={{
                  backgroundColor: "red",
                  color: "#fff",
                  border: "none",
                  padding: "6px 12px",
                  borderRadius: "5px",
                  cursor: "pointer",
                }}
              >
                x {t("presentation.close")}
              </button>
            </div>
            {/* Scrollable Content */}
            <div
              style={{
                flex: 1,
                overflowY: "auto",
                padding: "20px",
              }}
            >
              {/* Decision Type */}
              <label
                style={{
                  fontWeight: "500",
                  marginBottom: "6px",
                  display: "block",
                }}
              >
                {t("presentation.Decision Type")}
              </label>
              <Select
                options={[
                  { value: "Budget", label: "Budget" },
                  { value: "Milestone", label: t("Milestone") },
                  { value: "Rule", label: t("Rule") },
                ]}
                onChange={(selectedOption) =>
                  handleSelectChange(
                    selectedOption,
                    "decision_type",
                    currentDecisionIndex
                  )
                }
                styles={{
                  container: (base) => ({ ...base, marginBottom: "15px" }),
                }}
              />

              {/* Conditional Inputs */}
              {decision[activeStepIndex]?.[currentDecisionIndex]
                ?.decision_type === "Milestone" && (
                <>
                  <label
                    style={{
                      fontWeight: "500",
                      display: "block",
                      marginBottom: "6px",
                    }}
                  >
                    {t("presentation.Milestone Date")}
                  </label>
                  <input
                    type="date"
                    value={
                      decision[activeStepIndex]?.[currentDecisionIndex]
                        ?.milestone_date || ""
                    }
                    onChange={(event) =>
                      handleSelectChange(
                        { value: event.target.value },
                        "milestone_date",
                        currentDecisionIndex
                      )
                    }
                    style={{
                      width: "100%",
                      padding: "10px",
                      borderRadius: "5px",
                      border: "1px solid #ccc",
                      marginBottom: "15px",
                    }}
                  />
                </>
              )}

              {decision[activeStepIndex]?.[currentDecisionIndex]
                ?.decision_type === "Budget" && (
                <>
                  <label
                    style={{
                      fontWeight: "500",
                      display: "block",
                      marginBottom: "6px",
                    }}
                  >
                    {t("presentation.Budget Amount")}
                  </label>

                  {/* Input Group for Budget Amount + Currency */}
                  <div
                    style={{
                      display: "flex",
                      gap: "10px",
                      marginBottom: "15px",
                    }}
                  >
                    <input
                      type="number"
                      value={
                        decision[activeStepIndex]?.[currentDecisionIndex]
                          ?.budget_amount || ""
                      }
                      onChange={(event) =>
                        handleSelectChange(
                          { value: event.target.value },
                          "budget_amount",
                          currentDecisionIndex
                        )
                      }
                      style={{
                        flex: 2,
                        padding: "10px",
                        borderRadius: "5px",
                        border: "1px solid #ccc",
                      }}
                    />

                    <select
                      value={
                        decision[activeStepIndex]?.[currentDecisionIndex]
                          ?.currency || ""
                      }
                      onChange={(event) =>
                        handleSelectChange(
                          { value: event.target.value },
                          "currency",
                          currentDecisionIndex
                        )
                      }
                      style={{
                        flex: 1,
                        padding: "10px",
                        borderRadius: "5px",
                        border: "1px solid #ccc",
                      }}
                    >
                      <option value="" disabled>
                        {t("presentation.Select Currency")}
                      </option>
                      <option value="USD">USD</option>
                      <option value="EUR">EUR</option>
                      <option value="GBP">GBP</option>
                      <option value="JPY">JPY</option>
                      <option value="INR">INR</option>
                    </select>
                  </div>
                </>
              )}

              {/* Decision Text */}
              <label
                style={{
                  fontWeight: "500",
                  display: "block",
                  marginBottom: "6px",
                }}
              >
                {t("presentation.Description")}
              </label>
              <textarea
                rows="4"
                value={
                  decision[activeStepIndex]?.[currentDecisionIndex]?.decision ||
                  ""
                }
                onChange={(e) => handleTextChange(e, currentDecisionIndex)}
                style={{
                  width: "100%",
                  padding: "10px",
                  borderRadius: "5px",
                  border: "1px solid #ccc",
                  resize: "vertical",
                  marginBottom: "15px",
                }}
              />

              {/* Apply Decision */}
              <label
                style={{
                  fontWeight: "500",
                  display: "block",
                  marginBottom: "6px",
                }}
              >
                {t("presentation.Apply Decision To")}
              </label>
              <Select
                options={combinedOptions}
                value={
                  decision[activeStepIndex]?.[currentDecisionIndex]
                    ?.decision_apply
                    ? {
                        value:
                          decision[activeStepIndex][currentDecisionIndex]
                            .decision_apply,
                        label:
                          decision[activeStepIndex][currentDecisionIndex]
                            .decision_apply,
                      }
                    : null
                }
                onChange={(selectedOption) =>
                  handleSelectChange(
                    selectedOption,
                    "decision_apply",
                    currentDecisionIndex
                  )
                }
                styles={{
                  container: (provided) => ({
                    ...provided,
                    marginBottom: "20px",
                    zIndex: 10,
                  }),
                  menu: (provided) => ({
                    ...provided,
                    zIndex: 9999,
                  }),
                }}
              />

              {/* Save Button */}
              <button
                onClick={saveNewDecision}
                style={{
                  backgroundColor: "rgb(0, 38, 177)",
                  color: "#fff",
                  padding: "10px 20px",
                  borderRadius: "6px",
                  border: "none",
                  fontWeight: "600",
                  fontSize: "16px",
                  cursor: "pointer",
                  width: "100%",
                }}
                disabled={saveDecision}
              >
                💾 {t("presentation.Save Decision")}
              </button>
            </div>
          </div>
        </div>
      )}

      {showStrategyModal && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            height: "100vh",
            width: "100vw",
            backgroundColor: "#fff",
            zIndex: 1000,
            display: "flex",
            flexDirection: "column",
            overflowY: "auto",
          }}
          className="tektime"
        >
          <div
            className="d-flex align-items-center"
            style={{ width: "100%", padding: "1px" }}
          >
            {/* Left section - Empty */}
            <div style={{ flex: 1, textAlign: "start" }}></div>

            {/* Center section - Title */}
            <div style={{ flex: 1, textAlign: "center" }}>
              <Tooltip
                title={
                  meetingData?.steps[currentStepIndex]?.order_no +
                  ".\u00A0" +
                  meetingData?.steps[currentStepIndex]?.title
                }
              >
                <h4
                  style={{
                    overflow: "hidden",
                    // textOverflow: "ellipsis",
                    // display: "inline-block",
                    // maxWidth: "100%",
                    // verticalAlign: "bottom",
                    margin: 0, // optional: remove extra spacing
                  }}
                  className="truncated-text"
                >
                  {meetingData?.steps[currentStepIndex]?.order_no}. &nbsp;
                  {meetingData?.steps[currentStepIndex]?.title}
                </h4>
              </Tooltip>
            </div>

            {/* Right section - Button */}
            <div
              style={{
                flex: 1,
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                marginTop: "8px",
              }}
            >
              {/* Action buttons */}
            </div>
          </div>
          {/* Top Row */}
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              flexWrap: "wrap",
              marginBottom: "170px",
              maxHeight: "100px",
            }}
          ></div>

          <div
            style={{
              // maxHeight: "530px",
              overflowY: "auto",
              padding: "20px",
              borderRadius: "10px",
              backgroundColor: "#fff",
              boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
              height: "100vh",
            }}
          >
            {/* Header */}
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                marginBottom: "20px",
              }}
            >
              <h3 style={{ margin: 0 }}>
                {editingStrategy
                  ? "✏️ " + t("presentation.Update Strategy")
                  : "📝 " + t("presentation.New Strategy")}
              </h3>

              <button
                onClick={handleButtonClose}
                style={{
                  backgroundColor: "red",
                  color: "#fff",
                  border: "none",
                  padding: "6px 12px",
                  borderRadius: "5px",
                  cursor: "pointer",
                }}
              >
                x {t("presentation.close")}
              </button>
            </div>
            {/* Scrollable Content */}
            <div
              style={{
                flex: 1,
                // overflowY: "auto",
                padding: "20px",
                height: "100vh",
              }}
            >
              <section
                className="row py-1"
                // style={{ height: "600px" }}
              >
                <div className="col-md-12 mb-2">
                  {/* Plan of Action */}
                  <div
                    className="card card2 p-3 table-container"
                    // style={{ height: "600px" }}
                  >
                    <div
                      className="cardbody"
                      style={{
                        height: "auto",
                        // overflow:"hidden"
                        // minHeight: "80vh",
                      }}
                    >
                      <div className=" row subtitle  text-body-secondary">
                        <div className="col-md-2">
                          <span>{t("presentation.order")}</span>
                        </div>
                        <div className=" col-md-3 ">
                          <span>{t("presentation.action")}</span>
                        </div>
                        <div className="col-md-3">
                          <span>{t("presentation.carrier")}</span>
                        </div>
                        <div className="col-md-3">
                          <span>{t("presentation.dueDate")}</span>
                        </div>
                        <div className="col-md-1">
                          <span></span>
                        </div>
                      </div>

                      {tableData?.map((rowData, index) => {
                        if (
                          rowData.step_id !==
                          meetingData?.steps[currentStepIndex].id
                        ) {
                          return;
                        }
                        return (
                          <div
                            className="row p-2 text-body-dark mt-3 "
                            style={{
                              borderBottom: "1px solid #ccc",
                            }}
                            key={index}
                          >
                            <div className="col-md-2">
                              <select
                                className="form-select form-select-sm"
                                value={rowData.order}
                                onChange={(e) => {
                                  handleTableDataChange(e, index);
                                }}
                                name="order"
                              >
                                {Array.from({
                                  length: 11,
                                }).map((_, i) => (
                                  <option key={i} value={i + 1}>
                                    {i + 1}
                                  </option>
                                ))}
                              </select>
                            </div>

                            <div className="col-md-3">
                              <textarea
                                name="action"
                                value={rowData.action}
                                onChange={(e) => {
                                  handleTableDataChange(e, index);
                                }}
                                placeholder="Action"
                                rows={3}
                                // maxLength={100}
                                className="wrapped-textarea txt"
                              />
                            </div>

                            <div className="col-md-3">
                              {meetingData?.type === "Newsletter" ? (
                                <>
                                  <select
                                    className="form-select form-select-sm"
                                    // value={rowData.participant_id || ""}
                                    value={rowData.participant_id}
                                    name="participant_id"
                                    onChange={(e) =>
                                      handleTableDataChange(e, index)
                                    }
                                  >
                                    <option value="" disabled>
                                      {t("Select Participant")}
                                    </option>

                                    {meetingData?.participants &&
                                      meetingData?.participants?.length < 1 && (
                                        <option value="">
                                          {t(
                                            "presentation.No Participants Added"
                                          )}{" "}
                                        </option>
                                      )}
                                    {meetingData &&
                                      meetingData?.participants
                                        ?.filter(
                                          (participant, index, self) =>
                                            index ===
                                            self.findIndex(
                                              (p) =>
                                                p.email === participant.email
                                            )
                                        )
                                        ?.map((item) => {
                                          return (
                                            <option
                                              key={item.id}
                                              value={item.id}
                                            >
                                              {item.first_name} {item.last_name}
                                            </option>
                                          );
                                        })}
                                  </select>
                                </>
                              ) : (
                                <select
                                  className="form-select form-select-sm"
                                  // value={rowData.participant_id || ""}
                                  value={rowData.participant_id}
                                  name="participant_id"
                                  onChange={(e) =>
                                    handleTableDataChange(e, index)
                                  }
                                >
                                  <option value="" disabled>
                                    {t("Select Participant")}
                                  </option>

                                  {meetingData?.participants &&
                                    meetingData?.participants?.length < 1 && (
                                      <option value="">
                                        {t(
                                          "presentation.No Participants Added"
                                        )}{" "}
                                      </option>
                                    )}
                                  {meetingData &&
                                    meetingData?.participants
                                      ?.filter(
                                        (participant, index, self) =>
                                          index ===
                                          self.findIndex(
                                            (p) => p.email === participant.email
                                          )
                                      )
                                      ?.map((item) => {
                                        return (
                                          <option key={item.id} value={item.id}>
                                            {item.first_name} {item.last_name}
                                          </option>
                                        );
                                      })}
                                </select>
                              )}
                            </div>

                            <div className="col-md-3">
                              <div>
                                <img
                                  src="/Assets/minus1.svg"
                                  alt="minus"
                                  className="img-fluid "
                                  width={"15px"}
                                  style={{
                                    cursor: "pointer",
                                  }}
                                  onClick={() => handleDecrementCount(index)}
                                />{" "}
                                &nbsp; &nbsp;
                                <span>
                                  {parseInt(rowData.action_days)} {t("Day")}
                                </span>
                                &nbsp;&nbsp;
                                <img
                                  src="/Assets/plus1.svg"
                                  alt="plus"
                                  className="img-fluid"
                                  width={"15px"}
                                  style={{
                                    cursor: "pointer",
                                  }}
                                  onClick={() => handleIncrementCount(index)}
                                />
                              </div>
                            </div>

                            <div className="col-md-1">
                              <button
                                className="btndel"
                                onClick={() => handleButtonDelete(index)}
                              >
                                <AiFillDelete size={"25px"} color="red" />
                              </button>
                            </div>
                          </div>
                        );
                      })}

                      {/* <div className="d-flex justify-content-center mt-3 gap-2">
                                  <div>
                                    <GoPlusCircle
                                      size="30px"
                                      onClick={handleButtonClick}
                                    />
                                  </div>
                                </div> */}
                      <button
                        onClick={saveNewStrategy}
                        style={{
                          backgroundColor: "rgb(0, 38, 177)",
                          color: "#fff",
                          padding: "10px 20px",
                          borderRadius: "6px",
                          border: "none",
                          fontWeight: "600",
                          fontSize: "16px",
                          cursor: "pointer",
                          width: "100%",
                        }}
                        // disabled={saveStrategy}
                      >
                        💾 {t("presentation.Save Strategy")}
                      </button>
                    </div>
                  </div>
                </div>
              </section>
            </div>
          </div>
        </div>
      )}

      {/* Confirmation Popup before recording */}
      {showConfirmationPopup && (
        <Modal show={showConfirmationPopup} centered backdrop="static">
          <Modal.Header>
            <Modal.Title>{t("note_confirmation_title")}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <p
              dangerouslySetInnerHTML={{
                __html: t("note_confirmation_content"),
              }}
            />
          </Modal.Body>
          <Modal.Footer>
            {/* <Button variant="secondary" onClick={onClose}>
                 Cancel
               </Button> */}
            <button  className="btn"
                                    style={{
                                      backgroundColor: "#0026b1",
                                      color: "#fff",
                                      border: "none",
                                      padding: "9px 26px",
                                      fontSize: "16px",
                                      cursor: "pointer",
                                      borderRadius: "5px",
                                      transition: "background-color 0.3s",
                                      display: "flex",
                                      alignItems: "center",
                                    }} onClick={initiateRecording}>
              {t("meeting.formState.Save and Continue")}
            </button>
          </Modal.Footer>
        </Modal>
      )}

      <RecordingErrorModal
        show={showErrorModal}
        message={errorMessage}
        onRetry={handleRetry}
        onClose={() => setShowErrorModal(false)}
      />
    </>
  );
};

export default InProgress;
